import React from 'react';
import './Accounts.css';

function Accounts() {
  return (
    <div className="page-accounts">
      <div
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        <>
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            id="svg542025065_547"
          >
            <g opacity="0.8" clipPath="url(#svg542025065_547_clip0_1596_2630)">
              <g clipPath="url(#svg542025065_547_clip1_1596_2630)">
                <path
                  d="M4.16406 10.5H15.8311M15.8311 10.5L9.99706 4.66699M15.8311 10.5L9.99706 16.334"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <defs>
              <clipPath id="svg542025065_547_clip0_1596_2630">
                <rect width="20" height="21" fill="white" />
              </clipPath>
              <clipPath id="svg542025065_547_clip1_1596_2630">
                <rect width="20" height="21" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <svg viewBox="0 0 180 60" overflow="visible" id="svg1322499166_10645">
            <g>
              <path d="M 0 60 L 0 0 L 180 0 L 180 60 Z" fill="transparent" />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="rgb(12,13,16)"
              />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 122.291 28.802 L 122.291 32.239 L 120.137 32.239 L 120.137 34.492 L 122.291 34.492 L 122.291 42.15 C 122.291 44.764 123.474 45.81 126.449 45.81 C 126.972 45.81 127.471 45.748 127.906 45.673 L 127.906 43.445 C 127.533 43.482 127.296 43.507 126.885 43.507 C 125.553 43.507 124.968 42.884 124.968 41.465 L 124.968 34.492 L 127.906 34.492 L 127.906 32.239 L 124.968 32.239 L 124.968 28.802 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 135.486 45.997 C 139.445 45.997 141.873 43.345 141.873 38.95 C 141.873 34.579 139.433 31.915 135.486 31.915 C 131.526 31.915 129.086 34.579 129.086 38.95 C 129.086 43.345 131.514 45.997 135.486 45.997 Z M 135.486 43.619 C 133.158 43.619 131.85 41.913 131.85 38.95 C 131.85 36.011 133.158 34.293 135.486 34.293 C 137.802 34.293 139.122 36.011 139.122 38.95 C 139.122 41.901 137.802 43.619 135.486 43.619 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.949 45.736 L 146.626 45.736 L 146.626 37.73 C 146.626 35.825 148.058 34.542 150.088 34.542 C 150.56 34.542 151.358 34.629 151.582 34.704 L 151.582 32.064 C 151.295 31.989 150.785 31.952 150.386 31.952 C 148.618 31.952 147.112 32.923 146.726 34.256 L 146.527 34.256 L 146.527 32.176 L 143.949 32.176 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 158.229 34.193 C 160.209 34.193 161.504 35.575 161.567 37.705 L 154.718 37.705 C 154.868 35.588 156.249 34.193 158.229 34.193 Z M 161.555 42.075 C 161.057 43.133 159.948 43.719 158.33 43.719 C 156.188 43.719 154.806 42.212 154.718 39.834 L 154.718 39.684 L 164.294 39.684 L 164.294 38.751 C 164.294 34.492 162.015 31.915 158.243 31.915 C 154.419 31.915 151.992 34.666 151.992 39 C 151.992 43.333 154.37 45.997 158.255 45.997 C 161.355 45.997 163.521 44.503 164.132 42.075 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 104.734 40.728 C 104.941 44.058 107.716 46.187 111.845 46.187 C 116.259 46.187 119.021 43.955 119.021 40.393 C 119.021 37.592 117.446 36.044 113.626 35.153 L 111.574 34.65 C 109.148 34.082 108.167 33.321 108.167 31.992 C 108.167 30.314 109.69 29.217 111.974 29.217 C 114.142 29.217 115.639 30.288 115.91 32.005 L 118.724 32.005 C 118.556 28.868 115.794 26.662 112.013 26.662 C 107.948 26.662 105.238 28.868 105.238 32.185 C 105.238 34.921 106.773 36.547 110.142 37.334 L 112.542 37.915 C 115.007 38.496 116.091 39.348 116.091 40.767 C 116.091 42.419 114.388 43.619 112.065 43.619 C 109.574 43.619 107.845 42.496 107.599 40.728 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 77.004 31.952 C 75.161 31.952 73.567 32.873 72.745 34.417 L 72.546 34.417 L 72.546 32.176 L 69.969 32.176 L 69.969 50.243 L 72.646 50.243 L 72.646 43.681 L 72.857 43.681 C 73.567 45.113 75.099 45.96 77.028 45.96 C 80.453 45.96 82.632 43.258 82.632 38.95 C 82.632 34.642 80.453 31.952 77.004 31.952 Z M 76.244 43.557 C 74.003 43.557 72.596 41.789 72.596 38.962 C 72.596 36.123 74.003 34.355 76.257 34.355 C 78.523 34.355 79.88 36.086 79.88 38.95 C 79.88 41.826 78.523 43.557 76.244 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 91.996 31.952 C 90.153 31.952 88.559 32.873 87.737 34.417 L 87.538 34.417 L 87.538 32.176 L 84.961 32.176 L 84.961 50.243 L 87.638 50.243 L 87.638 43.681 L 87.85 43.681 C 88.559 45.113 90.091 45.96 92.021 45.96 C 95.445 45.96 97.624 43.258 97.624 38.95 C 97.624 34.642 95.445 31.952 91.996 31.952 Z M 91.236 43.557 C 88.995 43.557 87.588 41.789 87.588 38.962 C 87.588 36.123 88.995 34.355 91.249 34.355 C 93.515 34.355 94.872 36.086 94.872 38.95 C 94.872 41.826 93.515 43.557 91.236 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.166 45.736 L 68.237 45.736 L 61.514 27.113 L 58.403 27.113 L 51.68 45.736 L 54.648 45.736 L 56.364 40.793 L 63.462 40.793 Z M 59.81 30.495 L 60.029 30.495 L 62.727 38.367 L 57.1 38.367 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 53.477 13.066 L 53.477 22.05 L 56.72 22.05 C 59.397 22.05 60.947 20.4 60.947 17.53 C 60.947 14.703 59.385 13.066 56.72 13.066 Z M 54.871 14.336 L 56.565 14.336 C 58.426 14.336 59.528 15.519 59.528 17.548 C 59.528 19.609 58.445 20.779 56.565 20.779 L 54.871 20.779 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.696 22.18 C 67.676 22.18 68.89 20.854 68.89 18.657 C 68.89 16.471 67.67 15.139 65.696 15.139 C 63.716 15.139 62.496 16.471 62.496 18.657 C 62.496 20.854 63.71 22.18 65.696 22.18 Z M 65.696 20.991 C 64.532 20.991 63.878 20.138 63.878 18.657 C 63.878 17.188 64.532 16.328 65.696 16.328 C 66.854 16.328 67.514 17.188 67.514 18.657 C 67.514 20.132 66.854 20.991 65.696 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 79.227 15.27 L 77.888 15.27 L 76.68 20.443 L 76.574 20.443 L 75.18 15.27 L 73.897 15.27 L 72.503 20.443 L 72.403 20.443 L 71.189 15.27 L 69.832 15.27 L 71.7 22.049 L 73.076 22.049 L 74.47 17.057 L 74.576 17.057 L 75.977 22.049 L 77.365 22.049 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 80.769 22.05 L 82.108 22.05 L 82.108 18.084 C 82.108 17.026 82.737 16.366 83.727 16.366 C 84.717 16.366 85.19 16.907 85.19 17.997 L 85.19 22.05 L 86.528 22.05 L 86.528 17.661 C 86.528 16.048 85.694 15.139 84.181 15.139 C 83.16 15.139 82.488 15.594 82.158 16.347 L 82.058 16.347 L 82.058 15.27 L 80.769 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 88.637 22.049 L 89.975 22.049 L 89.975 12.624 L 88.637 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 95.008 22.18 C 96.988 22.18 98.202 20.854 98.202 18.657 C 98.202 16.471 96.982 15.139 95.008 15.139 C 93.029 15.139 91.809 16.471 91.809 18.657 C 91.809 20.854 93.022 22.18 95.008 22.18 Z M 95.008 20.991 C 93.844 20.991 93.191 20.138 93.191 18.657 C 93.191 17.188 93.844 16.328 95.008 16.328 C 96.166 16.328 96.826 17.188 96.826 18.657 C 96.826 20.132 96.166 20.991 95.008 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 102.188 21.035 C 101.46 21.035 100.931 20.68 100.931 20.07 C 100.931 19.472 101.354 19.155 102.288 19.092 L 103.944 18.987 L 103.944 19.553 C 103.944 20.394 103.197 21.035 102.188 21.035 Z M 101.846 22.162 C 102.736 22.162 103.477 21.776 103.882 21.097 L 103.987 21.097 L 103.987 22.05 L 105.276 22.05 L 105.276 17.418 C 105.276 15.986 104.317 15.139 102.618 15.139 C 101.08 15.139 99.984 15.886 99.847 17.05 L 101.142 17.05 C 101.292 16.571 101.808 16.297 102.555 16.297 C 103.471 16.297 103.944 16.702 103.944 17.418 L 103.944 18.003 L 102.107 18.109 C 100.495 18.208 99.586 18.912 99.586 20.132 C 99.586 21.371 100.538 22.162 101.846 22.162 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 109.818 22.162 C 110.752 22.162 111.542 21.72 111.947 20.979 L 112.053 20.979 L 112.053 22.049 L 113.335 22.049 L 113.335 12.624 L 111.997 12.624 L 111.997 16.347 L 111.897 16.347 C 111.53 15.6 110.746 15.158 109.818 15.158 C 108.106 15.158 107.004 16.515 107.004 18.657 C 107.004 20.804 108.093 22.162 109.818 22.162 Z M 110.198 16.359 C 111.318 16.359 112.022 17.25 112.022 18.663 C 112.022 20.082 111.325 20.96 110.198 20.96 C 109.065 20.96 108.386 20.095 108.386 18.657 C 108.386 17.231 109.071 16.359 110.198 16.359 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 122.016 22.18 C 123.996 22.18 125.21 20.854 125.21 18.657 C 125.21 16.471 123.99 15.139 122.016 15.139 C 120.037 15.139 118.816 16.471 118.816 18.657 C 118.816 20.854 120.031 22.18 122.016 22.18 Z M 122.016 20.991 C 120.852 20.991 120.199 20.138 120.199 18.657 C 120.199 17.188 120.852 16.328 122.016 16.328 C 123.174 16.328 123.834 17.188 123.834 18.657 C 123.834 20.132 123.174 20.991 122.016 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 126.98 22.05 L 128.319 22.05 L 128.319 18.084 C 128.319 17.026 128.948 16.366 129.938 16.366 C 130.927 16.366 131.401 16.907 131.401 17.997 L 131.401 22.05 L 132.739 22.05 L 132.739 17.661 C 132.739 16.048 131.905 15.139 130.392 15.139 C 129.371 15.139 128.699 15.594 128.369 16.347 L 128.269 16.347 L 128.269 15.27 L 126.98 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 138.905 13.583 L 138.905 15.301 L 137.828 15.301 L 137.828 16.428 L 138.905 16.428 L 138.905 20.257 C 138.905 21.564 139.497 22.087 140.984 22.087 C 141.246 22.087 141.495 22.056 141.713 22.018 L 141.713 20.904 C 141.526 20.923 141.408 20.935 141.202 20.935 C 140.536 20.935 140.244 20.624 140.244 19.914 L 140.244 16.428 L 141.713 16.428 L 141.713 15.301 L 140.244 15.301 L 140.244 13.583 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.512 22.049 L 144.85 22.049 L 144.85 18.09 C 144.85 17.063 145.46 16.372 146.556 16.372 C 147.502 16.372 148.007 16.92 148.007 18.003 L 148.007 22.049 L 149.345 22.049 L 149.345 17.673 C 149.345 16.061 148.455 15.145 147.011 15.145 C 145.99 15.145 145.274 15.6 144.944 16.359 L 144.838 16.359 L 144.838 12.624 L 143.512 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 154.173 16.278 C 155.163 16.278 155.811 16.969 155.843 18.034 L 152.418 18.034 C 152.493 16.976 153.183 16.278 154.173 16.278 Z M 155.835 20.219 C 155.586 20.748 155.033 21.041 154.223 21.041 C 153.153 21.041 152.462 20.288 152.418 19.099 L 152.418 19.024 L 157.205 19.024 L 157.205 18.557 C 157.205 16.428 156.066 15.139 154.179 15.139 C 152.268 15.139 151.055 16.515 151.055 18.681 C 151.055 20.848 152.244 22.18 154.185 22.18 C 155.736 22.18 156.819 21.433 157.124 20.219 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 37.153 30.452 C 37.185 27.93 38.54 25.544 40.688 24.224 C 39.333 22.288 37.063 21.061 34.701 20.987 C 32.182 20.723 29.74 22.494 28.457 22.494 C 27.148 22.494 25.172 21.013 23.044 21.057 C 20.27 21.147 17.684 22.724 16.335 25.149 C 13.434 30.172 15.598 37.553 18.376 41.613 C 19.767 43.601 21.392 45.822 23.518 45.743 C 25.599 45.657 26.375 44.416 28.887 44.416 C 31.375 44.416 32.104 45.743 34.273 45.693 C 36.506 45.657 37.913 43.696 39.254 41.689 C 40.253 40.273 41.022 38.707 41.532 37.05 C 38.908 35.941 37.156 33.3 37.153 30.452 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 33.057 18.317 C 34.274 16.856 34.874 14.977 34.729 13.081 C 32.869 13.276 31.151 14.165 29.917 15.57 C 28.711 16.943 28.083 18.789 28.202 20.613 C 30.062 20.632 31.891 19.767 33.057 18.317 Z"
                fill="rgb(255,255,255)"
              />
            </g>
          </svg>
          <svg viewBox="0 0 117 39" overflow="visible" id="svg2038526003_10374">
            <g>
              <path d="M 0 39 L 0 0 L 117 0 L 117 39 Z" fill="transparent" />
              <path
                d="M 110.175 0.487 L 6.825 0.487 C 3.325 0.487 0.488 3.325 0.488 6.825 L 0.488 32.175 C 0.488 35.675 3.325 38.512 6.825 38.512 L 110.175 38.512 C 113.675 38.512 116.513 35.675 116.513 32.175 L 116.513 6.825 C 116.513 3.325 113.675 0.487 110.175 0.487 Z"
                fill="rgb(12,13,16)"
              />
              <path
                d="M 110.175 0.487 L 6.825 0.487 C 3.325 0.487 0.488 3.325 0.488 6.825 L 0.488 32.175 C 0.488 35.675 3.325 38.512 6.825 38.512 L 110.175 38.512 C 113.675 38.512 116.513 35.675 116.513 32.175 L 116.513 6.825 C 116.513 3.325 113.675 0.487 110.175 0.487 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 79.489 18.721 L 79.489 20.955 L 78.089 20.955 L 78.089 22.42 L 79.489 22.42 L 79.489 27.397 C 79.489 29.097 80.258 29.777 82.192 29.777 C 82.532 29.777 82.856 29.736 83.139 29.688 L 83.139 28.239 C 82.896 28.263 82.742 28.279 82.475 28.279 C 81.609 28.279 81.229 27.875 81.229 26.952 L 81.229 22.42 L 83.139 22.42 L 83.139 20.955 L 81.229 20.955 L 81.229 18.721 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 88.066 29.898 C 90.639 29.898 92.217 28.174 92.217 25.317 C 92.217 22.477 90.631 20.745 88.066 20.745 C 85.492 20.745 83.906 22.477 83.906 25.317 C 83.906 28.174 85.484 29.898 88.066 29.898 Z M 88.066 28.352 C 86.553 28.352 85.703 27.244 85.703 25.317 C 85.703 23.407 86.553 22.29 88.066 22.29 C 89.571 22.29 90.429 23.407 90.429 25.317 C 90.429 27.235 89.571 28.352 88.066 28.352 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 93.567 29.728 L 95.307 29.728 L 95.307 24.524 C 95.307 23.286 96.238 22.452 97.557 22.452 C 97.864 22.452 98.383 22.509 98.528 22.557 L 98.528 20.842 C 98.342 20.793 98.01 20.769 97.751 20.769 C 96.602 20.769 95.623 21.4 95.372 22.266 L 95.243 22.266 L 95.243 20.915 L 93.567 20.915 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 102.849 22.226 C 104.136 22.226 104.978 23.124 105.019 24.508 L 100.567 24.508 C 100.664 23.132 101.562 22.226 102.849 22.226 Z M 105.011 27.349 C 104.687 28.037 103.966 28.417 102.915 28.417 C 101.522 28.417 100.624 27.438 100.567 25.892 L 100.567 25.795 L 106.791 25.795 L 106.791 25.188 C 106.791 22.42 105.31 20.745 102.858 20.745 C 100.372 20.745 98.795 22.533 98.795 25.35 C 98.795 28.166 100.341 29.898 102.866 29.898 C 104.881 29.898 106.289 28.927 106.686 27.349 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 68.077 26.473 C 68.212 28.638 70.015 30.022 72.699 30.022 C 75.568 30.022 77.364 28.571 77.364 26.255 C 77.364 24.435 76.34 23.428 73.857 22.85 L 72.523 22.523 C 70.946 22.153 70.309 21.658 70.309 20.795 C 70.309 19.704 71.299 18.991 72.783 18.991 C 74.192 18.991 75.165 19.687 75.342 20.803 L 77.171 20.803 C 77.061 18.764 75.266 17.33 72.808 17.33 C 70.166 17.33 68.405 18.764 68.405 20.92 C 68.405 22.699 69.402 23.756 71.592 24.267 L 73.152 24.645 C 74.755 25.022 75.459 25.576 75.459 26.499 C 75.459 27.572 74.352 28.352 72.842 28.352 C 71.223 28.352 70.099 27.623 69.939 26.473 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 50.052 20.769 C 48.855 20.769 47.819 21.368 47.284 22.371 L 47.155 22.371 L 47.155 20.915 L 45.48 20.915 L 45.48 32.658 L 47.22 32.658 L 47.22 28.393 L 47.357 28.393 C 47.819 29.324 48.814 29.874 50.069 29.874 C 52.294 29.874 53.711 28.118 53.711 25.317 C 53.711 22.517 52.294 20.769 50.052 20.769 Z M 49.559 28.312 C 48.102 28.312 47.187 27.163 47.187 25.325 C 47.187 23.48 48.102 22.331 49.567 22.331 C 51.04 22.331 51.922 23.456 51.922 25.317 C 51.922 27.187 51.04 28.312 49.559 28.312 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 59.797 20.769 C 58.599 20.769 57.564 21.368 57.029 22.371 L 56.9 22.371 L 56.9 20.915 L 55.225 20.915 L 55.225 32.658 L 56.965 32.658 L 56.965 28.393 L 57.102 28.393 C 57.564 29.324 58.559 29.874 59.813 29.874 C 62.039 29.874 63.455 28.118 63.455 25.317 C 63.455 22.517 62.039 20.769 59.797 20.769 Z M 59.304 28.312 C 57.847 28.312 56.932 27.163 56.932 25.325 C 56.932 23.48 57.847 22.331 59.312 22.331 C 60.785 22.331 61.667 23.456 61.667 25.317 C 61.667 27.187 60.785 28.312 59.304 28.312 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 42.358 29.728 L 44.354 29.728 L 39.984 17.624 L 37.962 17.624 L 33.592 29.728 L 35.521 29.728 L 36.637 26.515 L 41.25 26.515 Z M 38.876 19.821 L 39.019 19.821 L 40.772 24.938 L 37.115 24.938 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 34.76 8.493 L 34.76 14.332 L 36.868 14.332 C 38.608 14.332 39.616 13.26 39.616 11.394 C 39.616 9.557 38.6 8.493 36.868 8.493 Z M 35.666 9.318 L 36.767 9.318 C 37.977 9.318 38.693 10.087 38.693 11.407 C 38.693 12.746 37.989 13.507 36.767 13.507 L 35.666 13.507 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 42.702 14.417 C 43.989 14.417 44.778 13.555 44.778 12.127 C 44.778 10.706 43.985 9.84 42.702 9.84 C 41.416 9.84 40.622 10.706 40.622 12.127 C 40.622 13.555 41.411 14.417 42.702 14.417 Z M 42.702 13.644 C 41.946 13.644 41.521 13.09 41.521 12.127 C 41.521 11.172 41.946 10.613 42.702 10.613 C 43.455 10.613 43.884 11.172 43.884 12.127 C 43.884 13.086 43.455 13.644 42.702 13.644 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 51.497 9.925 L 50.627 9.925 L 49.842 13.288 L 49.773 13.288 L 48.867 9.925 L 48.033 9.925 L 47.127 13.288 L 47.062 13.288 L 46.273 9.925 L 45.391 9.925 L 46.605 14.332 L 47.499 14.332 L 48.406 11.087 L 48.474 11.087 L 49.385 14.332 L 50.287 14.332 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 52.5 14.332 L 53.37 14.332 L 53.37 11.755 C 53.37 11.067 53.779 10.638 54.422 10.638 C 55.066 10.638 55.373 10.99 55.373 11.698 L 55.373 14.332 L 56.243 14.332 L 56.243 11.479 C 56.243 10.431 55.701 9.84 54.718 9.84 C 54.054 9.84 53.617 10.136 53.403 10.625 L 53.338 10.625 L 53.338 9.925 L 52.5 9.925 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 57.614 14.332 L 58.484 14.332 L 58.484 8.206 L 57.614 8.206 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 61.756 14.417 C 63.042 14.417 63.831 13.555 63.831 12.127 C 63.831 10.706 63.038 9.84 61.756 9.84 C 60.469 9.84 59.676 10.706 59.676 12.127 C 59.676 13.555 60.465 14.417 61.756 14.417 Z M 61.756 13.644 C 60.999 13.644 60.574 13.09 60.574 12.127 C 60.574 11.172 60.999 10.613 61.756 10.613 C 62.508 10.613 62.937 11.172 62.937 12.127 C 62.937 13.086 62.508 13.644 61.756 13.644 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 66.422 13.673 C 65.949 13.673 65.605 13.442 65.605 13.045 C 65.605 12.657 65.88 12.451 66.487 12.41 L 67.564 12.341 L 67.564 12.71 C 67.564 13.256 67.078 13.673 66.422 13.673 Z M 66.2 14.405 C 66.778 14.405 67.26 14.154 67.523 13.713 L 67.592 13.713 L 67.592 14.332 L 68.429 14.332 L 68.429 11.322 C 68.429 10.391 67.806 9.84 66.702 9.84 C 65.702 9.84 64.99 10.326 64.901 11.083 L 65.742 11.083 C 65.84 10.771 66.175 10.593 66.661 10.593 C 67.256 10.593 67.564 10.856 67.564 11.322 L 67.564 11.702 L 66.37 11.771 C 65.322 11.835 64.731 12.293 64.731 13.086 C 64.731 13.891 65.35 14.405 66.2 14.405 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 71.382 14.405 C 71.989 14.405 72.502 14.118 72.766 13.636 L 72.834 13.636 L 72.834 14.332 L 73.668 14.332 L 73.668 8.206 L 72.798 8.206 L 72.798 10.625 L 72.733 10.625 C 72.494 10.14 71.985 9.853 71.382 9.853 C 70.269 9.853 69.553 10.735 69.553 12.127 C 69.553 13.523 70.26 14.405 71.382 14.405 Z M 71.629 10.634 C 72.357 10.634 72.814 11.212 72.814 12.131 C 72.814 13.053 72.361 13.624 71.629 13.624 C 70.892 13.624 70.451 13.062 70.451 12.127 C 70.451 11.2 70.896 10.634 71.629 10.634 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 79.31 14.417 C 80.597 14.417 81.386 13.555 81.386 12.127 C 81.386 10.706 80.593 9.84 79.31 9.84 C 78.024 9.84 77.23 10.706 77.23 12.127 C 77.23 13.555 78.02 14.417 79.31 14.417 Z M 79.31 13.644 C 78.554 13.644 78.129 13.09 78.129 12.127 C 78.129 11.172 78.554 10.613 79.31 10.613 C 80.063 10.613 80.492 11.172 80.492 12.127 C 80.492 13.086 80.063 13.644 79.31 13.644 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 82.537 14.332 L 83.407 14.332 L 83.407 11.755 C 83.407 11.067 83.816 10.638 84.46 10.638 C 85.103 10.638 85.411 10.99 85.411 11.698 L 85.411 14.332 L 86.28 14.332 L 86.28 11.479 C 86.28 10.431 85.738 9.84 84.755 9.84 C 84.091 9.84 83.654 10.136 83.44 10.625 L 83.375 10.625 L 83.375 9.925 L 82.537 9.925 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 90.288 8.829 L 90.288 9.946 L 89.588 9.946 L 89.588 10.678 L 90.288 10.678 L 90.288 13.167 C 90.288 14.017 90.673 14.356 91.64 14.356 C 91.81 14.356 91.972 14.336 92.113 14.312 L 92.113 13.588 C 91.992 13.6 91.915 13.608 91.781 13.608 C 91.348 13.608 91.159 13.406 91.159 12.944 L 91.159 10.678 L 92.113 10.678 L 92.113 9.946 L 91.159 9.946 L 91.159 8.829 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 93.283 14.332 L 94.152 14.332 L 94.152 11.759 C 94.152 11.091 94.549 10.642 95.261 10.642 C 95.876 10.642 96.205 10.998 96.205 11.702 L 96.205 14.332 L 97.074 14.332 L 97.074 11.487 C 97.074 10.439 96.496 9.844 95.557 9.844 C 94.893 9.844 94.428 10.14 94.214 10.634 L 94.145 10.634 L 94.145 8.206 L 93.283 8.206 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 100.212 10.581 C 100.856 10.581 101.277 11.03 101.298 11.722 L 99.072 11.722 C 99.12 11.034 99.569 10.581 100.212 10.581 Z M 101.293 13.143 C 101.131 13.487 100.771 13.677 100.245 13.677 C 99.549 13.677 99.1 13.187 99.072 12.414 L 99.072 12.366 L 102.183 12.366 L 102.183 12.062 C 102.183 10.678 101.443 9.84 100.216 9.84 C 98.974 9.84 98.186 10.735 98.186 12.143 C 98.186 13.551 98.959 14.417 100.22 14.417 C 101.228 14.417 101.932 13.932 102.131 13.143 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 24.149 19.794 C 24.171 18.155 25.051 16.604 26.447 15.745 C 25.566 14.487 24.091 13.69 22.556 13.642 C 20.918 13.47 19.331 14.621 18.497 14.621 C 17.646 14.621 16.362 13.659 14.979 13.687 C 13.175 13.745 11.495 14.77 10.617 16.347 C 8.732 19.611 10.138 24.41 11.945 27.048 C 12.848 28.341 13.905 29.784 15.287 29.733 C 16.639 29.677 17.144 28.871 18.776 28.871 C 20.394 28.871 20.868 29.733 22.278 29.7 C 23.729 29.677 24.643 28.402 25.515 27.098 C 26.165 26.177 26.664 25.16 26.996 24.083 C 25.29 23.361 24.151 21.645 24.149 19.794 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 21.487 11.906 C 22.278 10.956 22.668 9.735 22.574 8.503 C 21.365 8.63 20.248 9.207 19.446 10.121 C 18.662 11.013 18.254 12.213 18.331 13.398 C 19.54 13.411 20.729 12.849 21.487 11.906 Z"
                fill="rgb(255,255,255)"
              />
            </g>
          </svg>
          <svg viewBox="0 0 159 53" overflow="visible" id="svg-365320820_10584">
            <g>
              <path d="M 0 53 L 0 0 L 159 0 L 159 53 Z" fill="transparent" />
              <path
                d="M 149.725 0.662 L 9.275 0.662 C 4.518 0.662 0.662 4.518 0.662 9.275 L 0.662 43.725 C 0.662 48.482 4.518 52.337 9.275 52.337 L 149.725 52.337 C 154.482 52.337 158.338 48.482 158.338 43.725 L 158.338 9.275 C 158.338 4.518 154.482 0.662 149.725 0.662 Z"
                fill="rgb(12,13,16)"
              />
              <path
                d="M 149.725 0.662 L 9.275 0.662 C 4.518 0.662 0.662 4.518 0.662 9.275 L 0.662 43.725 C 0.662 48.482 4.518 52.337 9.275 52.337 L 149.725 52.337 C 154.482 52.337 158.338 48.482 158.338 43.725 L 158.338 9.275 C 158.338 4.518 154.482 0.662 149.725 0.662 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 108.024 25.442 L 108.024 28.477 L 106.121 28.477 L 106.121 30.468 L 108.024 30.468 L 108.024 37.232 C 108.024 39.542 109.069 40.466 111.697 40.466 C 112.159 40.466 112.599 40.411 112.984 40.345 L 112.984 38.376 C 112.654 38.409 112.445 38.431 112.082 38.431 C 110.905 38.431 110.388 37.881 110.388 36.627 L 110.388 30.468 L 112.984 30.468 L 112.984 28.477 L 110.388 28.477 L 110.388 25.442 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 119.679 40.631 C 123.176 40.631 125.321 38.288 125.321 34.406 C 125.321 30.545 123.166 28.191 119.679 28.191 C 116.181 28.191 114.026 30.545 114.026 34.406 C 114.026 38.288 116.171 40.631 119.679 40.631 Z M 119.679 38.53 C 117.623 38.53 116.467 37.023 116.467 34.406 C 116.467 31.81 117.623 30.292 119.679 30.292 C 121.725 30.292 122.891 31.81 122.891 34.406 C 122.891 37.012 121.725 38.53 119.679 38.53 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 127.155 40.4 L 129.52 40.4 L 129.52 33.328 C 129.52 31.645 130.785 30.512 132.578 30.512 C 132.995 30.512 133.7 30.589 133.897 30.655 L 133.897 28.323 C 133.644 28.257 133.193 28.224 132.841 28.224 C 131.279 28.224 129.949 29.082 129.608 30.259 L 129.432 30.259 L 129.432 28.422 L 127.155 28.422 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 139.769 30.204 C 141.518 30.204 142.662 31.425 142.718 33.306 L 136.668 33.306 C 136.8 31.436 138.02 30.204 139.769 30.204 Z M 142.707 37.166 C 142.267 38.101 141.287 38.618 139.858 38.618 C 137.966 38.618 136.745 37.287 136.668 35.186 L 136.668 35.054 L 145.126 35.054 L 145.126 34.23 C 145.126 30.468 143.113 28.191 139.781 28.191 C 136.403 28.191 134.26 30.622 134.26 34.45 C 134.26 38.277 136.36 40.631 139.792 40.631 C 142.53 40.631 144.444 39.311 144.983 37.166 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 92.515 35.977 C 92.698 38.918 95.149 40.799 98.796 40.799 C 102.695 40.799 105.135 38.827 105.135 35.68 C 105.135 33.207 103.744 31.839 100.37 31.052 L 98.557 30.607 C 96.414 30.106 95.548 29.433 95.548 28.259 C 95.548 26.777 96.893 25.808 98.91 25.808 C 100.825 25.808 102.148 26.754 102.387 28.271 L 104.873 28.271 C 104.724 25.5 102.285 23.551 98.945 23.551 C 95.354 23.551 92.96 25.5 92.96 28.43 C 92.96 30.847 94.316 32.283 97.292 32.979 L 99.412 33.492 C 101.59 34.005 102.547 34.757 102.547 36.011 C 102.547 37.47 101.043 38.53 98.991 38.53 C 96.79 38.53 95.263 37.538 95.046 35.977 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 68.02 28.224 C 66.392 28.224 64.984 29.038 64.258 30.402 L 64.082 30.402 L 64.082 28.422 L 61.806 28.422 L 61.806 44.381 L 64.17 44.381 L 64.17 38.585 L 64.357 38.585 C 64.984 39.85 66.337 40.598 68.042 40.598 C 71.066 40.598 72.991 38.211 72.991 34.406 C 72.991 30.6 71.066 28.224 68.02 28.224 Z M 67.349 38.475 C 65.369 38.475 64.126 36.913 64.126 34.417 C 64.126 31.909 65.369 30.347 67.36 30.347 C 69.362 30.347 70.56 31.876 70.56 34.406 C 70.56 36.946 69.362 38.475 67.349 38.475 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 81.263 28.224 C 79.635 28.224 78.227 29.038 77.501 30.402 L 77.325 30.402 L 77.325 28.422 L 75.049 28.422 L 75.049 44.381 L 77.413 44.381 L 77.413 38.585 L 77.6 38.585 C 78.227 39.85 79.58 40.598 81.285 40.598 C 84.309 40.598 86.234 38.211 86.234 34.406 C 86.234 30.6 84.309 28.224 81.263 28.224 Z M 80.592 38.475 C 78.612 38.475 77.369 36.913 77.369 34.417 C 77.369 31.909 78.612 30.347 80.603 30.347 C 82.605 30.347 83.804 31.876 83.804 34.406 C 83.804 36.946 82.605 38.475 80.592 38.475 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 57.563 40.4 L 60.276 40.4 L 54.337 23.95 L 51.59 23.95 L 45.65 40.4 L 48.272 40.4 L 49.788 36.034 L 56.058 36.034 Z M 52.832 26.937 L 53.026 26.937 L 55.408 33.891 L 50.438 33.891 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 47.238 11.542 L 47.238 19.477 L 50.103 19.477 C 52.467 19.477 53.837 18.02 53.837 15.485 C 53.837 12.988 52.456 11.542 50.103 11.542 Z M 48.469 12.664 L 49.965 12.664 C 51.61 12.664 52.583 13.708 52.583 15.501 C 52.583 17.321 51.626 18.355 49.965 18.355 L 48.469 18.355 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 58.031 19.593 C 59.78 19.593 60.853 18.421 60.853 16.48 C 60.853 14.55 59.775 13.373 58.031 13.373 C 56.283 13.373 55.205 14.55 55.205 16.48 C 55.205 18.421 56.277 19.593 58.031 19.593 Z M 58.031 18.542 C 57.003 18.542 56.426 17.789 56.426 16.48 C 56.426 15.182 57.003 14.423 58.031 14.423 C 59.054 14.423 59.637 15.182 59.637 16.48 C 59.637 17.783 59.054 18.542 58.031 18.542 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 69.983 13.488 L 68.801 13.488 L 67.734 18.058 L 67.641 18.058 L 66.409 13.488 L 65.276 13.488 L 64.044 18.058 L 63.956 18.058 L 62.884 13.488 L 61.685 13.488 L 63.335 19.477 L 64.55 19.477 L 65.782 15.067 L 65.875 15.067 L 67.113 19.477 L 68.339 19.477 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 71.346 19.477 L 72.529 19.477 L 72.529 15.974 C 72.529 15.039 73.084 14.456 73.959 14.456 C 74.833 14.456 75.251 14.935 75.251 15.897 L 75.251 19.477 L 76.433 19.477 L 76.433 15.6 C 76.433 14.176 75.696 13.373 74.36 13.373 C 73.458 13.373 72.864 13.774 72.573 14.44 L 72.485 14.44 L 72.485 13.488 L 71.346 13.488 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 78.296 19.477 L 79.478 19.477 L 79.478 11.151 L 78.296 11.151 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 83.924 19.593 C 85.673 19.593 86.745 18.421 86.745 16.48 C 86.745 14.55 85.668 13.373 83.924 13.373 C 82.175 13.373 81.098 14.55 81.098 16.48 C 81.098 18.421 82.17 19.593 83.924 19.593 Z M 83.924 18.542 C 82.896 18.542 82.318 17.789 82.318 16.48 C 82.318 15.182 82.896 14.423 83.924 14.423 C 84.947 14.423 85.53 15.182 85.53 16.48 C 85.53 17.783 84.947 18.542 83.924 18.542 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 90.266 18.581 C 89.623 18.581 89.156 18.267 89.156 17.728 C 89.156 17.2 89.529 16.92 90.354 16.865 L 91.817 16.771 L 91.817 17.272 C 91.817 18.014 91.157 18.581 90.266 18.581 Z M 89.964 19.576 C 90.75 19.576 91.405 19.235 91.762 18.636 L 91.855 18.636 L 91.855 19.477 L 92.994 19.477 L 92.994 15.386 C 92.994 14.121 92.147 13.373 90.646 13.373 C 89.287 13.373 88.319 14.033 88.199 15.061 L 89.342 15.061 C 89.475 14.638 89.93 14.396 90.59 14.396 C 91.399 14.396 91.817 14.753 91.817 15.386 L 91.817 15.903 L 90.195 15.996 C 88.771 16.084 87.968 16.706 87.968 17.783 C 87.968 18.878 88.809 19.576 89.964 19.576 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 97.006 19.576 C 97.831 19.576 98.529 19.186 98.887 18.531 L 98.98 18.531 L 98.98 19.477 L 100.113 19.477 L 100.113 11.151 L 98.931 11.151 L 98.931 14.44 L 98.842 14.44 C 98.518 13.78 97.826 13.389 97.006 13.389 C 95.494 13.389 94.52 14.588 94.52 16.48 C 94.52 18.377 95.482 19.576 97.006 19.576 Z M 97.342 14.451 C 98.331 14.451 98.953 15.237 98.953 16.485 C 98.953 17.739 98.337 18.515 97.342 18.515 C 96.341 18.515 95.741 17.75 95.741 16.48 C 95.741 15.221 96.346 14.451 97.342 14.451 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 107.781 19.593 C 109.53 19.593 110.602 18.421 110.602 16.48 C 110.602 14.55 109.525 13.373 107.781 13.373 C 106.033 13.373 104.954 14.55 104.954 16.48 C 104.954 18.421 106.027 19.593 107.781 19.593 Z M 107.781 18.542 C 106.753 18.542 106.176 17.789 106.176 16.48 C 106.176 15.182 106.753 14.423 107.781 14.423 C 108.804 14.423 109.387 15.182 109.387 16.48 C 109.387 17.783 108.804 18.542 107.781 18.542 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 112.166 19.477 L 113.348 19.477 L 113.348 15.974 C 113.348 15.039 113.904 14.456 114.779 14.456 C 115.652 14.456 116.071 14.935 116.071 15.897 L 116.071 19.477 L 117.253 19.477 L 117.253 15.6 C 117.253 14.176 116.516 13.373 115.18 13.373 C 114.278 13.373 113.684 13.774 113.393 14.44 L 113.304 14.44 L 113.304 13.488 L 112.166 13.488 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 122.699 11.998 L 122.699 13.516 L 121.748 13.516 L 121.748 14.511 L 122.699 14.511 L 122.699 17.893 C 122.699 19.048 123.222 19.51 124.536 19.51 C 124.767 19.51 124.987 19.483 125.18 19.45 L 125.18 18.465 C 125.015 18.482 124.91 18.493 124.728 18.493 C 124.14 18.493 123.882 18.218 123.882 17.591 L 123.882 14.511 L 125.18 14.511 L 125.18 13.516 L 123.882 13.516 L 123.882 11.998 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 126.769 19.477 L 127.951 19.477 L 127.951 15.98 C 127.951 15.072 128.49 14.462 129.458 14.462 C 130.293 14.462 130.74 14.946 130.74 15.903 L 130.74 19.477 L 131.921 19.477 L 131.921 15.611 C 131.921 14.187 131.135 13.378 129.86 13.378 C 128.958 13.378 128.325 13.78 128.034 14.451 L 127.94 14.451 L 127.94 11.151 L 126.769 11.151 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 136.186 14.379 C 137.061 14.379 137.633 14.99 137.661 15.93 L 134.636 15.93 C 134.702 14.995 135.312 14.379 136.186 14.379 Z M 137.654 17.86 C 137.434 18.328 136.946 18.586 136.23 18.586 C 135.285 18.586 134.675 17.921 134.636 16.87 L 134.636 16.804 L 138.864 16.804 L 138.864 16.392 C 138.864 14.511 137.858 13.373 136.191 13.373 C 134.503 13.373 133.432 14.588 133.432 16.502 C 133.432 18.416 134.482 19.593 136.197 19.593 C 137.567 19.593 138.523 18.933 138.793 17.86 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 32.818 26.899 C 32.847 24.672 34.043 22.564 35.941 21.397 C 34.744 19.688 32.739 18.604 30.653 18.539 C 28.428 18.305 26.271 19.87 25.137 19.87 C 23.981 19.87 22.235 18.562 20.356 18.6 C 17.905 18.68 15.621 20.073 14.429 22.215 C 11.866 26.651 13.778 33.172 16.232 36.758 C 17.461 38.514 18.896 40.476 20.774 40.406 C 22.612 40.33 23.298 39.234 25.517 39.234 C 27.715 39.234 28.359 40.406 30.275 40.362 C 32.247 40.33 33.489 38.598 34.675 36.825 C 35.557 35.574 36.236 34.191 36.686 32.728 C 34.369 31.748 32.821 29.415 32.818 26.899 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 29.2 16.18 C 30.276 14.889 30.805 13.23 30.677 11.555 C 29.034 11.727 27.517 12.513 26.427 13.754 C 25.361 14.967 24.807 16.597 24.912 18.208 C 26.555 18.225 28.17 17.461 29.2 16.18 Z"
                fill="rgb(255,255,255)"
              />
            </g>
          </svg>
          <svg
            viewBox="0 0 201 58.5"
            overflow="visible"
            id="svg-412316951_7924"
          >
            <g>
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="rgb(0,0,0)"
              />
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 159.651 44.25 L 162.45 44.25 L 162.45 25.498 L 159.651 25.498 Z M 184.862 32.253 L 181.654 40.383 L 181.558 40.383 L 178.228 32.253 L 175.213 32.253 L 180.208 43.616 L 177.359 49.937 L 180.278 49.937 L 187.975 32.253 Z M 168.988 42.12 C 168.073 42.12 166.793 41.661 166.793 40.528 C 166.793 39.08 168.386 38.525 169.76 38.525 C 170.99 38.525 171.571 38.79 172.318 39.152 C 172.1 40.89 170.605 42.12 168.988 42.12 Z M 169.326 31.843 C 167.3 31.843 165.201 32.736 164.333 34.714 L 166.817 35.751 C 167.348 34.714 168.336 34.376 169.374 34.376 C 170.822 34.376 172.293 35.244 172.317 36.789 L 172.317 36.981 C 171.81 36.692 170.724 36.258 169.398 36.258 C 166.719 36.258 163.994 37.729 163.994 40.479 C 163.994 42.989 166.19 44.605 168.65 44.605 C 170.531 44.605 171.57 43.761 172.22 42.771 L 172.317 42.771 L 172.317 44.22 L 175.02 44.22 L 175.02 37.029 C 175.02 33.7 172.533 31.843 169.326 31.843 Z M 152.029 34.536 L 148.047 34.536 L 148.047 28.108 L 152.029 28.108 C 154.121 28.108 155.309 29.84 155.309 31.322 C 155.309 32.775 154.121 34.536 152.029 34.536 Z M 151.957 25.498 L 145.249 25.498 L 145.249 44.25 L 148.047 44.25 L 148.047 37.146 L 151.957 37.146 C 155.059 37.146 158.108 34.9 158.108 31.322 C 158.108 27.744 155.059 25.498 151.957 25.498 Z M 115.384 42.124 C 113.45 42.124 111.832 40.504 111.832 38.282 C 111.832 36.033 113.45 34.391 115.384 34.391 C 117.293 34.391 118.791 36.033 118.791 38.282 C 118.791 40.504 117.293 42.124 115.384 42.124 Z M 118.598 33.303 L 118.501 33.303 C 117.873 32.554 116.664 31.877 115.142 31.877 C 111.952 31.877 109.028 34.681 109.028 38.282 C 109.028 41.858 111.952 44.637 115.142 44.637 C 116.664 44.637 117.873 43.96 118.501 43.187 L 118.598 43.187 L 118.598 44.105 C 118.598 46.546 117.293 47.851 115.19 47.851 C 113.475 47.851 112.412 46.618 111.977 45.579 L 109.536 46.594 C 110.236 48.285 112.097 50.364 115.19 50.364 C 118.478 50.364 121.257 48.431 121.257 43.718 L 121.257 32.264 L 118.598 32.264 Z M 123.19 44.25 L 125.992 44.25 L 125.992 25.498 L 123.19 25.498 Z M 130.125 38.064 C 130.053 35.599 132.035 34.342 133.46 34.342 C 134.572 34.342 135.514 34.898 135.829 35.695 Z M 138.824 35.937 C 138.293 34.512 136.674 31.877 133.363 31.877 C 130.076 31.877 127.346 34.463 127.346 38.257 C 127.346 41.834 130.053 44.637 133.677 44.637 C 136.601 44.637 138.293 42.849 138.994 41.81 L 136.819 40.359 C 136.094 41.423 135.104 42.124 133.677 42.124 C 132.252 42.124 131.236 41.471 130.585 40.19 L 139.114 36.662 Z M 70.863 33.835 L 70.863 36.541 L 77.339 36.541 C 77.146 38.064 76.638 39.175 75.865 39.949 C 74.922 40.891 73.448 41.93 70.863 41.93 C 66.875 41.93 63.758 38.716 63.758 34.729 C 63.758 30.742 66.875 27.527 70.863 27.527 C 73.013 27.527 74.584 28.373 75.744 29.461 L 77.654 27.551 C 76.034 26.005 73.884 24.821 70.863 24.821 C 65.4 24.821 60.809 29.268 60.809 34.729 C 60.809 40.19 65.4 44.637 70.863 44.637 C 73.81 44.637 76.034 43.67 77.774 41.858 C 79.562 40.069 80.118 37.556 80.118 35.526 C 80.118 34.898 80.069 34.318 79.973 33.835 Z M 87.481 42.124 C 85.547 42.124 83.88 40.529 83.88 38.257 C 83.88 35.961 85.547 34.391 87.481 34.391 C 89.414 34.391 91.081 35.961 91.081 38.257 C 91.081 40.529 89.414 42.124 87.481 42.124 Z M 87.481 31.877 C 83.952 31.877 81.077 34.56 81.077 38.257 C 81.077 41.93 83.952 44.637 87.481 44.637 C 91.009 44.637 93.885 41.93 93.885 38.257 C 93.885 34.56 91.009 31.877 87.481 31.877 Z M 101.45 42.124 C 99.518 42.124 97.85 40.529 97.85 38.257 C 97.85 35.961 99.518 34.391 101.45 34.391 C 103.384 34.391 105.051 35.961 105.051 38.257 C 105.051 40.529 103.384 42.124 101.45 42.124 Z M 101.45 31.877 C 97.922 31.877 95.047 34.56 95.047 38.257 C 95.047 41.93 97.922 44.637 101.45 44.637 C 104.979 44.637 107.855 41.93 107.855 38.257 C 107.855 34.56 104.979 31.877 101.45 31.877 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.965 19.102 C 64.62 19.102 63.463 18.628 62.531 17.696 C 61.598 16.763 61.125 15.594 61.125 14.236 C 61.125 12.877 61.598 11.711 62.531 10.776 C 63.463 9.843 64.62 9.37 65.965 9.37 C 66.65 9.37 67.289 9.489 67.9 9.735 C 68.512 9.981 69.012 10.324 69.406 10.771 L 69.498 10.877 L 68.449 11.926 L 68.345 11.797 C 68.083 11.476 67.751 11.227 67.33 11.046 C 66.911 10.865 66.452 10.781 65.965 10.781 C 65.018 10.781 64.232 11.103 63.575 11.757 C 62.933 12.424 62.611 13.236 62.611 14.236 C 62.611 15.236 62.934 16.049 63.576 16.716 C 64.232 17.37 65.018 17.693 65.965 17.693 C 66.832 17.693 67.549 17.451 68.113 16.972 C 68.638 16.526 68.953 15.923 69.064 15.155 L 65.815 15.155 L 65.815 13.772 L 70.469 13.772 L 70.489 13.898 C 70.527 14.142 70.554 14.376 70.554 14.602 C 70.554 15.892 70.16 16.945 69.389 17.72 C 68.517 18.644 67.372 19.102 65.965 19.102 Z M 106.377 19.102 C 105.031 19.102 103.887 18.628 102.967 17.696 C 102.967 17.696 102.966 17.696 102.966 17.695 C 102.044 16.773 101.587 15.605 101.587 14.236 C 101.587 12.867 102.044 11.699 102.966 10.777 C 102.966 10.776 102.966 10.776 102.966 10.776 C 103.886 9.844 105.031 9.37 106.377 9.37 C 107.722 9.37 108.865 9.844 109.786 10.79 C 110.708 11.712 111.166 12.878 111.166 14.236 C 111.166 15.605 110.708 16.773 109.786 17.695 C 108.865 18.628 107.711 19.102 106.377 19.102 Z M 71.886 18.9 L 71.886 9.572 L 72.036 9.572 L 77.457 9.572 L 77.457 10.983 L 73.346 10.983 L 73.346 13.545 L 77.054 13.545 L 77.054 14.927 L 73.346 14.927 L 73.346 17.491 L 77.457 17.491 L 77.457 18.9 Z M 80.866 18.9 L 80.866 10.983 L 78.344 10.983 L 78.344 9.572 L 84.848 9.572 L 84.848 10.983 L 84.698 10.983 L 82.326 10.983 L 82.326 18.9 Z M 89.005 18.9 L 89.005 9.572 L 90.465 9.572 L 90.465 9.722 L 90.465 18.9 Z M 94.141 18.9 L 94.141 10.983 L 91.619 10.983 L 91.619 9.572 L 98.123 9.572 L 98.123 10.983 L 97.973 10.983 L 95.601 10.983 L 95.601 18.9 Z M 112.462 18.9 L 112.462 9.572 L 114.108 9.572 L 118.299 16.28 L 118.263 15.007 L 118.263 9.572 L 119.723 9.572 L 119.723 18.9 L 118.278 18.9 L 113.886 11.853 L 113.922 13.125 L 113.922 13.127 L 113.922 18.9 Z M 106.377 17.693 C 107.325 17.693 108.098 17.37 108.728 16.717 L 108.729 16.716 L 108.73 16.715 C 109.369 16.076 109.682 15.252 109.682 14.236 C 109.682 13.222 109.369 12.396 108.73 11.757 L 108.729 11.756 L 108.728 11.755 C 108.098 11.102 107.325 10.781 106.377 10.781 C 105.428 10.781 104.655 11.102 104.013 11.754 L 104.013 11.755 C 103.385 12.41 103.073 13.222 103.073 14.236 C 103.073 15.252 103.385 16.062 104.013 16.717 C 104.655 17.37 105.429 17.693 106.377 17.693 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 30.322 28.385 L 14.352 45.335 C 14.353 45.338 14.354 45.341 14.354 45.345 C 14.844 47.185 16.525 48.541 18.52 48.541 C 19.318 48.541 20.067 48.325 20.709 47.946 L 20.76 47.916 L 38.736 37.544 Z"
                fill="rgb(234,67,53)"
              />
              <path
                d="M 46.48 25.499 L 46.465 25.489 L 38.704 20.99 L 29.961 28.77 L 38.735 37.542 L 46.455 33.088 C 47.808 32.358 48.727 30.931 48.727 29.285 C 48.727 27.652 47.82 26.232 46.48 25.499 Z"
                fill="rgb(251,188,4)"
              />
              <path
                d="M 14.349 13.165 C 14.253 13.519 14.203 13.89 14.203 14.275 L 14.203 44.226 C 14.203 44.611 14.253 44.983 14.35 45.335 L 30.869 28.819 Z"
                fill="rgb(66,133,244)"
              />
              <path
                d="M 30.441 29.25 L 38.706 20.987 L 20.751 10.576 C 20.098 10.185 19.336 9.96 18.521 9.96 C 16.526 9.96 14.843 11.317 14.353 13.16 C 14.352 13.162 14.352 13.163 14.352 13.165 Z"
                fill="rgb(52,168,83)"
              />
            </g>
          </svg>
          <svg viewBox="0 0 134 39" overflow="visible" id="svg-77694124_7650">
            <g>
              <path
                d="M 4.5 39 C 2.015 39 0 36.985 0 34.5 L 0 4.5 C 0 2.015 2.015 0 4.5 0 L 129.5 0 C 131.985 0 134 2.015 134 4.5 L 134 34.5 C 134 36.985 131.985 39 129.5 39 Z"
                fill="rgb(0,0,0)"
              />
              <path
                d="M 4.5 39 C 2.015 39 0 36.985 0 34.5 L 0 4.5 C 0 2.015 2.015 0 4.5 0 L 129.5 0 C 131.985 0 134 2.015 134 4.5 L 134 34.5 C 134 36.985 131.985 39 129.5 39 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 106.434 29.5 L 108.3 29.5 L 108.3 16.999 L 106.434 16.999 Z M 123.241 21.502 L 121.103 26.922 L 121.039 26.922 L 118.819 21.502 L 116.809 21.502 L 120.139 29.077 L 118.239 33.291 L 120.185 33.291 L 125.317 21.502 Z M 112.659 28.08 C 112.049 28.08 111.195 27.774 111.195 27.019 C 111.195 26.053 112.257 25.683 113.173 25.683 C 113.993 25.683 114.381 25.86 114.879 26.101 C 114.733 27.26 113.737 28.08 112.659 28.08 Z M 112.884 21.229 C 111.533 21.229 110.134 21.824 109.555 23.143 L 111.211 23.834 C 111.565 23.143 112.224 22.917 112.916 22.917 C 113.881 22.917 114.862 23.496 114.878 24.526 L 114.878 24.654 C 114.54 24.461 113.816 24.172 112.932 24.172 C 111.146 24.172 109.329 25.153 109.329 26.986 C 109.329 28.659 110.793 29.737 112.433 29.737 C 113.687 29.737 114.38 29.174 114.813 28.514 L 114.878 28.514 L 114.878 29.48 L 116.68 29.48 L 116.68 24.686 C 116.68 22.467 115.022 21.229 112.884 21.229 Z M 101.353 23.024 L 98.698 23.024 L 98.698 18.739 L 101.353 18.739 C 102.747 18.739 103.539 19.893 103.539 20.881 C 103.539 21.85 102.747 23.024 101.353 23.024 Z M 101.305 16.999 L 96.833 16.999 L 96.833 29.5 L 98.698 29.5 L 98.698 24.764 L 101.305 24.764 C 103.373 24.764 105.405 23.267 105.405 20.881 C 105.405 18.496 103.373 16.999 101.305 16.999 Z M 76.923 28.083 C 75.633 28.083 74.555 27.003 74.555 25.521 C 74.555 24.022 75.633 22.927 76.923 22.927 C 78.195 22.927 79.194 24.022 79.194 25.521 C 79.194 27.003 78.195 28.083 76.923 28.083 Z M 79.065 22.202 L 79.001 22.202 C 78.582 21.703 77.776 21.251 76.761 21.251 C 74.635 21.251 72.685 23.121 72.685 25.521 C 72.685 27.905 74.635 29.758 76.761 29.758 C 77.776 29.758 78.582 29.307 79.001 28.791 L 79.065 28.791 L 79.065 29.403 C 79.065 31.031 78.195 31.901 76.793 31.901 C 75.65 31.901 74.941 31.079 74.651 30.386 L 73.024 31.063 C 73.491 32.19 74.731 33.576 76.793 33.576 C 78.985 33.576 80.838 32.287 80.838 29.145 L 80.838 21.509 L 79.065 21.509 Z M 82.127 29.5 L 83.995 29.5 L 83.995 16.999 L 82.127 16.999 Z M 86.75 25.376 C 86.702 23.733 88.023 22.895 88.973 22.895 C 89.715 22.895 90.343 23.265 90.553 23.797 Z M 92.549 23.958 C 92.195 23.008 91.116 21.251 88.909 21.251 C 86.717 21.251 84.897 22.975 84.897 25.505 C 84.897 27.889 86.702 29.758 89.118 29.758 C 91.067 29.758 92.195 28.566 92.663 27.873 L 91.213 26.906 C 90.729 27.615 90.069 28.083 89.118 28.083 C 88.168 28.083 87.491 27.647 87.057 26.793 L 92.743 24.441 Z M 47.242 22.557 L 47.242 24.361 L 51.559 24.361 C 51.431 25.376 51.092 26.117 50.577 26.633 C 49.948 27.261 48.965 27.953 47.242 27.953 C 44.583 27.953 42.505 25.811 42.505 23.153 C 42.505 20.495 44.583 18.351 47.242 18.351 C 48.675 18.351 49.723 18.915 50.496 19.641 L 51.769 18.367 C 50.689 17.337 49.256 16.547 47.242 16.547 C 43.6 16.547 40.539 19.512 40.539 23.153 C 40.539 26.793 43.6 29.758 47.242 29.758 C 49.207 29.758 50.689 29.113 51.849 27.905 C 53.041 26.713 53.412 25.037 53.412 23.684 C 53.412 23.265 53.379 22.879 53.315 22.557 Z M 58.321 28.083 C 57.031 28.083 55.92 27.019 55.92 25.505 C 55.92 23.974 57.031 22.927 58.321 22.927 C 59.609 22.927 60.721 23.974 60.721 25.505 C 60.721 27.019 59.609 28.083 58.321 28.083 Z M 58.321 21.251 C 55.968 21.251 54.051 23.04 54.051 25.505 C 54.051 27.953 55.968 29.758 58.321 29.758 C 60.673 29.758 62.59 27.953 62.59 25.505 C 62.59 23.04 60.673 21.251 58.321 21.251 Z M 67.633 28.083 C 66.345 28.083 65.233 27.019 65.233 25.505 C 65.233 23.974 66.345 22.927 67.633 22.927 C 68.923 22.927 70.034 23.974 70.034 25.505 C 70.034 27.019 68.923 28.083 67.633 28.083 Z M 67.633 21.251 C 65.281 21.251 63.365 23.04 63.365 25.505 C 63.365 27.953 65.281 29.758 67.633 29.758 C 69.986 29.758 71.903 27.953 71.903 25.505 C 71.903 23.04 69.986 21.251 67.633 21.251 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 43.977 12.735 C 43.08 12.735 42.309 12.419 41.687 11.797 C 41.065 11.175 40.75 10.396 40.75 9.491 C 40.75 8.585 41.065 7.807 41.687 7.184 C 42.309 6.562 43.08 6.247 43.977 6.247 C 44.433 6.247 44.859 6.326 45.267 6.49 C 45.675 6.654 46.008 6.883 46.271 7.181 L 46.332 7.251 L 45.633 7.951 L 45.563 7.865 C 45.389 7.651 45.167 7.485 44.887 7.364 C 44.607 7.243 44.301 7.187 43.977 7.187 C 43.345 7.187 42.821 7.402 42.383 7.838 C 41.955 8.283 41.741 8.824 41.741 9.491 C 41.741 10.157 41.956 10.699 42.384 11.144 C 42.821 11.58 43.345 11.795 43.977 11.795 C 44.555 11.795 45.033 11.634 45.409 11.315 C 45.759 11.017 45.969 10.615 46.043 10.103 L 43.877 10.103 L 43.877 9.181 L 46.979 9.181 L 46.993 9.265 C 47.018 9.428 47.036 9.584 47.036 9.735 C 47.036 10.595 46.773 11.297 46.259 11.813 C 45.678 12.429 44.915 12.735 43.977 12.735 Z M 70.918 12.735 C 70.021 12.735 69.258 12.419 68.645 11.797 C 68.645 11.797 68.644 11.797 68.644 11.797 C 68.029 11.182 67.725 10.403 67.725 9.491 C 67.725 8.578 68.029 7.799 68.644 7.185 C 68.644 7.184 68.644 7.184 68.644 7.184 C 69.257 6.563 70.021 6.247 70.918 6.247 C 71.815 6.247 72.577 6.563 73.191 7.193 C 73.805 7.808 74.111 8.585 74.111 9.491 C 74.111 10.403 73.805 11.182 73.191 11.797 C 72.577 12.419 71.807 12.735 70.918 12.735 Z M 47.924 12.6 L 47.924 6.381 L 48.024 6.381 L 51.638 6.381 L 51.638 7.322 L 48.897 7.322 L 48.897 9.03 L 51.369 9.03 L 51.369 9.951 L 48.897 9.951 L 48.897 11.661 L 51.638 11.661 L 51.638 12.6 Z M 53.911 12.6 L 53.911 7.322 L 52.229 7.322 L 52.229 6.381 L 56.565 6.381 L 56.565 7.322 L 56.465 7.322 L 54.884 7.322 L 54.884 12.6 Z M 59.337 12.6 L 59.337 6.381 L 60.31 6.381 L 60.31 6.481 L 60.31 12.6 Z M 62.761 12.6 L 62.761 7.322 L 61.079 7.322 L 61.079 6.381 L 65.415 6.381 L 65.415 7.322 L 65.315 7.322 L 63.734 7.322 L 63.734 12.6 Z M 74.975 12.6 L 74.975 6.381 L 76.072 6.381 L 78.866 10.853 L 78.842 10.005 L 78.842 6.381 L 79.815 6.381 L 79.815 12.6 L 78.852 12.6 L 75.924 7.902 L 75.948 8.75 L 75.948 8.751 L 75.948 12.6 Z M 70.918 11.795 C 71.55 11.795 72.065 11.58 72.485 11.145 L 72.486 11.144 L 72.487 11.143 C 72.913 10.717 73.121 10.168 73.121 9.491 C 73.121 8.815 72.913 8.264 72.487 7.838 L 72.486 7.837 L 72.485 7.837 C 72.065 7.401 71.55 7.187 70.918 7.187 C 70.285 7.187 69.77 7.401 69.342 7.836 L 69.342 7.837 C 68.923 8.273 68.715 8.815 68.715 9.491 C 68.715 10.168 68.923 10.708 69.342 11.145 C 69.77 11.58 70.286 11.795 70.918 11.795 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 20.215 18.923 L 9.568 30.223 C 9.569 30.225 9.569 30.227 9.569 30.23 C 9.896 31.457 11.017 32.361 12.347 32.361 C 12.879 32.361 13.378 32.217 13.806 31.964 L 13.84 31.944 L 25.824 25.029 Z"
                fill="rgb(234,67,53)"
              />
              <path
                d="M 30.987 16.999 L 30.977 16.993 L 25.803 13.993 L 19.974 19.18 L 25.823 25.028 L 30.97 22.059 C 31.872 21.572 32.485 20.621 32.485 19.523 C 32.485 18.435 31.88 17.488 30.987 16.999 Z"
                fill="rgb(251,188,4)"
              />
              <path
                d="M 9.566 8.777 C 9.502 9.013 9.469 9.26 9.469 9.517 L 9.469 29.484 C 9.469 29.741 9.502 29.989 9.567 30.223 L 20.579 19.213 Z"
                fill="rgb(66,133,244)"
              />
              <path
                d="M 20.294 19.5 L 25.804 13.991 L 13.834 7.051 C 13.399 6.79 12.891 6.64 12.347 6.64 C 11.017 6.64 9.895 7.545 9.569 8.773 C 9.568 8.775 9.568 8.775 9.568 8.777 Z"
                fill="rgb(52,168,83)"
              />
            </g>
          </svg>
          <svg viewBox="0 0 173 50" overflow="visible" id="svg922906930_7792">
            <g>
              <path
                d="M 5.81 50 C 2.601 50 0 47.417 0 44.231 L 0 5.769 C 0 2.583 2.601 0 5.81 0 L 167.19 0 C 170.399 0 173 2.583 173 5.769 L 173 44.231 C 173 47.417 170.399 50 167.19 50 Z"
                fill="rgb(0,0,0)"
              />
              <path
                d="M 5.81 50 C 2.601 50 0 47.417 0 44.231 L 0 5.769 C 0 2.583 2.601 0 5.81 0 L 167.19 0 C 170.399 0 173 2.583 173 5.769 L 173 44.231 C 173 47.417 170.399 50 167.19 50 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 137.411 37.821 L 139.82 37.821 L 139.82 21.793 L 137.411 21.793 Z M 159.11 27.567 L 156.349 34.515 L 156.266 34.515 L 153.4 27.567 L 150.805 27.567 L 155.104 37.279 L 152.652 42.681 L 155.165 42.681 L 161.789 27.567 Z M 145.447 36 C 144.66 36 143.558 35.608 143.558 34.639 C 143.558 33.402 144.929 32.927 146.112 32.927 C 147.171 32.927 147.671 33.154 148.314 33.463 C 148.126 34.949 146.839 36 145.447 36 Z M 145.738 27.216 C 143.995 27.216 142.188 27.979 141.441 29.67 L 143.579 30.556 C 144.036 29.67 144.886 29.381 145.78 29.381 C 147.026 29.381 148.292 30.123 148.313 31.444 L 148.313 31.608 C 147.876 31.361 146.942 30.99 145.8 30.99 C 143.494 30.99 141.149 32.247 141.149 34.597 C 141.149 36.743 143.039 38.124 145.156 38.124 C 146.775 38.124 147.67 37.403 148.229 36.556 L 148.313 36.556 L 148.313 37.795 L 150.639 37.795 L 150.639 31.649 C 150.639 28.803 148.499 27.216 145.738 27.216 Z M 130.851 29.518 L 127.424 29.518 L 127.424 24.024 L 130.851 24.024 C 132.651 24.024 133.674 25.504 133.674 26.771 C 133.674 28.013 132.651 29.518 130.851 29.518 Z M 130.789 21.793 L 125.015 21.793 L 125.015 37.821 L 127.424 37.821 L 127.424 31.749 L 130.789 31.749 C 133.459 31.749 136.083 29.829 136.083 26.771 C 136.083 23.713 133.459 21.793 130.789 21.793 Z M 99.311 36.003 C 97.646 36.003 96.253 34.619 96.253 32.72 C 96.253 30.797 97.646 29.394 99.311 29.394 C 100.954 29.394 102.243 30.797 102.243 32.72 C 102.243 34.619 100.954 36.003 99.311 36.003 Z M 102.077 28.464 L 101.993 28.464 C 101.453 27.824 100.412 27.245 99.102 27.245 C 96.357 27.245 93.84 29.642 93.84 32.72 C 93.84 35.776 96.357 38.151 99.102 38.151 C 100.412 38.151 101.453 37.573 101.993 36.912 L 102.077 36.912 L 102.077 37.697 C 102.077 39.783 100.954 40.898 99.144 40.898 C 97.668 40.898 96.753 39.844 96.378 38.956 L 94.277 39.824 C 94.88 41.269 96.481 43.046 99.144 43.046 C 101.974 43.046 104.365 41.394 104.365 37.366 L 104.365 27.576 L 102.077 27.576 Z M 106.029 37.821 L 108.441 37.821 L 108.441 21.793 L 106.029 21.793 Z M 111.998 32.533 C 111.936 30.426 113.642 29.352 114.869 29.352 C 115.826 29.352 116.636 29.827 116.908 30.509 Z M 119.485 30.715 C 119.028 29.497 117.635 27.245 114.785 27.245 C 111.956 27.245 109.606 29.456 109.606 32.698 C 109.606 35.756 111.936 38.151 115.055 38.151 C 117.572 38.151 119.028 36.623 119.632 35.735 L 117.76 34.495 C 117.136 35.404 116.284 36.003 115.055 36.003 C 113.829 36.003 112.954 35.445 112.394 34.35 L 119.735 31.335 Z M 60.992 28.919 L 60.992 31.232 L 66.565 31.232 C 66.399 32.533 65.962 33.483 65.297 34.144 C 64.485 34.95 63.216 35.838 60.992 35.838 C 57.559 35.838 54.876 33.091 54.876 29.683 C 54.876 26.275 57.559 23.527 60.992 23.527 C 62.842 23.527 64.194 24.25 65.193 25.18 L 66.837 23.548 C 65.442 22.226 63.592 21.215 60.992 21.215 C 56.29 21.215 52.338 25.015 52.338 29.683 C 52.338 34.35 56.29 38.151 60.992 38.151 C 63.528 38.151 65.442 37.325 66.94 35.776 C 68.479 34.247 68.957 32.099 68.957 30.364 C 68.957 29.827 68.915 29.332 68.832 28.919 Z M 75.295 36.003 C 73.63 36.003 72.195 34.64 72.195 32.698 C 72.195 30.736 73.63 29.394 75.295 29.394 C 76.958 29.394 78.393 30.736 78.393 32.698 C 78.393 34.64 76.958 36.003 75.295 36.003 Z M 75.295 27.245 C 72.257 27.245 69.783 29.538 69.783 32.698 C 69.783 35.838 72.257 38.151 75.295 38.151 C 78.331 38.151 80.806 35.838 80.806 32.698 C 80.806 29.538 78.331 27.245 75.295 27.245 Z M 87.318 36.003 C 85.655 36.003 84.219 34.64 84.219 32.698 C 84.219 30.736 85.655 29.394 87.318 29.394 C 88.982 29.394 90.417 30.736 90.417 32.698 C 90.417 34.64 88.982 36.003 87.318 36.003 Z M 87.318 27.245 C 84.281 27.245 81.807 29.538 81.807 32.698 C 81.807 35.838 84.281 38.151 87.318 38.151 C 90.355 38.151 92.83 35.838 92.83 32.698 C 92.83 29.538 90.355 27.245 87.318 27.245 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 56.776 16.326 C 55.618 16.326 54.622 15.921 53.82 15.125 C 53.017 14.327 52.61 13.328 52.61 12.168 C 52.61 11.006 53.017 10.009 53.82 9.21 C 54.622 8.413 55.618 8.009 56.776 8.009 C 57.365 8.009 57.915 8.11 58.441 8.321 C 58.968 8.531 59.398 8.824 59.738 9.206 L 59.817 9.297 L 58.914 10.193 L 58.824 10.083 C 58.599 9.809 58.313 9.596 57.951 9.441 C 57.59 9.286 57.195 9.215 56.776 9.215 C 55.961 9.215 55.284 9.49 54.719 10.049 C 54.166 10.619 53.889 11.313 53.889 12.168 C 53.889 13.022 54.167 13.717 54.72 14.287 C 55.284 14.846 55.961 15.122 56.776 15.122 C 57.522 15.122 58.139 14.915 58.625 14.506 C 59.076 14.125 59.348 13.609 59.443 12.953 L 56.647 12.953 L 56.647 11.771 L 60.652 11.771 L 60.67 11.879 C 60.702 12.087 60.726 12.287 60.726 12.48 C 60.726 13.583 60.386 14.483 59.723 15.145 C 58.972 15.935 57.987 16.326 56.776 16.326 Z M 91.558 16.326 C 90.4 16.326 89.415 15.921 88.623 15.125 C 88.623 15.125 88.622 15.125 88.622 15.124 C 87.829 14.336 87.436 13.338 87.436 12.168 C 87.436 10.997 87.829 9.999 88.622 9.211 C 88.622 9.21 88.622 9.21 88.622 9.21 C 89.414 8.414 90.4 8.009 91.558 8.009 C 92.716 8.009 93.7 8.414 94.492 9.222 C 95.286 10.01 95.68 11.007 95.68 12.168 C 95.68 13.338 95.286 14.336 94.492 15.124 C 93.7 15.921 92.706 16.326 91.558 16.326 Z M 61.872 16.154 L 61.872 8.181 L 62.001 8.181 L 66.667 8.181 L 66.667 9.387 L 63.129 9.387 L 63.129 11.577 L 66.32 11.577 L 66.32 12.758 L 63.129 12.758 L 63.129 14.95 L 66.667 14.95 L 66.667 16.154 Z M 69.601 16.154 L 69.601 9.387 L 67.43 9.387 L 67.43 8.181 L 73.028 8.181 L 73.028 9.387 L 72.899 9.387 L 70.858 9.387 L 70.858 16.154 Z M 76.606 16.154 L 76.606 8.181 L 77.863 8.181 L 77.863 8.309 L 77.863 16.154 Z M 81.027 16.154 L 81.027 9.387 L 78.856 9.387 L 78.856 8.181 L 84.454 8.181 L 84.454 9.387 L 84.325 9.387 L 82.283 9.387 L 82.283 16.154 Z M 96.796 16.154 L 96.796 8.181 L 98.212 8.181 L 101.82 13.915 L 101.789 12.826 L 101.789 8.181 L 103.045 8.181 L 103.045 16.154 L 101.801 16.154 L 98.021 10.131 L 98.052 11.218 L 98.052 11.22 L 98.052 16.154 Z M 91.558 15.122 C 92.374 15.122 93.04 14.846 93.582 14.288 L 93.583 14.287 L 93.584 14.286 C 94.134 13.74 94.403 13.036 94.403 12.168 C 94.403 11.301 94.134 10.595 93.584 10.049 L 93.583 10.048 L 93.582 10.047 C 93.04 9.489 92.374 9.215 91.558 9.215 C 90.742 9.215 90.076 9.489 89.524 10.046 L 89.524 10.047 C 88.983 10.607 88.715 11.301 88.715 12.168 C 88.715 13.036 88.983 13.728 89.524 14.288 C 90.076 14.846 90.742 15.122 91.558 15.122 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 26.098 24.261 L 12.353 38.748 C 12.354 38.75 12.354 38.753 12.354 38.756 C 12.776 40.329 14.223 41.488 15.94 41.488 C 16.627 41.488 17.272 41.303 17.824 40.979 L 17.868 40.954 L 33.34 32.089 Z"
                fill="rgb(234,67,53)"
              />
              <path
                d="M 40.005 21.794 L 39.992 21.785 L 33.312 17.94 L 25.787 24.59 L 33.339 32.087 L 39.984 28.28 C 41.148 27.656 41.939 26.437 41.939 25.03 C 41.939 23.634 41.159 22.421 40.005 21.794 Z"
                fill="rgb(251,188,4)"
              />
              <path
                d="M 12.35 11.252 C 12.268 11.555 12.224 11.872 12.224 12.201 L 12.224 37.8 C 12.224 38.129 12.268 38.447 12.351 38.748 L 26.569 24.632 Z"
                fill="rgb(66,133,244)"
              />
              <path
                d="M 26.2 25 L 33.314 17.938 L 17.86 9.039 C 17.298 8.705 16.642 8.513 15.941 8.513 C 14.224 8.513 12.775 9.673 12.354 11.248 C 12.353 11.25 12.353 11.25 12.353 11.252 Z"
                fill="rgb(52,168,83)"
              />
            </g>
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg-1209903461_9010"
          >
            <mask
              id="svg-1209903461_9010_mask0_1696_467"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="47"
              height="35"
            >
              <path d="M0 0H46.2245V34.6667H0V0Z" fill="white" />
            </mask>
            <g mask="url(#svg-1209903461_9010_mask0_1696_467)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H65.8667V2.66771H0V0ZM0 5.33542H65.8667V8.00313H0V5.33542ZM0 10.6641H65.8667V13.3385H0V10.6641ZM0 15.9995H65.8667V18.6672H0V15.9995ZM0 21.3349H65.8667V24.0026H0V21.3349ZM0 26.6635H65.8667V29.3313H0V26.6635ZM0 31.999H65.8667V34.6667H0V31.999Z"
                fill="#BD3D44"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.66772H65.8667V5.33543H0V2.66772ZM0 8.00314H65.8667V10.6641H0V8.00314ZM0 13.3318H65.8667V15.9995H0V13.3318ZM0 18.6672H65.8667V21.3349H0V18.6672ZM0 24.0026H65.8667V26.6703H0V24.0026ZM0 29.3313H65.8667V31.999H0V29.3313Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H26.3453V18.6672H0V0Z"
                fill="#192F5D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.19531 0.79895L2.43906 1.53697H3.21094L2.58802 1.99062L2.825 2.73541L2.19531 2.27499L1.5724 2.72864L1.80938 1.99062L1.17969 1.53697H1.9651L2.19531 0.79895ZM6.58958 0.79895L6.82656 1.53697H7.60521L6.97552 1.99062L7.2125 2.73541L6.58958 2.27499L5.9599 2.72864L6.19688 1.99062L5.57396 1.53697H6.34583L6.58958 0.79895ZM10.9771 0.79895L11.2208 1.53697H11.9859L11.363 1.99062L11.6 2.73541L10.9703 2.27499L10.3474 2.72864L10.5844 1.99062L9.95469 1.53697H10.7333L10.9771 0.79895ZM15.3714 0.79895L15.6083 1.53697H16.387L15.7573 1.99062L16.001 2.73541L15.3714 2.27499L14.7417 2.72864L14.9854 1.99062L14.3557 1.53697H15.1276L15.3714 0.79895ZM19.7589 0.79895L20.0026 1.53697H20.7745L20.1516 1.99062L20.3885 2.73541L19.7589 2.27499L19.1359 2.72864L19.3729 1.99062L18.75 1.53697H19.5219L19.7589 0.79895ZM24.1531 0.79895L24.3901 1.53697H25.1688L24.5391 1.99062L24.7828 2.73541L24.1531 2.27499L23.5234 2.72864L23.7672 1.99062L23.1375 1.53697H23.9161L24.1531 0.79895ZM4.39583 2.6677L4.63281 3.40572H5.41146L4.78177 3.85937L5.01198 4.59739L4.4026 4.14374L3.77292 4.59739L3.99635 3.85937L3.38698 3.40572H4.15885L4.39583 2.6677ZM8.78333 2.6677L9.02708 3.40572H9.79896L9.16927 3.85937L9.41302 4.59739L8.78333 4.14374L8.15365 4.59739L8.3974 3.85937L7.76771 3.40572H8.54635L8.78333 2.6677ZM13.1776 2.6677L13.4146 3.40572H14.1932L13.5635 3.85937L13.8005 4.59739L13.1776 4.14374L12.5479 4.59739L12.7849 3.85937L12.162 3.40572H12.9339L13.1776 2.6677ZM17.5651 2.6677L17.8089 3.40572H18.5807L17.951 3.85937L18.1948 4.59739L17.5651 4.14374L16.9422 4.59739L17.1792 3.85937L16.5495 3.40572H17.3349L17.5651 2.6677ZM21.9594 2.6677L22.1964 3.40572H22.975L22.3453 3.85937L22.5823 4.59739L21.9594 4.14374L21.3297 4.59739L21.5667 3.85937L20.9438 3.40572H21.7156L21.9594 2.6677ZM2.19531 4.52968L2.43906 5.28124H3.21094L2.58802 5.73489L2.825 6.47291L2.19531 6.01249L1.5724 6.47291L1.80938 5.72812L1.17969 5.27447H1.9651L2.19531 4.52968ZM6.58958 4.52968L6.82656 5.27447H7.60521L6.97552 5.72812L7.2125 6.46614L6.58958 6.00572L5.9599 6.46614L6.19688 5.72135L5.57396 5.2677H6.34583L6.58958 4.52968ZM10.9771 4.52968L11.2208 5.27447H11.9859L11.363 5.72812L11.6 6.46614L10.9703 6.00572L10.3474 6.46614L10.5844 5.72135L9.95469 5.2677H10.7333L10.9771 4.52968ZM15.3714 4.52968L15.6083 5.27447H16.387L15.7573 5.72812L16.001 6.46614L15.3714 6.00572L14.7417 6.46614L14.9854 5.72135L14.3557 5.2677H15.1276L15.3714 4.52968ZM19.7589 4.52968L20.0026 5.27447H20.7745L20.1516 5.72812L20.3885 6.46614L19.7589 6.00572L19.1359 6.46614L19.3729 5.72135L18.75 5.2677H19.5219L19.7589 4.52968ZM24.1531 4.52968L24.3901 5.27447H25.1688L24.5391 5.72812L24.7828 6.46614L24.1531 6.00572L23.5234 6.46614L23.7672 5.72135L23.1375 5.2677H23.9161L24.1531 4.52968ZM4.39583 6.39843L4.63281 7.13645H5.41146L4.78177 7.5901L5.01875 8.33489L4.39583 7.87447L3.76615 8.32812L4.00312 7.5901L3.38021 7.13645H4.15208L4.39583 6.39843ZM8.78333 6.39843L9.02708 7.13645H9.79896L9.16927 7.5901L9.41302 8.33489L8.78333 7.87447L8.15365 8.32812L8.3974 7.5901L7.76771 7.13645H8.54635L8.78333 6.39843ZM13.1776 6.39843L13.4146 7.13645H14.1932L13.5635 7.5901L13.8005 8.33489L13.1776 7.87447L12.5479 8.32812L12.7849 7.5901L12.162 7.13645H12.9339L13.1776 6.39843ZM17.5651 6.39843L17.8089 7.13645H18.5807L17.9578 7.5901L18.1948 8.33489L17.5651 7.87447L16.9422 8.32812L17.1792 7.5901L16.5495 7.13645H17.3349L17.5651 6.39843ZM21.9594 6.39843L22.1964 7.13645H22.975L22.3453 7.5901L22.5823 8.33489L21.9594 7.87447L21.3297 8.32812L21.5667 7.5901L20.9438 7.13645H21.7156L21.9594 6.39843ZM2.19531 8.26718L2.43906 9.0052H3.21094L2.58802 9.45884L2.825 10.2036L2.19531 9.74322L1.5724 10.1969L1.80938 9.45884L1.17969 9.0052H1.9651L2.19531 8.26718ZM6.58958 8.26718L6.82656 9.0052H7.60521L6.97552 9.45884L7.2125 10.1969L6.58958 9.74322L5.9599 10.1969L6.19688 9.45884L5.57396 9.0052H6.34583L6.58958 8.26718ZM10.9771 8.26718L11.2208 9.0052H11.9859L11.363 9.45884L11.6 10.2036L10.9703 9.74322L10.3474 10.1969L10.5844 9.45884L9.95469 9.0052H10.7333L10.9771 8.26718ZM15.3714 8.26718L15.6083 9.0052H16.387L15.7573 9.45884L16.001 10.2036L15.3714 9.74322L14.7417 10.1969L14.9854 9.45884L14.3557 9.0052H15.1276L15.3714 8.26718ZM19.7589 8.26718L20.0026 9.0052H20.7745L20.1516 9.45884L20.3885 10.2036L19.7589 9.74322L19.1359 10.1969L19.3729 9.45884L18.75 9.0052H19.5219L19.7589 8.26718ZM24.1531 8.26718L24.3901 9.0052H25.1688L24.5391 9.45884L24.7828 10.2036L24.1531 9.74322L23.5234 10.1969L23.7672 9.45884L23.1375 9.0052H23.9161L24.1531 8.26718ZM4.39583 10.1359L4.63281 10.8739H5.41146L4.78177 11.3276L5.01875 12.0656L4.39583 11.6052L3.76615 12.0656L4.00312 11.3208L3.38021 10.8672H4.15208L4.39583 10.1359ZM8.78333 10.1359L9.02708 10.8739H9.79896L9.16927 11.3276L9.41302 12.0656L8.78333 11.6052L8.15365 12.0656L8.3974 11.3208L7.76771 10.8672H8.54635L8.78333 10.1359ZM13.1776 10.1359L13.4146 10.8739H14.1932L13.5635 11.3276L13.8005 12.0656L13.1776 11.6052L12.5479 12.0656L12.7849 11.3208L12.162 10.8672H12.9339L13.1776 10.1359ZM17.5651 10.1359L17.8089 10.8739H18.5807L17.9578 11.3276L18.1948 12.0656L17.5651 11.6052L16.9422 12.0656L17.1792 11.3208L16.5495 10.8672H17.3349L17.5651 10.1359ZM21.9594 10.1359L22.1964 10.8739H22.975L22.3453 11.3276L22.5823 12.0656L21.9594 11.6052L21.3297 12.0656L21.5667 11.3208L20.9438 10.8672H21.7156L21.9594 10.1359ZM2.19531 11.9979L2.43906 12.7427H3.21094L2.58802 13.1963L2.825 13.9276L2.19531 13.4739L1.5724 13.9276L1.80938 13.1896L1.17969 12.7359H1.9651L2.19531 11.9979ZM6.58958 11.9979L6.82656 12.7427H7.60521L6.97552 13.1963L7.21927 13.9276L6.58958 13.4739L5.9599 13.9276L6.20365 13.1896L5.57396 12.7359H6.34583L6.58958 11.9979ZM10.9771 11.9979L11.2208 12.7427H11.9859L11.363 13.1963L11.6 13.9276L10.9703 13.4739L10.3474 13.9276L10.5844 13.1896L9.95469 12.7359H10.7333L10.9771 11.9979ZM15.3714 11.9979L15.6083 12.7427H16.387L15.7573 13.1963L16.001 13.9276L15.3714 13.4739L14.7417 13.9276L14.9854 13.1896L14.3557 12.7359H15.1276L15.3714 11.9979ZM19.7589 11.9979L20.0026 12.7427H20.7745L20.1516 13.1963L20.3885 13.9276L19.7589 13.4739L19.1359 13.9276L19.3729 13.1896L18.75 12.7359H19.5219L19.7589 11.9979ZM24.1531 11.9979L24.3901 12.7427H25.1688L24.5391 13.1963L24.7828 13.9276L24.1531 13.4739L23.5234 13.9276L23.7672 13.1896L23.1375 12.7359H23.9161L24.1531 11.9979ZM4.39583 13.8667L4.63281 14.6047H5.41146L4.78177 15.0583L5.01875 15.8031L4.39583 15.3427L3.76615 15.7963L4.00312 15.0583L3.38021 14.6047H4.15208L4.39583 13.8667ZM8.78333 13.8667L9.02708 14.6047H9.79896L9.16927 15.0583L9.41302 15.8031L8.78333 15.3427L8.15365 15.7963L8.3974 15.0583L7.76771 14.6047H8.54635L8.78333 13.8667ZM13.1776 13.8667L13.4146 14.6047H14.1932L13.5635 15.0583L13.8005 15.8031L13.1776 15.3427L12.5479 15.7963L12.7849 15.0583L12.162 14.6047H12.9339L13.1776 13.8667ZM17.5651 13.8667L17.8089 14.6047H18.5807L17.9578 15.0583L18.1948 15.8031L17.5651 15.3427L16.9422 15.7963L17.1792 15.0583L16.5495 14.6047H17.3349L17.5651 13.8667ZM21.9594 13.8667L22.1964 14.6047H22.975L22.3453 15.0583L22.5823 15.8031L21.9594 15.3427L21.3297 15.7963L21.5667 15.0583L20.9438 14.6047H21.7156L21.9594 13.8667ZM2.19531 15.7354L2.43906 16.4734H3.21094L2.58802 16.9271L2.825 17.6651L2.19531 17.2114L1.5724 17.6651L1.80938 16.9203L1.17969 16.4667H1.9651L2.19531 15.7354ZM6.58958 15.7354L6.82656 16.4734H7.60521L6.97552 16.9271L7.21927 17.6651L6.58958 17.2114L5.9599 17.6651L6.20365 16.9203L5.57396 16.4667H6.34583L6.58958 15.7354ZM10.9771 15.7354L11.2208 16.4734H11.9859L11.3766 16.9271L11.6135 17.6651L10.9839 17.2114L10.3609 17.6651L10.5979 16.9203L9.96823 16.4667H10.7469L10.9771 15.7354ZM15.3714 15.7354L15.6083 16.4734H16.387L15.7573 16.9271L16.001 17.6651L15.3714 17.2114L14.7417 17.6651L14.9854 16.9203L14.3557 16.4667H15.1276L15.3714 15.7354ZM19.7589 15.7354L20.0026 16.4734H20.7745L20.1516 16.9271L20.3885 17.6651L19.7589 17.2114L19.1359 17.6651L19.3729 16.9203L18.75 16.4667H19.5219L19.7589 15.7354ZM24.1531 15.7354L24.3901 16.4734H25.1688L24.5391 16.9271L24.7828 17.6651L24.1531 17.2114L23.5234 17.6651L23.7672 16.9203L23.1375 16.4667H23.9161L24.1531 15.7354Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg-77748519_156"
          >
            <path d="M0 0H46.2222V34.6667H0V0Z" fill="#012169" />
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg2125279330_305"
          >
            <path
              d="M5.41667 0L23.0389 13.0722L40.5889 0H46.2222V4.47778L28.8889 17.4056L46.2222 30.2611V34.6667H40.4444L23.1111 21.7389L5.85 34.6667H0V30.3333L17.2611 17.4778L0 4.62222V0H5.41667Z"
              fill="white"
            />
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg994370299_368"
          >
            <path
              d="M30.6222 20.2944L46.2222 31.7778V34.6667L26.65 20.2944H30.6222ZM17.3333 21.7389L17.7667 24.2667L3.9 34.6667H0L17.3333 21.7389ZM46.2222 0V0.216667L28.2389 13.7944L28.3833 10.6167L42.6111 0H46.2222ZM0 0L17.2611 12.7111H12.9278L0 3.03333V0Z"
              fill="#C8102E"
            />
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg-1148296261_203"
          >
            <path
              d="M17.4056 0V34.6667H28.9611V0H17.4056ZM0 11.5556V23.1111H46.2222V11.5556H0Z"
              fill="white"
            />
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg-29915228_203"
          >
            <path
              d="M0 13.9389V20.8722H46.2222V13.9389H0ZM19.7167 0V34.6667H26.65V0H19.7167Z"
              fill="#C8102E"
            />
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg49011196_156"
          >
            <path d="M0 0H46.2222V34.6667H0V0Z" fill="#003399" />
          </svg>
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            id="svg-873981876_11120"
          >
            <path
              d="M12.0605 0L11.5469 1.71193L12.4028 1.88313L12.0605 0Z"
              fill="#FFCC00"
            />
            <path
              d="M12.0606 0L12.5742 1.71193L11.7183 1.88313L12.0606 0Z"
              fill="#FFCC00"
            />
            <path
              d="M13.69 1.1829L11.9031 1.22347L12.0048 2.09045L13.69 1.1829Z"
              fill="#FFCC00"
            />
            <path
              d="M13.689 1.18294L12.2195 2.2004L11.7922 1.43923L13.689 1.18294Z"
              fill="#FFCC00"
            />
            <path
              d="M13.065 3.09692L12.4742 1.41006L11.6811 1.77469L13.065 3.09692Z"
              fill="#FFCC00"
            />
            <path
              d="M13.0639 3.09693L11.6422 2.01382L12.2341 1.3722L13.0639 3.09693Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4311 1.1829L12.218 1.22347L12.1163 2.09045L10.4311 1.1829Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4321 1.18294L11.9016 2.2004L12.3289 1.43923L10.4321 1.18294Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0561 3.09692L11.6469 1.41006L12.44 1.77469L11.0561 3.09692Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0572 3.09693L12.4789 2.01382L11.887 1.3722L11.0572 3.09693Z"
              fill="#FFCC00"
            />
            <path
              d="M12.0605 20.5432L11.5469 22.2551L12.4028 22.4263L12.0605 20.5432Z"
              fill="#FFCC00"
            />
            <path
              d="M12.0606 20.5432L12.5742 22.2551L11.7183 22.4263L12.0606 20.5432Z"
              fill="#FFCC00"
            />
            <path
              d="M13.69 21.7261L11.9031 21.7667L12.0048 22.6337L13.69 21.7261Z"
              fill="#FFCC00"
            />
            <path
              d="M13.689 21.7262L12.2195 22.7436L11.7922 21.9824L13.689 21.7262Z"
              fill="#FFCC00"
            />
            <path
              d="M13.065 23.6401L12.4742 21.9533L11.6811 22.3179L13.065 23.6401Z"
              fill="#FFCC00"
            />
            <path
              d="M13.0639 23.6401L11.6422 22.557L12.2341 21.9154L13.0639 23.6401Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4311 21.7261L12.218 21.7667L12.1163 22.6337L10.4311 21.7261Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4321 21.7262L11.9016 22.7436L12.3289 21.9824L10.4321 21.7262Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0561 23.6401L11.6469 21.9533L12.44 22.3179L11.0561 23.6401Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0572 23.6401L12.4789 22.557L11.887 21.9154L11.0572 23.6401Z"
              fill="#FFCC00"
            />
            <path
              d="M1.78702 10.2716L1.27344 11.9835L2.1294 12.1547L1.78702 10.2716Z"
              fill="#FFCC00"
            />
            <path
              d="M1.7872 10.2716L2.30078 11.9835L1.44481 12.1547L1.7872 10.2716Z"
              fill="#FFCC00"
            />
            <path
              d="M3.41652 11.4545L1.62967 11.4951L1.73136 12.3621L3.41652 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M3.41551 11.4545L1.94607 12.472L1.51875 11.7108L3.41551 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M2.79154 13.3685L2.20078 11.6817L1.40767 12.0463L2.79154 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M2.7905 13.3685L1.36875 12.2854L1.96062 11.6438L2.7905 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M0.157701 11.4545L1.94455 11.4951L1.84286 12.3621L0.157701 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M0.158705 11.4545L1.62815 12.472L2.05547 11.7108L0.158705 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M0.782683 13.3685L1.37344 11.6817L2.16655 12.0463L0.782683 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M0.783724 13.3685L2.20547 12.2854L1.6136 11.6438L0.783724 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M6.04154 4.55054L7.46328 3.46743L6.87141 2.82581L6.04154 4.55054Z"
              fill="#FFCC00"
            />
            <path
              d="M6.0405 4.55053L6.63125 2.86367L7.42437 3.2283L6.0405 4.55053Z"
              fill="#FFCC00"
            />
            <path
              d="M5.42042 2.63656L6.88986 3.65402L7.31719 2.89285L5.42042 2.63656Z"
              fill="#FFCC00"
            />
            <path
              d="M5.41942 2.63664L7.20627 2.67721L7.10458 3.54418L5.41942 2.63664Z"
              fill="#FFCC00"
            />
            <path
              d="M7.04874 1.45361L6.53516 3.16555L7.39112 3.33674L7.04874 1.45361Z"
              fill="#FFCC00"
            />
            <path
              d="M7.04892 1.45361L7.5625 3.16555L6.70653 3.33674L7.04892 1.45361Z"
              fill="#FFCC00"
            />
            <path
              d="M8.05612 4.55054L6.63438 3.46743L7.22624 2.82581L8.05612 4.55054Z"
              fill="#FFCC00"
            />
            <path
              d="M8.05716 4.55053L7.46641 2.86367L6.67329 3.2283L8.05716 4.55053Z"
              fill="#FFCC00"
            />
            <path
              d="M8.68114 2.63656L7.2117 3.65402L6.78437 2.89285L8.68114 2.63656Z"
              fill="#FFCC00"
            />
            <path
              d="M8.68214 2.63664L6.89529 2.67721L6.99699 3.54418L8.68214 2.63664Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24857 8.35864L3.65781 6.67178L2.8647 7.03641L4.24857 8.35864Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24753 8.35865L2.82578 7.27554L3.41765 6.63392L4.24753 8.35865Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23685 8.35865L3.65859 7.27554L3.06673 6.63392L2.23685 8.35865Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23581 8.35864L2.82656 6.67178L3.61968 7.03641L2.23581 8.35864Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61183 6.44466L3.08127 7.46212L3.50859 6.70095L1.61183 6.44466Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61083 6.44474L3.39768 6.48532L3.29598 7.35229L1.61083 6.44474Z"
              fill="#FFCC00"
            />
            <path
              d="M4.87254 6.44466L3.4031 7.46212L2.97578 6.70095L4.87254 6.44466Z"
              fill="#FFCC00"
            />
            <path
              d="M4.87355 6.44474L3.0867 6.48532L3.18839 7.35229L4.87355 6.44474Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24423 5.26172L3.75781 6.97365L2.90185 7.14485L3.24423 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24405 5.26172L2.73047 6.97365L3.58644 7.14485L3.24405 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M4.86964 16.7409L3.08279 16.7815L3.18449 17.6484L4.86964 16.7409Z"
              fill="#FFCC00"
            />
            <path
              d="M4.86864 16.7409L3.3992 17.7584L2.97187 16.9972L4.86864 16.7409Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24857 18.655L3.65781 16.9682L2.8647 17.3328L4.24857 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24753 18.655L2.82578 17.5719L3.41765 16.9303L4.24753 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23685 18.655L3.65859 17.5719L3.06673 16.9303L2.23685 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23581 18.655L2.82656 16.9682L3.61968 17.3328L2.23581 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24423 15.5581L3.75781 17.27L2.90185 17.4412L3.24423 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24405 15.5581L2.73047 17.27L3.58644 17.4412L3.24405 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61473 16.741L3.40158 16.7816L3.29989 17.6486L1.61473 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61574 16.741L3.08518 17.7585L3.5125 16.9973L1.61574 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M8.58449 20.1867L6.79764 20.2273L6.89933 21.0942L8.58449 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M8.58348 20.1867L7.11404 21.2042L6.68672 20.443L8.58348 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M7.96341 22.1008L7.37266 20.414L6.57954 20.7786L7.96341 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M7.96237 22.1008L6.54063 21.0177L7.13249 20.3761L7.96237 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M5.95169 22.1008L7.37344 21.0177L6.78157 20.3761L5.95169 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M5.95065 22.1008L6.54141 20.414L7.33452 20.7786L5.95065 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M6.95908 19.0039L7.47266 20.7158L6.61669 20.887L6.95908 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M6.95889 19.0039L6.44531 20.7158L7.30128 20.887L6.95889 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M5.32958 20.1868L7.11643 20.2274L7.01473 21.0944L5.32958 20.1868Z"
              fill="#FFCC00"
            />
            <path
              d="M5.33058 20.1868L6.80002 21.2043L7.22734 20.4431L5.33058 20.1868Z"
              fill="#FFCC00"
            />
            <path
              d="M22.3302 10.2716L22.8438 11.9835L21.9878 12.1547L22.3302 10.2716Z"
              fill="#FFCC00"
            />
            <path
              d="M22.33 10.2716L21.8164 11.9835L22.6724 12.1547L22.33 10.2716Z"
              fill="#FFCC00"
            />
            <path
              d="M20.7007 11.4545L22.4875 11.4951L22.3858 12.3621L20.7007 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M20.7017 11.4545L22.1711 12.472L22.5984 11.7108L20.7017 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M21.3257 13.3685L21.9164 11.6817L22.7095 12.0463L21.3257 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M21.3267 13.3685L22.7484 12.2854L22.1566 11.6438L21.3267 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M23.9595 11.4545L22.1726 11.4951L22.2743 12.3621L23.9595 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M23.9585 11.4545L22.489 12.472L22.0617 11.7108L23.9585 11.4545Z"
              fill="#FFCC00"
            />
            <path
              d="M23.3345 13.3685L22.7438 11.6817L21.9506 12.0463L23.3345 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M23.3335 13.3685L21.9117 12.2854L22.5036 11.6438L23.3335 13.3685Z"
              fill="#FFCC00"
            />
            <path
              d="M18.0757 4.55054L16.6539 3.46743L17.2458 2.82581L18.0757 4.55054Z"
              fill="#FFCC00"
            />
            <path
              d="M18.0767 4.55053L17.4859 2.86367L16.6928 3.2283L18.0767 4.55053Z"
              fill="#FFCC00"
            />
            <path
              d="M18.6968 2.63656L17.2273 3.65402L16.8 2.89285L18.6968 2.63656Z"
              fill="#FFCC00"
            />
            <path
              d="M18.6978 2.63664L16.9109 2.67721L17.0126 3.54418L18.6978 2.63664Z"
              fill="#FFCC00"
            />
            <path
              d="M17.0685 1.45361L17.582 3.16555L16.7261 3.33674L17.0685 1.45361Z"
              fill="#FFCC00"
            />
            <path
              d="M17.0683 1.45361L16.5547 3.16555L17.4107 3.33674L17.0683 1.45361Z"
              fill="#FFCC00"
            />
            <path
              d="M16.0611 4.55054L17.4828 3.46743L16.8909 2.82581L16.0611 4.55054Z"
              fill="#FFCC00"
            />
            <path
              d="M16.06 4.55053L16.6508 2.86367L17.4439 3.2283L16.06 4.55053Z"
              fill="#FFCC00"
            />
            <path
              d="M15.436 2.63656L16.9055 3.65402L17.3328 2.89285L15.436 2.63656Z"
              fill="#FFCC00"
            />
            <path
              d="M15.435 2.63664L17.2219 2.67721L17.1202 3.54418L15.435 2.63664Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8686 8.35864L20.4594 6.67178L21.2525 7.03641L19.8686 8.35864Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8697 8.35865L21.2914 7.27554L20.6995 6.63392L19.8697 8.35865Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8803 8.35865L20.4586 7.27554L21.0505 6.63392L21.8803 8.35865Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8814 8.35864L21.2906 6.67178L20.4975 7.03641L21.8814 8.35864Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5054 6.44466L21.0359 7.46212L20.6086 6.70095L22.5054 6.44466Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5064 6.44474L20.7195 6.48532L20.8212 7.35229L22.5064 6.44474Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2446 6.44466L20.7141 7.46212L21.1414 6.70095L19.2446 6.44466Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2436 6.44474L21.0305 6.48532L20.9288 7.35229L19.2436 6.44474Z"
              fill="#FFCC00"
            />
            <path
              d="M20.873 5.26172L20.3594 6.97365L21.2153 7.14485L20.873 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M20.8731 5.26172L21.3867 6.97365L20.5308 7.14485L20.8731 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2475 16.741L21.0344 16.7816L20.9327 17.6486L19.2475 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2485 16.741L20.718 17.7585L21.1453 16.9973L19.2485 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8686 18.655L20.4594 16.9682L21.2525 17.3328L19.8686 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8697 18.655L21.2914 17.5719L20.6995 16.9303L19.8697 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8803 18.655L20.4586 17.5719L21.0505 16.9303L21.8803 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8814 18.655L21.2906 16.9682L20.4975 17.3328L21.8814 18.655Z"
              fill="#FFCC00"
            />
            <path
              d="M20.873 15.5581L20.3594 17.27L21.2153 17.4412L20.873 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M20.8731 15.5581L21.3867 17.27L20.5308 17.4412L20.8731 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5025 16.741L20.7156 16.7816L20.8173 17.6486L22.5025 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5015 16.741L21.032 17.7585L20.6047 16.9973L22.5015 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M15.5327 20.1867L17.3196 20.2273L17.2179 21.0942L15.5327 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M15.5337 20.1867L17.0031 21.2042L17.4305 20.443L15.5337 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M16.1538 22.1008L16.7445 20.414L17.5376 20.7786L16.1538 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M16.1548 22.1008L17.5766 21.0177L16.9847 20.3761L16.1548 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M18.1655 22.1008L16.7438 21.0177L17.3356 20.3761L18.1655 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M18.1665 22.1008L17.5758 20.414L16.7827 20.7786L18.1665 22.1008Z"
              fill="#FFCC00"
            />
            <path
              d="M17.1581 19.0039L16.6445 20.7158L17.5005 20.887L17.1581 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M17.1583 19.0039L17.6719 20.7158L16.8159 20.887L17.1583 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M18.7876 20.1868L17.0008 20.2274L17.1025 21.0944L18.7876 20.1868Z"
              fill="#FFCC00"
            />
            <path
              d="M18.7866 20.1868L17.3172 21.2043L16.8898 20.4431L18.7866 20.1868Z"
              fill="#FFCC00"
            />
          </svg>
          <svg
            width="35"
            height="35"
            viewBox="0 0 35 35"
            fill="none"
            id="svg-1761932441_338"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.3333 34.6667C26.9063 34.6667 34.6667 26.9063 34.6667 17.3333C34.6667 7.7604 26.9063 0 17.3333 0C7.7604 0 0 7.7604 0 17.3333C0 26.9063 7.7604 34.6667 17.3333 34.6667Z"
              fill="white"
            />
          </svg>
          <svg
            width="9"
            height="9"
            viewBox="0 0 9 9"
            fill="none"
            id="svg879503595_837"
          >
            <path
              d="M8.31419 0.65625V6.34375C8.31419 6.5178 8.24504 6.68472 8.12197 6.80779C7.9989 6.93086 7.83198 7 7.65794 7C7.48389 7 7.31697 6.93086 7.1939 6.80779C7.07083 6.68472 7.00169 6.5178 7.00169 6.34375V2.24219L1.12223 8.12055C0.998948 8.24383 0.831739 8.31309 0.657388 8.31309C0.483038 8.31309 0.315829 8.24383 0.192545 8.12055C0.0692604 7.99726 0 7.83005 0 7.6557C0 7.48135 0.0692604 7.31414 0.192545 7.19086L6.072 1.3125H1.97044C1.79639 1.3125 1.62947 1.24336 1.5064 1.12029C1.38333 0.997218 1.31419 0.830298 1.31419 0.65625C1.31419 0.482202 1.38333 0.315282 1.5064 0.192211C1.62947 0.0691403 1.79639 0 1.97044 0H7.65794C7.83198 0 7.9989 0.0691403 8.12197 0.192211C8.24504 0.315282 8.31419 0.482202 8.31419 0.65625Z"
              fill="#71717A"
            />
          </svg>
          <svg
            width="59"
            height="25"
            viewBox="0 0 59 25"
            fill="none"
            id="svg1335810439_5361"
          >
            <path
              d="M8.33656 13.8952C8.36666 14.7339 8.11525 15.4343 7.58235 15.9962C7.04944 16.5581 6.34499 16.906 5.46898 17.0399L5.51797 18.4054L4.55136 18.4401L4.50292 17.0899C3.66196 17.0586 2.93769 16.8542 2.33011 16.4765C1.73276 16.0985 1.289 15.5767 0.998834 14.9112L2.20096 14.1614C2.58287 15.1002 3.33349 15.6109 4.45283 15.6937L4.31962 11.9806C3.85346 11.8335 3.47479 11.6986 3.18361 11.5759C2.9023 11.4426 2.60399 11.2638 2.28869 11.0396C1.97338 10.8153 1.73296 10.5372 1.56742 10.2051C1.41174 9.86247 1.32583 9.46611 1.30968 9.01605C1.27996 8.18752 1.53191 7.50251 2.06555 6.96103C2.59919 6.41955 3.27881 6.09303 4.1044 5.98148L4.05596 4.63128L5.02258 4.5966L5.07157 5.96214C5.68823 6.02196 6.24317 6.21713 6.7364 6.54766C7.22963 6.87819 7.61986 7.33532 7.90709 7.91904L6.73454 8.63707C6.41112 7.90102 5.87349 7.47478 5.12166 7.35837L5.24826 10.8873C5.72502 11.0443 6.10387 11.1843 6.38482 11.3074C6.66577 11.4305 6.9743 11.6089 7.31043 11.8426C7.64619 12.0661 7.89702 12.349 8.06293 12.6913C8.22884 13.0336 8.32005 13.4349 8.33656 13.8952ZM2.72125 8.96541C2.73519 9.3541 2.8642 9.66697 3.10827 9.90402C3.35234 10.1411 3.73906 10.3576 4.26843 10.5537L4.15449 7.3777C3.70663 7.45522 3.34956 7.63702 3.08329 7.92311C2.82688 8.1986 2.7062 8.54603 2.72125 8.96541ZM5.41834 15.6283C5.90676 15.5391 6.2788 15.3465 6.53447 15.0506C6.8 14.744 6.92525 14.3811 6.9102 13.9617C6.89516 13.5423 6.75537 13.2145 6.49085 12.9781C6.23618 12.7312 5.83887 12.5048 5.2989 12.2989L5.41834 15.6283ZM16.2285 9.14143C16.2583 9.96996 16.0642 10.699 15.6464 11.3285L15.6617 11.3279L12.3797 16.623L10.7687 16.6808L13.1808 12.8303C12.9565 12.8589 12.7829 12.8753 12.6602 12.8797C11.5759 12.9186 10.6741 12.6181 9.95471 11.9782C9.24516 11.3277 8.87131 10.4705 8.83314 9.40674C8.79498 8.34295 9.10664 7.46633 9.76811 6.77688C10.4394 6.07683 11.3172 5.70735 12.4015 5.66845C13.4857 5.62955 14.3826 5.93536 15.0922 6.58587C15.8116 7.22579 16.1904 8.07764 16.2285 9.14143ZM10.8154 7.70716C10.4107 8.13136 10.2205 8.68101 10.2447 9.3561C10.2689 10.0312 10.4983 10.5709 10.9327 10.9753C11.377 11.369 11.9367 11.5537 12.6118 11.5295C13.2869 11.5053 13.8267 11.2811 14.2315 10.8569C14.646 10.4221 14.8412 9.86717 14.817 9.19207C14.7927 8.51698 14.5636 7.98237 14.1295 7.58827C13.6955 7.19416 13.1358 7.00941 12.4505 7.03399C11.7754 7.05821 11.2304 7.2826 10.8154 7.70716ZM19.2683 5.62182L20.4958 5.57778L20.8811 16.318L19.4695 16.3686L19.1393 7.16274L16.8774 7.91985L16.4804 6.70506L19.2683 5.62182ZM29.6169 14.6834C28.9269 15.7221 27.9274 16.2649 26.6181 16.3119C25.3088 16.3588 24.2729 15.889 23.5103 14.9024C22.7477 13.9159 22.3362 12.5787 22.2756 10.8909C22.2151 9.20319 22.5298 7.83997 23.2197 6.80127C23.9096 5.76257 24.9092 5.21973 26.2185 5.17276C27.5277 5.12579 28.5637 5.5956 29.3262 6.5822C30.0888 7.56879 30.5004 8.90596 30.5609 10.5937C30.6215 12.2814 30.3068 13.6447 29.6169 14.6834ZM24.519 13.8984C25.0155 14.6078 25.6985 14.9468 26.568 14.9157C27.4374 14.8845 28.0944 14.4973 28.5389 13.7542C28.9935 13.0107 29.197 11.9741 29.1493 10.6443C29.1016 9.3146 28.8244 8.29524 28.3176 7.58624C27.8206 6.86665 27.1374 6.52245 26.268 6.55365C25.3985 6.58484 24.7416 6.97199 24.2971 7.71512C23.8527 8.45824 23.6545 9.49978 23.7025 10.8397C23.7502 12.1695 24.0224 13.189 24.519 13.8984ZM32.5334 16.0689C32.2572 16.0788 32.0185 15.9901 31.8172 15.8027C31.6159 15.6154 31.5103 15.3836 31.5003 15.1074C31.4904 14.8312 31.5792 14.5925 31.7665 14.3912C31.9539 14.1898 32.1857 14.0842 32.4619 14.0743C32.7483 14.0641 32.987 14.1528 33.1781 14.3405C33.3794 14.5279 33.485 14.7597 33.495 15.0359C33.5049 15.312 33.4161 15.5508 33.2288 15.7521C33.0516 15.953 32.8198 16.0587 32.5334 16.0689ZM41.4694 14.2582C40.7795 15.2969 39.7799 15.8397 38.4706 15.8867C37.1614 15.9336 36.1254 15.4638 35.3629 14.4772C34.6003 13.4906 34.1887 12.1535 34.1282 10.4657C34.0676 8.77798 34.3823 7.41476 35.0722 6.37606C35.7621 5.33735 36.7617 4.79452 38.071 4.74755C39.3803 4.70058 40.4162 5.17039 41.1788 6.15698C41.9414 7.14357 42.3529 8.48074 42.4135 10.1685C42.474 11.8562 42.1593 13.2195 41.4694 14.2582ZM36.3715 13.4732C36.8681 14.1825 37.5511 14.5216 38.4206 14.4904C39.29 14.4592 39.947 14.0721 40.3914 13.329C40.8461 12.5855 41.0496 11.5489 41.0019 10.2191C40.9542 8.88939 40.6769 7.87002 40.1701 7.16103C39.6732 6.44144 38.99 6.09724 38.1206 6.12843C37.2511 6.15962 36.5942 6.54678 36.1497 7.2899C35.7052 8.03302 35.507 9.07457 35.5551 10.4145C35.6028 11.7443 35.8749 12.7638 36.3715 13.4732ZM50.8269 13.9224C50.137 14.9611 49.1374 15.504 47.8282 15.551C46.5189 15.5979 45.4829 15.1281 44.7204 14.1415C43.9578 13.1549 43.5462 11.8178 43.4857 10.13C43.4251 8.44227 43.7398 7.07905 44.4297 6.04035C45.1197 5.00165 46.1192 4.45881 47.4285 4.41184C48.7378 4.36487 49.7737 4.83468 50.5363 5.82128C51.2989 6.80787 51.7104 8.14504 51.771 9.83278C51.8315 11.5205 51.5169 12.8837 50.8269 13.9224ZM45.729 13.1375C46.2256 13.8468 46.9086 14.1859 47.7781 14.1547C48.6475 14.1235 49.3045 13.7364 49.7489 12.9933C50.2036 12.2498 50.4071 11.2132 50.3594 9.88342C50.3117 8.55368 50.0345 7.53432 49.5277 6.82532C49.0307 6.10573 48.3475 5.76153 47.4781 5.79273C46.6086 5.82392 45.9517 6.21107 45.5072 6.95419C45.0627 7.69732 44.8645 8.73886 44.9126 10.0788C44.9603 11.4086 45.2325 12.4281 45.729 13.1375Z"
              fill="#71717A"
            />
          </svg>
          <svg
            width="37"
            height="37"
            viewBox="0 0 37 37"
            fill="none"
            id="svg1905732075_3621"
          >
            <mask
              id="svg1905732075_3621_mask0_1696_488"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="37"
              height="37"
            >
              <path
                d="M36.0597 17.7121C36.4106 27.4943 28.7651 35.7088 18.983 36.0597C9.20085 36.4106 0.986368 28.7651 0.63543 18.983C0.284492 9.20085 7.92999 0.986368 17.7121 0.63543C27.4943 0.284492 35.7088 7.92999 36.0597 17.7121Z"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#svg1905732075_3621_mask0_1696_488)">
              <g filter="url(#svg1905732075_3621_filter0_d_1696_488)">
                <mask
                  id="svg1905732075_3621_mask1_1696_488"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="-7"
                  y="0"
                  width="51"
                  height="39"
                >
                  <path
                    d="M-6.96875 1.79833L42.4776 0.0244173L43.808 37.1092L-5.63832 38.8831L-6.96875 1.79833Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#svg1905732075_3621_mask1_1696_488)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M-6.96875 1.79833L-5.63832 38.8831L43.808 37.1092L42.4776 0.0244173L-6.96875 1.79833Z"
                    fill="#2E42A5"
                  />
                  <mask
                    id="svg1905732075_3621_mask2_1696_488"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="-7"
                    y="0"
                    width="51"
                    height="39"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M-6.96875 1.79833L-5.63832 38.8831L43.808 37.1092L42.4776 0.0244173L-6.96875 1.79833Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#svg1905732075_3621_mask2_1696_488)">
                    <mask
                      id="svg1905732075_3621_mask3_1696_488"
                      style={{ maskType: 'luminance' }}
                      maskUnits="userSpaceOnUse"
                      x="-7"
                      y="0"
                      width="51"
                      height="39"
                    >
                      <path
                        d="M-6.96875 1.79833L42.4776 0.0244173L43.808 37.1092L-5.63832 38.8831L-6.96875 1.79833Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#svg1905732075_3621_mask3_1696_488)">
                      <path
                        d="M-11.2393 36.4305L-0.193409 40.6419L42.9038 5.01797L48.3979 -2.02618L36.7072 -3.14677L19.157 12.1679L4.96196 22.5715L-11.2393 36.4305Z"
                        fill="white"
                      />
                      <path
                        d="M-9.63487 39.6015L-3.99579 42.0731L46.3133 -2.58722L38.5299 -2.30799L-9.63487 39.6015Z"
                        fill="#F50100"
                      />
                      <path
                        d="M49.2177 34.2616L38.502 39.2536L-7.03719 6.8096L-13.0219 0.177253L-1.44161 -1.77819L17.1609 12.2395L32.065 21.5991L49.2177 34.2616Z"
                        fill="white"
                      />
                      <path
                        d="M48.9315 36.5889L43.4841 39.4583L20.7507 21.9252L14.1322 20.1126L-13.5712 0.220651L-5.78784 -0.058581L21.8827 19.3388L29.1266 21.5371L48.9315 36.5889Z"
                        fill="#F50100"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.4797 -2.38823L11.8048 -1.96939L12.3592 13.4828L-9.57455 14.2697L-9.13108 26.6312L12.8027 25.8444L13.357 41.2962L25.0318 40.8773L24.4775 25.4255L46.4961 24.6356L46.0526 12.274L24.034 13.0639L23.4797 -2.38823Z"
                        fill="#F50100"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.3592 13.4828L-9.57455 14.2697L-9.13108 26.6312L12.8027 25.8444L13.357 41.2962L25.0318 40.8773L24.4775 25.4255L46.4961 24.6356L46.0526 12.274L24.034 13.0639L23.4797 -2.38823L11.8048 -1.96939L12.3592 13.4828ZM13.6396 -0.261722L14.1939 15.1904L-7.7398 15.9773L-7.42341 24.7965L14.5103 24.0096L15.0647 39.4614L23.1971 39.1697L22.6427 23.7179L44.6613 22.9279L44.3449 14.1088L22.3264 14.8987L21.772 -0.553475L13.6396 -0.261722Z"
                        fill="white"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <defs>
              <filter
                id="svg1905732075_3621_filter0_d_1696_488"
                x="-10.2587"
                y="-1.07224"
                width="57.3572"
                height="45.4385"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2.19329" />
                <feGaussianBlur stdDeviation="1.64496" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_1696_488"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_1696_488"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
          <svg
            width="62"
            height="25"
            viewBox="0 0 62 25"
            fill="none"
            id="svg701843853_4460"
          >
            <path
              d="M3.8177 15.655L9.23383 15.4607L9.28337 16.8416L1.12082 17.1344L1.07128 15.7536L2.40614 15.7057L2.29935 12.7291L1.22533 12.7676L1.1802 11.5095L2.25421 11.471L2.18046 9.41499C2.14266 8.36142 2.43076 7.54198 3.04476 6.95664C3.66899 6.37094 4.41583 6.0625 5.28527 6.03131C6.01151 6.00525 6.64225 6.1721 7.1775 6.53185C7.71237 6.88137 8.12471 7.38379 8.41451 8.03912L7.25731 8.7566C6.886 7.82767 6.25028 7.37935 5.35015 7.41164C4.82849 7.43035 4.39964 7.60961 4.0636 7.94941C3.7272 8.27897 3.57037 8.76085 3.59312 9.39503L3.66578 11.4203L7.07196 11.2981L7.11709 12.5563L3.71092 12.6785L3.8177 15.655ZM17.6468 13.1617L17.6947 14.4966L16.3905 14.5434L16.4637 16.584L15.0368 16.6352L14.9636 14.5946L9.4861 14.7911L9.43821 13.4562L13.0251 5.95335L14.5594 5.89831L10.9725 13.4012L14.9157 13.2597L14.8067 10.2218L16.2336 10.1706L16.3426 13.2085L17.6468 13.1617ZM21.692 9.83649C22.7047 9.80016 23.5696 10.0713 24.2868 10.6498C25.0139 11.2178 25.3963 12.0285 25.4341 13.0821C25.4715 14.1254 25.1431 14.9617 24.4487 15.5909C23.7543 16.22 22.8957 16.553 21.8728 16.5897C21.0545 16.619 20.3162 16.4509 19.6579 16.0853C18.9991 15.7095 18.5285 15.1529 18.246 14.4154L19.4334 13.6814C19.5953 14.198 19.8858 14.587 20.3048 14.8485C20.7235 15.0997 21.2295 15.2147 21.8228 15.1934C22.4979 15.1692 23.0389 14.9757 23.4458 14.6129C23.8527 14.2501 24.0449 13.7567 24.0225 13.1327C24.0002 12.5088 23.773 12.0304 23.3412 11.6977C22.909 11.3547 22.3655 11.195 21.7109 11.2185L18.6729 11.3275L18.8721 5.74359L24.7485 5.53277L24.7964 6.86763L20.2088 7.03221L20.127 9.89264L21.692 9.83649ZM33.3777 14.656C32.6878 15.6947 31.6882 16.2375 30.3789 16.2845C29.0697 16.3315 28.0337 15.8617 27.2712 14.8751C26.5086 13.8885 26.097 12.5513 26.0365 10.8636C25.9759 9.17583 26.2906 7.81261 26.9805 6.77391C27.6704 5.7352 28.67 5.19237 29.9793 5.1454C31.2886 5.09843 32.3245 5.56824 33.0871 6.55483C33.8497 7.54142 34.2612 8.87859 34.3218 10.5663C34.3823 12.2541 34.0676 13.6173 33.3777 14.656ZM28.2798 13.871C28.7764 14.5804 29.4594 14.9195 30.3288 14.8883C31.1983 14.8571 31.8552 14.4699 32.2997 13.7268C32.7544 12.9833 32.9579 11.9467 32.9102 10.617C32.8625 9.28724 32.5852 8.26787 32.0784 7.55888C31.5815 6.83929 30.8983 6.49509 30.0289 6.52628C29.1594 6.55747 28.5025 6.94463 28.058 7.68775C27.6135 8.43087 27.4153 9.47242 27.4634 10.8124C27.5111 12.1421 27.7832 13.1617 28.2798 13.871ZM36.2943 16.0416C36.0181 16.0515 35.7794 15.9627 35.578 15.7754C35.3767 15.588 35.2711 15.3562 35.2612 15.08C35.2513 14.8039 35.34 14.5651 35.5274 14.3638C35.7148 14.1625 35.9466 14.0569 36.2227 14.047C36.5091 14.0367 36.7479 14.1254 36.939 14.3132C37.1403 14.5005 37.2459 14.7323 37.2558 15.0085C37.2657 15.2847 37.177 15.5234 36.9896 15.7247C36.8125 15.9257 36.5807 16.0313 36.2943 16.0416ZM45.2303 14.2308C44.5404 15.2695 43.5408 15.8123 42.2315 15.8593C40.9222 15.9063 39.8863 15.4365 39.1237 14.4499C38.3612 13.4633 37.9496 12.1261 37.889 10.4384C37.8285 8.75061 38.1432 7.38739 38.8331 6.34869C39.523 5.30999 40.5226 4.76715 41.8319 4.72018C43.1412 4.67321 44.1771 5.14302 44.9397 6.12961C45.7022 7.11621 46.1138 8.45337 46.1743 10.1411C46.2349 11.8289 45.9202 13.1921 45.2303 14.2308ZM40.1324 13.4458C40.629 14.1552 41.312 14.4943 42.1814 14.4631C43.0509 14.4319 43.7078 14.0447 44.1523 13.3016C44.607 12.5581 44.8105 11.5215 44.7628 10.1918C44.7151 8.86202 44.4378 7.84266 43.931 7.13366C43.4341 6.41407 42.7509 6.06987 41.8814 6.10106C41.012 6.13226 40.355 6.51941 39.9106 7.26253C39.4661 8.00566 39.2679 9.0472 39.316 10.3872C39.3637 11.7169 39.6358 12.7365 40.1324 13.4458ZM54.5878 13.8951C53.8979 14.9338 52.8983 15.4766 51.589 15.5236C50.2797 15.5706 49.2438 15.1008 48.4812 14.1142C47.7187 13.1276 47.3071 11.7904 47.2466 10.1027C47.186 8.41491 47.5007 7.05169 48.1906 6.01299C48.8805 4.97428 49.8801 4.43145 51.1894 4.38448C52.4987 4.33751 53.5346 4.80732 54.2972 5.79391C55.0597 6.7805 55.4713 8.11767 55.5318 9.80541C55.5924 11.4932 55.2777 12.8564 54.5878 13.8951ZM49.4899 13.1101C49.9865 13.8195 50.6695 14.1586 51.5389 14.1274C52.4084 14.0962 53.0653 13.709 53.5098 12.9659C53.9645 12.2224 54.168 11.1858 54.1203 9.85606C54.0726 8.52632 53.7953 7.50695 53.2885 6.79796C52.7916 6.07837 52.1084 5.73417 51.2389 5.76536C50.3695 5.79655 49.7125 6.18371 49.2681 6.92683C48.8236 7.66995 48.6254 8.7115 48.6735 10.0515C48.7212 11.3812 48.9933 12.4007 49.4899 13.1101Z"
              fill="#71717A"
            />
          </svg>
          <svg
            width="59"
            height="25"
            viewBox="0 0 59 25"
            fill="none"
            id="svg-508483599_4911"
          >
            <path
              d="M3.19042 6.19862L4.41787 6.15459L4.80318 16.8948L3.39161 16.9454L3.06134 7.73954L0.799436 8.49665L0.402508 7.28186L3.19042 6.19862ZM8.65047 15.1744L7.78692 18.9385L6.63619 18.9798L7.11615 15.2294L8.65047 15.1744ZM9.82613 16.7146L9.7843 15.5485L13.4353 11.5461C14.4117 10.4971 14.8868 9.60949 14.8607 8.88324C14.8391 8.27975 14.6381 7.81583 14.2577 7.49149C13.8774 7.16715 13.4213 7.01453 12.8894 7.03361C11.8767 7.06994 11.1575 7.57711 10.7317 8.55513L9.50963 7.89228C9.82222 7.18461 10.2687 6.64113 10.8492 6.26184C11.4398 5.88219 12.0983 5.67933 12.8245 5.65328C13.7246 5.62098 14.5178 5.88955 15.2039 6.45896C15.8901 7.02838 16.2511 7.81429 16.2871 8.81671C16.326 9.90096 15.7291 11.1053 14.4964 12.4298L11.8479 15.2594L16.7117 15.0849L16.7612 16.4658L9.82613 16.7146ZM24.7472 14.8581C24.0573 15.8968 23.0577 16.4396 21.7484 16.4866C20.4391 16.5335 19.4032 16.0637 18.6407 15.0771C17.8781 14.0906 17.4665 12.7534 17.406 11.0656C17.3454 9.37789 17.6601 8.01467 18.35 6.97597C19.0399 5.93727 20.0395 5.39443 21.3488 5.34746C22.6581 5.30049 23.694 5.7703 24.4566 6.7569C25.2192 7.74349 25.6307 9.08066 25.6913 10.7684C25.7518 12.4561 25.4371 13.8194 24.7472 14.8581ZM19.6493 14.0731C20.1459 14.7825 20.8289 15.1215 21.6983 15.0904C22.5678 15.0592 23.2247 14.672 23.6692 13.9289C24.1239 13.1854 24.3274 12.1488 24.2797 10.819C24.232 9.4893 23.9547 8.46994 23.4479 7.76094C22.951 7.04135 22.2678 6.69715 21.3983 6.72835C20.5289 6.75954 19.8719 7.14669 19.4275 7.88982C18.983 8.63294 18.7848 9.67448 18.8329 11.0144C18.8806 12.3442 19.1527 13.3637 19.6493 14.0731ZM34.1047 14.5224C33.4148 15.5611 32.4152 16.1039 31.1059 16.1509C29.7967 16.1978 28.7607 15.728 27.9982 14.7414C27.2356 13.7548 26.824 12.4177 26.7635 10.7299C26.7029 9.04219 27.0176 7.67897 27.7075 6.64027C28.3974 5.60157 29.397 5.05873 30.7063 5.01176C32.0156 4.96479 33.0515 5.4346 33.8141 6.42119C34.5767 7.40778 34.9882 8.74495 35.0488 10.4327C35.1093 12.1204 34.7946 13.4837 34.1047 14.5224ZM29.0068 13.7374C29.5034 14.4468 30.1864 14.7858 31.0558 14.7546C31.9253 14.7235 32.5822 14.3363 33.0267 13.5932C33.4814 12.8497 33.6849 11.8131 33.6372 10.4833C33.5895 9.1536 33.3122 8.13423 32.8054 7.42524C32.3085 6.70565 31.6253 6.36145 30.7559 6.39264C29.8864 6.42383 29.2295 6.81099 28.785 7.55411C28.3405 8.29723 28.1423 9.33878 28.1904 10.6787C28.2381 12.0085 28.5102 13.028 29.0068 13.7374ZM40.5637 15.6119L39.8638 4.66787L41.1066 4.62328L41.8065 15.5673L40.5637 15.6119ZM40.3162 20.2757L40.1024 19.4538C40.3661 19.3828 40.5791 19.324 40.7413 19.2772C40.9035 19.2304 41.0859 19.1778 41.2887 19.1193L41.2235 19.4443C40.9546 19.372 40.6927 19.2073 40.4377 18.9501C40.1928 18.6926 40.0644 18.3951 40.0523 18.0575C40.0413 17.7507 40.1035 17.4873 40.239 17.2673C40.3851 17.0573 40.5739 16.8968 40.8055 16.7861C41.0474 16.675 41.3064 16.6145 41.5825 16.6046C41.6951 16.6006 41.813 16.6066 41.9365 16.6226C42.0702 16.6383 42.1941 16.6646 42.3081 16.7015L42.2128 17.473C42.1098 17.4563 42.0119 17.4393 41.9191 17.4221C41.8263 17.405 41.7237 17.3984 41.6112 17.4025C41.3759 17.4109 41.1934 17.4635 41.0638 17.5604C40.9345 17.6674 40.8729 17.8079 40.8792 17.9818C40.8869 18.1966 40.96 18.3783 41.0984 18.527C41.2471 18.6753 41.4099 18.7872 41.5867 18.8628C41.7742 18.9483 41.9241 18.989 42.0366 18.9849L41.4098 19.0689C41.6834 18.9874 41.9363 18.9015 42.1687 18.8112C42.4116 18.7308 42.6289 18.6513 42.8207 18.5727L43.0943 19.3464C42.8521 19.4473 42.5641 19.5549 42.2302 19.6693C41.9065 19.7833 41.5776 19.8924 41.2433 19.9966C40.9091 20.1008 40.6001 20.1938 40.3162 20.2757ZM44.3638 15.6445C44.0876 15.6544 43.8489 15.5657 43.6476 15.3783C43.4463 15.1909 43.3406 14.9592 43.3307 14.683C43.3208 14.4068 43.4096 14.1681 43.5969 13.9667C43.7843 13.7654 44.0161 13.6598 44.2923 13.6499C44.5787 13.6396 44.8174 13.7284 45.0085 13.9161C45.2098 14.1035 45.3154 14.3353 45.3253 14.6114C45.3352 14.8876 45.2465 15.1264 45.0591 15.3277C44.882 15.5286 44.6502 15.6342 44.3638 15.6445ZM46.4375 14.7098L47.0133 13.6291C47.2226 13.7547 47.5136 13.8723 47.8862 13.9819C48.2589 14.0914 48.6907 14.1374 49.1817 14.1197C49.6931 14.1014 50.0953 14.0358 50.3883 13.9228C50.6915 13.8095 50.9061 13.6533 51.0321 13.4542C51.1679 13.2445 51.2311 13.0067 51.2215 12.7407C51.2142 12.5361 51.1592 12.2872 51.0565 11.9939C50.9636 11.6899 50.7649 11.2874 50.4601 10.7862C50.155 10.2748 49.6907 9.61039 49.0674 8.79292L50.1013 8.0645C50.6702 8.79175 51.124 9.45143 51.4628 10.0436C51.8117 10.6353 52.061 11.1589 52.2105 11.6145C52.3698 12.0594 52.4553 12.4455 52.4671 12.7728C52.4818 13.182 52.3938 13.5846 52.2032 13.9806C52.0122 14.3664 51.6807 14.6907 51.2087 14.9534C50.7368 15.2162 50.0763 15.3628 49.2274 15.3932C48.8591 15.4064 48.5 15.3886 48.15 15.3397C47.8103 15.2904 47.4952 15.2147 47.2047 15.1124C46.9139 15 46.6582 14.8658 46.4375 14.7098Z"
              fill="#71717A"
            />
          </svg>
          <svg
            width="81"
            height="25"
            viewBox="0 0 81 25"
            fill="none"
            id="svg-1992885442_5845"
          >
            <path
              d="M1.88798 17.7881L1.74652 13.8449L0.549753 13.8879L0.514525 12.9059L1.71129 12.863L1.66615 11.6048L0.469389 11.6478L0.43416 10.6658L1.63092 10.6229L1.49497 6.83312L3.09065 6.77587L4.68421 10.5133L6.4947 10.4484L6.35874 6.65863L7.57085 6.61514L7.7068 10.4049L8.90357 10.362L8.9388 11.3439L7.74203 11.3869L7.78717 12.645L8.98393 12.6021L9.01916 13.584L7.8224 13.627L7.96386 17.5701L6.35283 17.6279L4.75377 13.737L2.94328 13.802L3.08474 17.7452L1.88798 17.7881ZM2.90805 12.82L4.35031 12.7683L3.84488 11.5267L2.83223 11.563L2.90805 12.82ZM6.67414 15.4502L6.73551 15.448L6.62563 13.6699L5.98122 13.693L6.67414 15.4502ZM2.797 10.581L3.44141 10.5579L2.72875 8.67849L2.66738 8.68069L2.797 10.581ZM5.57776 12.7243L6.60575 12.6874L6.52993 11.4303L5.07233 11.4826L5.57776 12.7243ZM11.6639 6.68338L12.8913 6.63935L13.2767 17.3795L11.8651 17.4302L11.5348 8.2243L9.27292 8.98141L8.87599 7.76662L11.6639 6.68338ZM17.1239 15.6591L16.2604 19.4233L15.1097 19.4646L15.5896 15.7142L17.1239 15.6591ZM21.6549 10.519C22.6675 10.4827 23.5324 10.7538 24.2496 11.3323C24.9767 11.9003 25.3591 12.711 25.3969 13.7646C25.4344 14.8079 25.1059 15.6442 24.4115 16.2734C23.7172 16.9026 22.8586 17.2355 21.8357 17.2722C21.0174 17.3016 20.2791 17.1334 19.6207 16.7679C18.962 16.3921 18.4914 15.8354 18.2089 15.0979L19.3962 14.364C19.5581 14.8805 19.8486 15.2695 20.2677 15.531C20.6864 15.7823 21.1923 15.8973 21.7856 15.876C22.4607 15.8518 23.0017 15.6582 23.4086 15.2954C23.8155 14.9326 24.0078 14.4392 23.9854 13.8152C23.963 13.1913 23.7359 12.7129 23.304 12.3802C22.8718 12.0373 22.3284 11.8775 21.6737 11.901L18.6358 12.01L18.8349 6.42612L24.7113 6.2153L24.7592 7.55015L20.1716 7.71474L20.0899 10.5752L21.6549 10.519ZM33.3406 15.3385C32.6507 16.3772 31.6511 16.9201 30.3418 16.967C29.0325 17.014 27.9966 16.5442 27.234 15.5576C26.4714 14.571 26.0599 13.2338 25.9993 11.5461C25.9388 9.85836 26.2535 8.49513 26.9434 7.45643C27.6333 6.41773 28.6329 5.8749 29.9422 5.82793C31.2514 5.78095 32.2874 6.25077 33.0499 7.23736C33.8125 8.22395 34.2241 9.56112 34.2846 11.2489C34.3452 12.9366 34.0305 14.2998 33.3406 15.3385ZM28.2427 14.5536C28.7392 15.2629 29.4222 15.602 30.2917 15.5708C31.1611 15.5396 31.8181 15.1525 32.2626 14.4093C32.7173 13.6659 32.9208 12.6292 32.873 11.2995C32.8253 9.96977 32.5481 8.9504 32.0413 8.24141C31.5443 7.52182 30.8611 7.17762 29.9917 7.20881C29.1223 7.24 28.4653 7.62716 28.0208 8.37028C27.5764 9.1134 27.3782 10.1549 27.4262 11.4949C27.4739 12.8246 27.7461 13.8442 28.2427 14.5536ZM42.6981 15.0028C42.0082 16.0415 41.0086 16.5844 39.6993 16.6313C38.39 16.6783 37.3541 16.2085 36.5915 15.2219C35.8289 14.2353 35.4174 12.8981 35.3568 11.2104C35.2963 9.52265 35.611 8.15943 36.3009 7.12073C36.9908 6.08203 37.9904 5.53919 39.2997 5.49222C40.6089 5.44525 41.6449 5.91506 42.4074 6.90165C43.17 7.88825 43.5816 9.22541 43.6421 10.9132C43.7027 12.6009 43.388 13.9641 42.6981 15.0028ZM37.6002 14.2179C38.0967 14.9272 38.7798 15.2663 39.6492 15.2351C40.5186 15.2039 41.1756 14.8168 41.6201 14.0736C42.0748 13.3302 42.2783 12.2935 42.2306 10.9638C42.1829 9.63406 41.9056 8.6147 41.3988 7.9057C40.9018 7.18611 40.2187 6.84191 39.3492 6.8731C38.4798 6.90429 37.8228 7.29145 37.3783 8.03457C36.9339 8.77769 36.7357 9.81924 36.7837 11.1592C36.8315 12.4889 37.1036 13.5085 37.6002 14.2179ZM46.7026 14.598L45.8391 18.3622L44.6883 18.4034L45.1683 14.653L46.7026 14.598ZM54.7005 14.5722C54.0106 15.6109 53.011 16.1538 51.7017 16.2007C50.3924 16.2477 49.3565 15.7779 48.5939 14.7913C47.8313 13.8047 47.4198 12.4675 47.3592 10.7798C47.2987 9.09206 47.6134 7.72884 48.3033 6.69014C48.9932 5.65144 49.9928 5.1086 51.3021 5.06163C52.6114 5.01466 53.6473 5.48447 54.4098 6.47106C55.1724 7.45765 55.584 8.79482 55.6445 10.4826C55.7051 12.1703 55.3904 13.5335 54.7005 14.5722ZM49.6026 13.7873C50.0991 14.4966 50.7822 14.8357 51.6516 14.8045C52.521 14.7733 53.178 14.3862 53.6225 13.643C54.0772 12.8996 54.2807 11.8629 54.233 10.5332C54.1853 9.20347 53.908 8.1841 53.4012 7.47511C52.9042 6.75552 52.2211 6.41132 51.3516 6.44251C50.4822 6.4737 49.8252 6.86086 49.3807 7.60398C48.9363 8.3471 48.7381 9.38865 48.7861 10.7286C48.8339 12.0584 49.106 13.0779 49.6026 13.7873ZM64.058 14.2365C63.3681 15.2752 62.3685 15.8181 61.0592 15.865C59.7499 15.912 58.714 15.4422 57.9514 14.4556C57.1889 13.469 56.7773 12.1318 56.7167 10.4441C56.6562 8.75636 56.9709 7.39313 57.6608 6.35443C58.3507 5.31573 59.3503 4.7729 60.6596 4.72593C61.9689 4.67895 63.0048 5.14877 63.7674 6.13536C64.5299 7.12195 64.9415 8.45912 65.002 10.1469C65.0626 11.8346 64.7479 13.1978 64.058 14.2365ZM58.9601 13.4516C59.4567 14.1609 60.1397 14.5 61.0091 14.4688C61.8786 14.4376 62.5355 14.0505 62.98 13.3073C63.4347 12.5639 63.6382 11.5272 63.5905 10.1975C63.5428 8.86777 63.2655 7.8484 62.7587 7.13941C62.2618 6.41982 61.5786 6.07562 60.7091 6.10681C59.8397 6.138 59.1827 6.52516 58.7383 7.26828C58.2938 8.0114 58.0956 9.05294 58.1437 10.3929C58.1914 11.7226 58.4635 12.7422 58.9601 13.4516ZM73.4155 13.9008C72.7256 14.9395 71.726 15.4824 70.4167 15.5293C69.1074 15.5763 68.0715 15.1065 67.3089 14.1199C66.5464 13.1333 66.1348 11.7961 66.0743 10.1084C66.0137 8.42065 66.3284 7.05743 67.0183 6.01873C67.7082 4.98003 68.7078 4.43719 70.0171 4.39022C71.3264 4.34325 72.3623 4.81306 73.1249 5.79965C73.8874 6.78625 74.299 8.12341 74.3596 9.81116C74.4201 11.4989 74.1054 12.8621 73.4155 13.9008ZM68.3176 13.1159C68.8142 13.8252 69.4972 14.1643 70.3666 14.1331C71.2361 14.1019 71.893 13.7148 72.3375 12.9716C72.7922 12.2282 72.9957 11.1915 72.948 9.8618C72.9003 8.53206 72.623 7.51269 72.1162 6.8037C71.6193 6.08411 70.9361 5.73991 70.0666 5.7711C69.1972 5.80229 68.5402 6.18945 68.0958 6.93257C67.6513 7.67569 67.4531 8.71724 67.5012 10.0572C67.5489 11.3869 67.821 12.4065 68.3176 13.1159Z"
              fill="#71717A"
            />
          </svg>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            id="svg-458407791_470"
          >
            <g opacity="0.5">
              <path
                d="M12.2194 5.21967C12.5122 4.92678 12.987 4.92678 13.2799 5.21967C13.5728 5.51256 13.5728 5.98732 13.2799 6.28022L8.10998 11.4501C7.84392 11.7162 7.42225 11.7435 7.12365 11.5146L4.29357 9.34467C3.96489 9.09263 3.90288 8.62259 4.1549 8.29389C4.40694 7.96521 4.87698 7.90319 5.20568 8.15522L7.5133 9.92475L12.2194 5.21967Z"
                fill="black"
              />
            </g>
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            id="svg-2032160236_829"
          >
            <path
              d="M13.5004 0.75V10.5C13.5004 10.6989 13.4214 10.8897 13.2807 11.0303C13.1401 11.171 12.9493 11.25 12.7504 11.25C12.5515 11.25 12.3607 11.171 12.2201 11.0303C12.0794 10.8897 12.0004 10.6989 12.0004 10.5V2.56031L1.28104 13.2806C1.14031 13.4214 0.94944 13.5004 0.750417 13.5004C0.551394 13.5004 0.360523 13.4214 0.219792 13.2806C0.0790615 13.1399 0 12.949 0 12.75C0 12.551 0.0790615 12.3601 0.219792 12.2194L10.9401 1.5H3.00042C2.8015 1.5 2.61074 1.42098 2.47009 1.28033C2.32943 1.13968 2.25042 0.948912 2.25042 0.75C2.25042 0.551088 2.32943 0.360322 2.47009 0.21967C2.61074 0.0790178 2.8015 0 3.00042 0H12.7504C12.9493 0 13.1401 0.0790178 13.2807 0.21967C13.4214 0.360322 13.5004 0.551088 13.5004 0.75Z"
              fill="#71717A"
            />
          </svg>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg-959763977_725"
          >
            <path
              d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
              fill="#BFDBFE"
            />
            <path
              d="M29 25.5H11"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 18.5L11 15.5L14 12.5"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 15.5H29"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26 28.5L29 25.5L26 22.5"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg-874199162_1508"
          >
            <path
              d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
              fill="#BFDBFE"
            />
            <path
              d="M11 20.5C11 21.6819 11.2328 22.8522 11.6851 23.9442C12.1374 25.0361 12.8003 26.0282 13.636 26.864C14.4718 27.6997 15.4639 28.3626 16.5558 28.8149C17.6478 29.2672 18.8181 29.5 20 29.5C21.1819 29.5 22.3522 29.2672 23.4442 28.8149C24.5361 28.3626 25.5282 27.6997 26.364 26.864C27.1997 26.0282 27.8626 25.0361 28.3149 23.9442C28.7672 22.8522 29 21.6819 29 20.5C29 18.1131 28.0518 15.8239 26.364 14.136C24.6761 12.4482 22.3869 11.5 20 11.5C17.6131 11.5 15.3239 12.4482 13.636 14.136C11.9482 15.8239 11 18.1131 11 20.5Z"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.5977 17.5H28.3977"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.5977 23.5H28.3977"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.4997 11.5C17.815 14.1996 16.9219 17.3179 16.9219 20.5C16.9219 23.6821 17.815 26.8004 19.4997 29.5"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.5 11.5C22.1847 14.1996 23.0778 17.3179 23.0778 20.5C23.0778 23.6821 22.1847 26.8004 20.5 29.5"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg883086955_1070"
          >
            <rect width="40" height="40" rx="10" fill="#BFDBFE" />
            <path
              d="M25 16.5V13.5C25 13.2348 24.8946 12.9804 24.7071 12.7929C24.5196 12.6054 24.2652 12.5 24 12.5H14C13.4696 12.5 12.9609 12.7107 12.5858 13.0858C12.2107 13.4609 12 13.9696 12 14.5M12 14.5C12 15.0304 12.2107 15.5391 12.5858 15.9142C12.9609 16.2893 13.4696 16.5 14 16.5H26C26.2652 16.5 26.5196 16.6054 26.7071 16.7929C26.8946 16.9804 27 17.2348 27 17.5V20.5M12 14.5V26.5C12 27.0304 12.2107 27.5391 12.5858 27.9142C12.9609 28.2893 13.4696 28.5 14 28.5H26C26.2652 28.5 26.5196 28.3946 26.7071 28.2071C26.8946 28.0196 27 27.7652 27 27.5V24.5"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28 20.5V24.5H24C23.4696 24.5 22.9609 24.2893 22.5858 23.9142C22.2107 23.5391 22 23.0304 22 22.5C22 21.9696 22.2107 21.4609 22.5858 21.0858C22.9609 20.7107 23.4696 20.5 24 20.5H28Z"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg-899467930_1823"
          >
            <path
              d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
              fill="#BFDBFE"
            />
            <path
              d="M11 20.5C11 21.6819 11.2328 22.8522 11.6851 23.9442C12.1374 25.0361 12.8003 26.0282 13.636 26.864C14.4718 27.6997 15.4639 28.3626 16.5558 28.8149C17.6478 29.2672 18.8181 29.5 20 29.5C21.1819 29.5 22.3522 29.2672 23.4442 28.8149C24.5361 28.3626 25.5282 27.6997 26.364 26.864C27.1997 26.0282 27.8626 25.0361 28.3149 23.9442C28.7672 22.8522 29 21.6819 29 20.5C29 19.3181 28.7672 18.1478 28.3149 17.0558C27.8626 15.9639 27.1997 14.9718 26.364 14.136C25.5282 13.3003 24.5361 12.6374 23.4442 12.1851C22.3522 11.7328 21.1819 11.5 20 11.5C18.8181 11.5 17.6478 11.7328 16.5558 12.1851C15.4639 12.6374 14.4718 13.3003 13.636 14.136C12.8003 14.9718 12.1374 15.9639 11.6851 17.0558C11.2328 18.1478 11 19.3181 11 20.5Z"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22.8 17.4999C22.6188 17.1857 22.3557 16.9266 22.0386 16.7505C21.7215 16.5743 21.3625 16.4877 21 16.4999H19C18.4696 16.4999 17.9609 16.7106 17.5858 17.0857C17.2107 17.4608 17 17.9695 17 18.4999C17 19.0303 17.2107 19.5391 17.5858 19.9141C17.9609 20.2892 18.4696 20.4999 19 20.4999H21C21.5304 20.4999 22.0391 20.7106 22.4142 21.0857C22.7893 21.4608 23 21.9695 23 22.4999C23 23.0303 22.7893 23.5391 22.4142 23.9141C22.0391 24.2892 21.5304 24.4999 21 24.4999H19C18.6375 24.5121 18.2785 24.4255 17.9614 24.2494C17.6443 24.0732 17.3812 23.8142 17.2 23.4999"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 15.5V25.5"
              stroke="#2563EB"
              strokeWidth={1.33333}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg2080463978_9012"
          >
            <mask
              id="svg2080463978_9012_mask0_1696_1108"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="47"
              height="35"
            >
              <path d="M0 0H46.2245V34.6667H0V0Z" fill="white" />
            </mask>
            <g mask="url(#svg2080463978_9012_mask0_1696_1108)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H65.8667V2.66771H0V0ZM0 5.33542H65.8667V8.00313H0V5.33542ZM0 10.6641H65.8667V13.3385H0V10.6641ZM0 15.9995H65.8667V18.6672H0V15.9995ZM0 21.3349H65.8667V24.0026H0V21.3349ZM0 26.6635H65.8667V29.3313H0V26.6635ZM0 31.999H65.8667V34.6667H0V31.999Z"
                fill="#BD3D44"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.66748H65.8667V5.33519H0V2.66748ZM0 8.0029H65.8667V10.6638H0V8.0029ZM0 13.3315H65.8667V15.9993H0V13.3315ZM0 18.667H65.8667V21.3347H0V18.667ZM0 24.0024H65.8667V26.6701H0V24.0024ZM0 29.331H65.8667V31.9987H0V29.331Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H26.3453V18.6672H0V0Z"
                fill="#192F5D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.19531 0.798828L2.43906 1.53685H3.21094L2.58802 1.99049L2.825 2.73529L2.19531 2.27487L1.5724 2.72852L1.80938 1.99049L1.17969 1.53685H1.9651L2.19531 0.798828ZM6.58958 0.798828L6.82656 1.53685H7.60521L6.97552 1.99049L7.2125 2.73529L6.58958 2.27487L5.9599 2.72852L6.19688 1.99049L5.57396 1.53685H6.34583L6.58958 0.798828ZM10.9771 0.798828L11.2208 1.53685H11.9859L11.363 1.99049L11.6 2.73529L10.9703 2.27487L10.3474 2.72852L10.5844 1.99049L9.95469 1.53685H10.7333L10.9771 0.798828ZM15.3714 0.798828L15.6083 1.53685H16.387L15.7573 1.99049L16.001 2.73529L15.3714 2.27487L14.7417 2.72852L14.9854 1.99049L14.3557 1.53685H15.1276L15.3714 0.798828ZM19.7589 0.798828L20.0026 1.53685H20.7745L20.1516 1.99049L20.3885 2.73529L19.7589 2.27487L19.1359 2.72852L19.3729 1.99049L18.75 1.53685H19.5219L19.7589 0.798828ZM24.1531 0.798828L24.3901 1.53685H25.1688L24.5391 1.99049L24.7828 2.73529L24.1531 2.27487L23.5234 2.72852L23.7672 1.99049L23.1375 1.53685H23.9161L24.1531 0.798828ZM4.39583 2.66758L4.63281 3.4056H5.41146L4.78177 3.85924L5.01198 4.59727L4.4026 4.14362L3.77292 4.59727L3.99635 3.85924L3.38698 3.4056H4.15885L4.39583 2.66758ZM8.78333 2.66758L9.02708 3.4056H9.79896L9.16927 3.85924L9.41302 4.59727L8.78333 4.14362L8.15365 4.59727L8.3974 3.85924L7.76771 3.4056H8.54635L8.78333 2.66758ZM13.1776 2.66758L13.4146 3.4056H14.1932L13.5635 3.85924L13.8005 4.59727L13.1776 4.14362L12.5479 4.59727L12.7849 3.85924L12.162 3.4056H12.9339L13.1776 2.66758ZM17.5651 2.66758L17.8089 3.4056H18.5807L17.951 3.85924L18.1948 4.59727L17.5651 4.14362L16.9422 4.59727L17.1792 3.85924L16.5495 3.4056H17.3349L17.5651 2.66758ZM21.9594 2.66758L22.1964 3.4056H22.975L22.3453 3.85924L22.5823 4.59727L21.9594 4.14362L21.3297 4.59727L21.5667 3.85924L20.9438 3.4056H21.7156L21.9594 2.66758ZM2.19531 4.52956L2.43906 5.28112H3.21094L2.58802 5.73476L2.825 6.47279L2.19531 6.01237L1.5724 6.47279L1.80938 5.72799L1.17969 5.27435H1.9651L2.19531 4.52956ZM6.58958 4.52956L6.82656 5.27435H7.60521L6.97552 5.72799L7.2125 6.46602L6.58958 6.0056L5.9599 6.46602L6.19688 5.72122L5.57396 5.26758H6.34583L6.58958 4.52956ZM10.9771 4.52956L11.2208 5.27435H11.9859L11.363 5.72799L11.6 6.46602L10.9703 6.0056L10.3474 6.46602L10.5844 5.72122L9.95469 5.26758H10.7333L10.9771 4.52956ZM15.3714 4.52956L15.6083 5.27435H16.387L15.7573 5.72799L16.001 6.46602L15.3714 6.0056L14.7417 6.46602L14.9854 5.72122L14.3557 5.26758H15.1276L15.3714 4.52956ZM19.7589 4.52956L20.0026 5.27435H20.7745L20.1516 5.72799L20.3885 6.46602L19.7589 6.0056L19.1359 6.46602L19.3729 5.72122L18.75 5.26758H19.5219L19.7589 4.52956ZM24.1531 4.52956L24.3901 5.27435H25.1688L24.5391 5.72799L24.7828 6.46602L24.1531 6.0056L23.5234 6.46602L23.7672 5.72122L23.1375 5.26758H23.9161L24.1531 4.52956ZM4.39583 6.39831L4.63281 7.13633H5.41146L4.78177 7.58997L5.01875 8.33476L4.39583 7.87435L3.76615 8.32799L4.00312 7.58997L3.38021 7.13633H4.15208L4.39583 6.39831ZM8.78333 6.39831L9.02708 7.13633H9.79896L9.16927 7.58997L9.41302 8.33476L8.78333 7.87435L8.15365 8.32799L8.3974 7.58997L7.76771 7.13633H8.54635L8.78333 6.39831ZM13.1776 6.39831L13.4146 7.13633H14.1932L13.5635 7.58997L13.8005 8.33476L13.1776 7.87435L12.5479 8.32799L12.7849 7.58997L12.162 7.13633H12.9339L13.1776 6.39831ZM17.5651 6.39831L17.8089 7.13633H18.5807L17.9578 7.58997L18.1948 8.33476L17.5651 7.87435L16.9422 8.32799L17.1792 7.58997L16.5495 7.13633H17.3349L17.5651 6.39831ZM21.9594 6.39831L22.1964 7.13633H22.975L22.3453 7.58997L22.5823 8.33476L21.9594 7.87435L21.3297 8.32799L21.5667 7.58997L20.9438 7.13633H21.7156L21.9594 6.39831ZM2.19531 8.26706L2.43906 9.00508H3.21094L2.58802 9.45872L2.825 10.2035L2.19531 9.7431L1.5724 10.1967L1.80938 9.45872L1.17969 9.00508H1.9651L2.19531 8.26706ZM6.58958 8.26706L6.82656 9.00508H7.60521L6.97552 9.45872L7.2125 10.1967L6.58958 9.7431L5.9599 10.1967L6.19688 9.45872L5.57396 9.00508H6.34583L6.58958 8.26706ZM10.9771 8.26706L11.2208 9.00508H11.9859L11.363 9.45872L11.6 10.2035L10.9703 9.7431L10.3474 10.1967L10.5844 9.45872L9.95469 9.00508H10.7333L10.9771 8.26706ZM15.3714 8.26706L15.6083 9.00508H16.387L15.7573 9.45872L16.001 10.2035L15.3714 9.7431L14.7417 10.1967L14.9854 9.45872L14.3557 9.00508H15.1276L15.3714 8.26706ZM19.7589 8.26706L20.0026 9.00508H20.7745L20.1516 9.45872L20.3885 10.2035L19.7589 9.7431L19.1359 10.1967L19.3729 9.45872L18.75 9.00508H19.5219L19.7589 8.26706ZM24.1531 8.26706L24.3901 9.00508H25.1688L24.5391 9.45872L24.7828 10.2035L24.1531 9.7431L23.5234 10.1967L23.7672 9.45872L23.1375 9.00508H23.9161L24.1531 8.26706ZM4.39583 10.1358L4.63281 10.8738H5.41146L4.78177 11.3275L5.01875 12.0655L4.39583 11.6051L3.76615 12.0655L4.00312 11.3207L3.38021 10.8671H4.15208L4.39583 10.1358ZM8.78333 10.1358L9.02708 10.8738H9.79896L9.16927 11.3275L9.41302 12.0655L8.78333 11.6051L8.15365 12.0655L8.3974 11.3207L7.76771 10.8671H8.54635L8.78333 10.1358ZM13.1776 10.1358L13.4146 10.8738H14.1932L13.5635 11.3275L13.8005 12.0655L13.1776 11.6051L12.5479 12.0655L12.7849 11.3207L12.162 10.8671H12.9339L13.1776 10.1358ZM17.5651 10.1358L17.8089 10.8738H18.5807L17.9578 11.3275L18.1948 12.0655L17.5651 11.6051L16.9422 12.0655L17.1792 11.3207L16.5495 10.8671H17.3349L17.5651 10.1358ZM21.9594 10.1358L22.1964 10.8738H22.975L22.3453 11.3275L22.5823 12.0655L21.9594 11.6051L21.3297 12.0655L21.5667 11.3207L20.9438 10.8671H21.7156L21.9594 10.1358ZM2.19531 11.9978L2.43906 12.7426H3.21094L2.58802 13.1962L2.825 13.9275L2.19531 13.4738L1.5724 13.9275L1.80938 13.1895L1.17969 12.7358H1.9651L2.19531 11.9978ZM6.58958 11.9978L6.82656 12.7426H7.60521L6.97552 13.1962L7.21927 13.9275L6.58958 13.4738L5.9599 13.9275L6.20365 13.1895L5.57396 12.7358H6.34583L6.58958 11.9978ZM10.9771 11.9978L11.2208 12.7426H11.9859L11.363 13.1962L11.6 13.9275L10.9703 13.4738L10.3474 13.9275L10.5844 13.1895L9.95469 12.7358H10.7333L10.9771 11.9978ZM15.3714 11.9978L15.6083 12.7426H16.387L15.7573 13.1962L16.001 13.9275L15.3714 13.4738L14.7417 13.9275L14.9854 13.1895L14.3557 12.7358H15.1276L15.3714 11.9978ZM19.7589 11.9978L20.0026 12.7426H20.7745L20.1516 13.1962L20.3885 13.9275L19.7589 13.4738L19.1359 13.9275L19.3729 13.1895L18.75 12.7358H19.5219L19.7589 11.9978ZM24.1531 11.9978L24.3901 12.7426H25.1688L24.5391 13.1962L24.7828 13.9275L24.1531 13.4738L23.5234 13.9275L23.7672 13.1895L23.1375 12.7358H23.9161L24.1531 11.9978ZM4.39583 13.8665L4.63281 14.6046H5.41146L4.78177 15.0582L5.01875 15.803L4.39583 15.3426L3.76615 15.7962L4.00312 15.0582L3.38021 14.6046H4.15208L4.39583 13.8665ZM8.78333 13.8665L9.02708 14.6046H9.79896L9.16927 15.0582L9.41302 15.803L8.78333 15.3426L8.15365 15.7962L8.3974 15.0582L7.76771 14.6046H8.54635L8.78333 13.8665ZM13.1776 13.8665L13.4146 14.6046H14.1932L13.5635 15.0582L13.8005 15.803L13.1776 15.3426L12.5479 15.7962L12.7849 15.0582L12.162 14.6046H12.9339L13.1776 13.8665ZM17.5651 13.8665L17.8089 14.6046H18.5807L17.9578 15.0582L18.1948 15.803L17.5651 15.3426L16.9422 15.7962L17.1792 15.0582L16.5495 14.6046H17.3349L17.5651 13.8665ZM21.9594 13.8665L22.1964 14.6046H22.975L22.3453 15.0582L22.5823 15.803L21.9594 15.3426L21.3297 15.7962L21.5667 15.0582L20.9438 14.6046H21.7156L21.9594 13.8665ZM2.19531 15.7353L2.43906 16.4733H3.21094L2.58802 16.927L2.825 17.665L2.19531 17.2113L1.5724 17.665L1.80938 16.9202L1.17969 16.4665H1.9651L2.19531 15.7353ZM6.58958 15.7353L6.82656 16.4733H7.60521L6.97552 16.927L7.21927 17.665L6.58958 17.2113L5.9599 17.665L6.20365 16.9202L5.57396 16.4665H6.34583L6.58958 15.7353ZM10.9771 15.7353L11.2208 16.4733H11.9859L11.3766 16.927L11.6135 17.665L10.9839 17.2113L10.3609 17.665L10.5979 16.9202L9.96823 16.4665H10.7469L10.9771 15.7353ZM15.3714 15.7353L15.6083 16.4733H16.387L15.7573 16.927L16.001 17.665L15.3714 17.2113L14.7417 17.665L14.9854 16.9202L14.3557 16.4665H15.1276L15.3714 15.7353ZM19.7589 15.7353L20.0026 16.4733H20.7745L20.1516 16.927L20.3885 17.665L19.7589 17.2113L19.1359 17.665L19.3729 16.9202L18.75 16.4665H19.5219L19.7589 15.7353ZM24.1531 15.7353L24.3901 16.4733H25.1688L24.5391 16.927L24.7828 17.665L24.1531 17.2113L23.5234 17.665L23.7672 16.9202L23.1375 16.4665H23.9161L24.1531 15.7353Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            id="svg-983728359_11122"
          >
            <path
              d="M12.0605 0L11.5469 1.71193L12.4028 1.88313L12.0605 0Z"
              fill="#FFCC00"
            />
            <path
              d="M12.0606 0L12.5742 1.71193L11.7183 1.88313L12.0606 0Z"
              fill="#FFCC00"
            />
            <path
              d="M13.69 1.18278L11.9031 1.22335L12.0048 2.09033L13.69 1.18278Z"
              fill="#FFCC00"
            />
            <path
              d="M13.689 1.18294L12.2195 2.2004L11.7922 1.43923L13.689 1.18294Z"
              fill="#FFCC00"
            />
            <path
              d="M13.065 3.0968L12.4742 1.40994L11.6811 1.77456L13.065 3.0968Z"
              fill="#FFCC00"
            />
            <path
              d="M13.0639 3.09656L11.6422 2.01345L12.2341 1.37183L13.0639 3.09656Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4311 1.18278L12.218 1.22335L12.1163 2.09033L10.4311 1.18278Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4321 1.18294L11.9016 2.2004L12.3289 1.43923L10.4321 1.18294Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0561 3.0968L11.6469 1.40994L12.44 1.77456L11.0561 3.0968Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0572 3.09656L12.4789 2.01345L11.887 1.37183L11.0572 3.09656Z"
              fill="#FFCC00"
            />
            <path
              d="M12.0605 20.543L11.5469 22.2549L12.4028 22.4261L12.0605 20.543Z"
              fill="#FFCC00"
            />
            <path
              d="M12.0606 20.543L12.5742 22.2549L11.7183 22.4261L12.0606 20.543Z"
              fill="#FFCC00"
            />
            <path
              d="M13.69 21.7257L11.9031 21.7663L12.0048 22.6333L13.69 21.7257Z"
              fill="#FFCC00"
            />
            <path
              d="M13.689 21.7259L12.2195 22.7434L11.7922 21.9822L13.689 21.7259Z"
              fill="#FFCC00"
            />
            <path
              d="M13.065 23.6398L12.4742 21.9529L11.6811 22.3175L13.065 23.6398Z"
              fill="#FFCC00"
            />
            <path
              d="M13.0639 23.6395L11.6422 22.5564L12.2341 21.9148L13.0639 23.6395Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4311 21.7257L12.218 21.7663L12.1163 22.6333L10.4311 21.7257Z"
              fill="#FFCC00"
            />
            <path
              d="M10.4321 21.7259L11.9016 22.7434L12.3289 21.9822L10.4321 21.7259Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0561 23.6398L11.6469 21.9529L12.44 22.3175L11.0561 23.6398Z"
              fill="#FFCC00"
            />
            <path
              d="M11.0572 23.6395L12.4789 22.5564L11.887 21.9148L11.0572 23.6395Z"
              fill="#FFCC00"
            />
            <path
              d="M1.78702 10.2715L1.27344 11.9834L2.1294 12.1546L1.78702 10.2715Z"
              fill="#FFCC00"
            />
            <path
              d="M1.7872 10.2715L2.30078 11.9834L1.44481 12.1546L1.7872 10.2715Z"
              fill="#FFCC00"
            />
            <path
              d="M3.41652 11.4543L1.62967 11.4948L1.73136 12.3618L3.41652 11.4543Z"
              fill="#FFCC00"
            />
            <path
              d="M3.41551 11.4544L1.94607 12.4719L1.51875 11.7107L3.41551 11.4544Z"
              fill="#FFCC00"
            />
            <path
              d="M2.79154 13.3683L2.20078 11.6814L1.40767 12.046L2.79154 13.3683Z"
              fill="#FFCC00"
            />
            <path
              d="M2.7905 13.368L1.36875 12.2849L1.96062 11.6433L2.7905 13.368Z"
              fill="#FFCC00"
            />
            <path
              d="M0.157701 11.4543L1.94455 11.4948L1.84286 12.3618L0.157701 11.4543Z"
              fill="#FFCC00"
            />
            <path
              d="M0.158705 11.4544L1.62815 12.4719L2.05547 11.7107L0.158705 11.4544Z"
              fill="#FFCC00"
            />
            <path
              d="M0.782683 13.3683L1.37344 11.6814L2.16655 12.046L0.782683 13.3683Z"
              fill="#FFCC00"
            />
            <path
              d="M0.783724 13.368L2.20547 12.2849L1.6136 11.6433L0.783724 13.368Z"
              fill="#FFCC00"
            />
            <path
              d="M6.04154 4.55066L7.46328 3.46756L6.87141 2.82593L6.04154 4.55066Z"
              fill="#FFCC00"
            />
            <path
              d="M6.0405 4.55041L6.63125 2.86355L7.42437 3.22818L6.0405 4.55041Z"
              fill="#FFCC00"
            />
            <path
              d="M5.42042 2.63607L6.88986 3.65353L7.31719 2.89236L5.42042 2.63607Z"
              fill="#FFCC00"
            />
            <path
              d="M5.42333 2.6359L7.21018 2.67648L7.10848 3.54345L5.42333 2.6359Z"
              fill="#FFCC00"
            />
            <path
              d="M7.04874 1.45312L6.53516 3.16506L7.39112 3.33625L7.04874 1.45312Z"
              fill="#FFCC00"
            />
            <path
              d="M7.04892 1.45312L7.5625 3.16506L6.70653 3.33625L7.04892 1.45312Z"
              fill="#FFCC00"
            />
            <path
              d="M8.05612 4.55066L6.63438 3.46756L7.22624 2.82593L8.05612 4.55066Z"
              fill="#FFCC00"
            />
            <path
              d="M8.05716 4.55041L7.46641 2.86355L6.67329 3.22818L8.05716 4.55041Z"
              fill="#FFCC00"
            />
            <path
              d="M8.68114 2.63656L7.2117 3.65402L6.78437 2.89285L8.68114 2.63656Z"
              fill="#FFCC00"
            />
            <path
              d="M8.67824 2.63639L6.89139 2.67697L6.99308 3.54394L8.67824 2.63639Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24857 8.35852L3.65781 6.67166L2.8647 7.03628L4.24857 8.35852Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24753 8.35828L2.82578 7.27517L3.41765 6.63355L4.24753 8.35828Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23685 8.35877L3.65859 7.27566L3.06673 6.63404L2.23685 8.35877Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23581 8.35852L2.82656 6.67166L3.61968 7.03628L2.23581 8.35852Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61183 6.44466L3.08127 7.46212L3.50859 6.70095L1.61183 6.44466Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61473 6.4445L3.40158 6.48507L3.29989 7.35205L1.61473 6.4445Z"
              fill="#FFCC00"
            />
            <path
              d="M4.87254 6.44466L3.4031 7.46212L2.97578 6.70095L4.87254 6.44466Z"
              fill="#FFCC00"
            />
            <path
              d="M4.86964 6.4445L3.08279 6.48507L3.18449 7.35205L4.86964 6.4445Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24423 5.26172L3.75781 6.97365L2.90185 7.14485L3.24423 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24405 5.26172L2.73047 6.97365L3.58644 7.14485L3.24405 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M4.86964 16.7409L3.08279 16.7815L3.18449 17.6484L4.86964 16.7409Z"
              fill="#FFCC00"
            />
            <path
              d="M4.86864 16.741L3.3992 17.7585L2.97187 16.9973L4.86864 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24857 18.6549L3.65781 16.968L2.8647 17.3327L4.24857 18.6549Z"
              fill="#FFCC00"
            />
            <path
              d="M4.24753 18.6547L2.82578 17.5716L3.41765 16.9299L4.24753 18.6547Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23685 18.6552L3.65859 17.572L3.06673 16.9304L2.23685 18.6552Z"
              fill="#FFCC00"
            />
            <path
              d="M2.23581 18.6549L2.82656 16.968L3.61968 17.3327L2.23581 18.6549Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24423 15.5581L3.75781 17.27L2.90185 17.4412L3.24423 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M3.24405 15.5581L2.73047 17.27L3.58644 17.4412L3.24405 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61473 16.7409L3.40158 16.7815L3.29989 17.6484L1.61473 16.7409Z"
              fill="#FFCC00"
            />
            <path
              d="M1.61574 16.741L3.08518 17.7585L3.5125 16.9973L1.61574 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M8.58449 20.1867L6.79764 20.2273L6.89933 21.0942L8.58449 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M8.58348 20.1868L7.11404 21.2043L6.68672 20.4431L8.58348 20.1868Z"
              fill="#FFCC00"
            />
            <path
              d="M7.96341 22.1007L7.37266 20.4138L6.57954 20.7785L7.96341 22.1007Z"
              fill="#FFCC00"
            />
            <path
              d="M7.96237 22.1005L6.54063 21.0174L7.13249 20.3757L7.96237 22.1005Z"
              fill="#FFCC00"
            />
            <path
              d="M5.95169 22.101L7.37344 21.0178L6.78157 20.3762L5.95169 22.101Z"
              fill="#FFCC00"
            />
            <path
              d="M5.95065 22.1007L6.54141 20.4138L7.33452 20.7785L5.95065 22.1007Z"
              fill="#FFCC00"
            />
            <path
              d="M6.95908 19.0039L7.47266 20.7158L6.61669 20.887L6.95908 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M6.95889 19.0039L6.44531 20.7158L7.30128 20.887L6.95889 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M5.32958 20.1867L7.11643 20.2273L7.01473 21.0942L5.32958 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M5.33058 20.1868L6.80002 21.2043L7.22734 20.4431L5.33058 20.1868Z"
              fill="#FFCC00"
            />
            <path
              d="M22.3302 10.2715L22.8438 11.9834L21.9878 12.1546L22.3302 10.2715Z"
              fill="#FFCC00"
            />
            <path
              d="M22.33 10.2715L21.8164 11.9834L22.6724 12.1546L22.33 10.2715Z"
              fill="#FFCC00"
            />
            <path
              d="M20.7007 11.4543L22.4875 11.4948L22.3858 12.3618L20.7007 11.4543Z"
              fill="#FFCC00"
            />
            <path
              d="M20.7017 11.4544L22.1711 12.4719L22.5984 11.7107L20.7017 11.4544Z"
              fill="#FFCC00"
            />
            <path
              d="M21.3257 13.3683L21.9164 11.6814L22.7095 12.046L21.3257 13.3683Z"
              fill="#FFCC00"
            />
            <path
              d="M21.3267 13.368L22.7484 12.2849L22.1566 11.6433L21.3267 13.368Z"
              fill="#FFCC00"
            />
            <path
              d="M23.9595 11.4543L22.1726 11.4948L22.2743 12.3618L23.9595 11.4543Z"
              fill="#FFCC00"
            />
            <path
              d="M23.9585 11.4544L22.489 12.4719L22.0617 11.7107L23.9585 11.4544Z"
              fill="#FFCC00"
            />
            <path
              d="M23.3345 13.3683L22.7438 11.6814L21.9506 12.046L23.3345 13.3683Z"
              fill="#FFCC00"
            />
            <path
              d="M23.3335 13.368L21.9117 12.2849L22.5036 11.6433L23.3335 13.368Z"
              fill="#FFCC00"
            />
            <path
              d="M18.0757 4.55066L16.6539 3.46756L17.2458 2.82593L18.0757 4.55066Z"
              fill="#FFCC00"
            />
            <path
              d="M18.0767 4.55041L17.4859 2.86355L16.6928 3.22818L18.0767 4.55041Z"
              fill="#FFCC00"
            />
            <path
              d="M18.6968 2.63607L17.2273 3.65353L16.8 2.89236L18.6968 2.63607Z"
              fill="#FFCC00"
            />
            <path
              d="M18.6939 2.6359L16.907 2.67648L17.0087 3.54345L18.6939 2.6359Z"
              fill="#FFCC00"
            />
            <path
              d="M17.0685 1.45312L17.582 3.16506L16.7261 3.33625L17.0685 1.45312Z"
              fill="#FFCC00"
            />
            <path
              d="M17.0683 1.45312L16.5547 3.16506L17.4107 3.33625L17.0683 1.45312Z"
              fill="#FFCC00"
            />
            <path
              d="M16.0611 4.55066L17.4828 3.46756L16.8909 2.82593L16.0611 4.55066Z"
              fill="#FFCC00"
            />
            <path
              d="M16.06 4.55041L16.6508 2.86355L17.4439 3.22818L16.06 4.55041Z"
              fill="#FFCC00"
            />
            <path
              d="M15.436 2.63656L16.9055 3.65402L17.3328 2.89285L15.436 2.63656Z"
              fill="#FFCC00"
            />
            <path
              d="M15.439 2.63639L17.2258 2.67697L17.1241 3.54394L15.439 2.63639Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8686 8.35852L20.4594 6.67166L21.2525 7.03628L19.8686 8.35852Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8697 8.35828L21.2914 7.27517L20.6995 6.63355L19.8697 8.35828Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8803 8.35877L20.4586 7.27566L21.0505 6.63404L21.8803 8.35877Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8814 8.35852L21.2906 6.67166L20.4975 7.03628L21.8814 8.35852Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5054 6.44466L21.0359 7.46212L20.6086 6.70095L22.5054 6.44466Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5025 6.4445L20.7156 6.48507L20.8173 7.35205L22.5025 6.4445Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2446 6.44515L20.7141 7.46261L21.1414 6.70144L19.2446 6.44515Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2475 6.44499L21.0344 6.48556L20.9327 7.35253L19.2475 6.44499Z"
              fill="#FFCC00"
            />
            <path
              d="M20.873 5.26172L20.3594 6.97365L21.2153 7.14485L20.873 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M20.8731 5.26172L21.3867 6.97365L20.5308 7.14485L20.8731 5.26172Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2475 16.7409L21.0344 16.7815L20.9327 17.6484L19.2475 16.7409Z"
              fill="#FFCC00"
            />
            <path
              d="M19.2485 16.741L20.718 17.7585L21.1453 16.9973L19.2485 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8686 18.6549L20.4594 16.968L21.2525 17.3327L19.8686 18.6549Z"
              fill="#FFCC00"
            />
            <path
              d="M19.8697 18.6547L21.2914 17.5716L20.6995 16.9299L19.8697 18.6547Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8803 18.6552L20.4586 17.572L21.0505 16.9304L21.8803 18.6552Z"
              fill="#FFCC00"
            />
            <path
              d="M21.8814 18.6549L21.2906 16.968L20.4975 17.3327L21.8814 18.6549Z"
              fill="#FFCC00"
            />
            <path
              d="M20.873 15.5581L20.3594 17.27L21.2153 17.4412L20.873 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M20.8731 15.5581L21.3867 17.27L20.5308 17.4412L20.8731 15.5581Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5025 16.7409L20.7156 16.7815L20.8173 17.6484L22.5025 16.7409Z"
              fill="#FFCC00"
            />
            <path
              d="M22.5015 16.741L21.032 17.7585L20.6047 16.9973L22.5015 16.741Z"
              fill="#FFCC00"
            />
            <path
              d="M15.5327 20.1867L17.3196 20.2273L17.2179 21.0942L15.5327 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M15.5337 20.1868L17.0031 21.2043L17.4305 20.4431L15.5337 20.1868Z"
              fill="#FFCC00"
            />
            <path
              d="M16.1538 22.1007L16.7445 20.4138L17.5376 20.7785L16.1538 22.1007Z"
              fill="#FFCC00"
            />
            <path
              d="M16.1548 22.1005L17.5766 21.0174L16.9847 20.3757L16.1548 22.1005Z"
              fill="#FFCC00"
            />
            <path
              d="M18.1655 22.101L16.7438 21.0178L17.3356 20.3762L18.1655 22.101Z"
              fill="#FFCC00"
            />
            <path
              d="M18.1665 22.1007L17.5758 20.4138L16.7827 20.7785L18.1665 22.1007Z"
              fill="#FFCC00"
            />
            <path
              d="M17.1581 19.0039L16.6445 20.7158L17.5005 20.887L17.1581 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M17.1583 19.0039L17.6719 20.7158L16.8159 20.887L17.1583 19.0039Z"
              fill="#FFCC00"
            />
            <path
              d="M18.7876 20.1867L17.0008 20.2273L17.1025 21.0942L18.7876 20.1867Z"
              fill="#FFCC00"
            />
            <path
              d="M18.7866 20.1868L17.3172 21.2043L16.8898 20.4431L18.7866 20.1868Z"
              fill="#FFCC00"
            />
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg-1372703318_9012"
          >
            <mask
              id="svg-1372703318_9012_mask0_1696_2309"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="47"
              height="35"
            >
              <path d="M0 0H46.2245V34.6667H0V0Z" fill="white" />
            </mask>
            <g mask="url(#svg-1372703318_9012_mask0_1696_2309)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H65.8667V2.66771H0V0ZM0 5.33542H65.8667V8.00313H0V5.33542ZM0 10.6641H65.8667V13.3385H0V10.6641ZM0 15.9995H65.8667V18.6672H0V15.9995ZM0 21.3349H65.8667V24.0026H0V21.3349ZM0 26.6635H65.8667V29.3313H0V26.6635ZM0 31.999H65.8667V34.6667H0V31.999Z"
                fill="#BD3D44"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.66748H65.8667V5.33519H0V2.66748ZM0 8.0029H65.8667V10.6638H0V8.0029ZM0 13.3315H65.8667V15.9993H0V13.3315ZM0 18.667H65.8667V21.3347H0V18.667ZM0 24.0024H65.8667V26.6701H0V24.0024ZM0 29.331H65.8667V31.9987H0V29.331Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H26.3453V18.6672H0V0Z"
                fill="#192F5D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.19531 0.798828L2.43906 1.53685H3.21094L2.58802 1.99049L2.825 2.73529L2.19531 2.27487L1.5724 2.72852L1.80938 1.99049L1.17969 1.53685H1.9651L2.19531 0.798828ZM6.58958 0.798828L6.82656 1.53685H7.60521L6.97552 1.99049L7.2125 2.73529L6.58958 2.27487L5.9599 2.72852L6.19688 1.99049L5.57396 1.53685H6.34583L6.58958 0.798828ZM10.9771 0.798828L11.2208 1.53685H11.9859L11.363 1.99049L11.6 2.73529L10.9703 2.27487L10.3474 2.72852L10.5844 1.99049L9.95469 1.53685H10.7333L10.9771 0.798828ZM15.3714 0.798828L15.6083 1.53685H16.387L15.7573 1.99049L16.001 2.73529L15.3714 2.27487L14.7417 2.72852L14.9854 1.99049L14.3557 1.53685H15.1276L15.3714 0.798828ZM19.7589 0.798828L20.0026 1.53685H20.7745L20.1516 1.99049L20.3885 2.73529L19.7589 2.27487L19.1359 2.72852L19.3729 1.99049L18.75 1.53685H19.5219L19.7589 0.798828ZM24.1531 0.798828L24.3901 1.53685H25.1688L24.5391 1.99049L24.7828 2.73529L24.1531 2.27487L23.5234 2.72852L23.7672 1.99049L23.1375 1.53685H23.9161L24.1531 0.798828ZM4.39583 2.66758L4.63281 3.4056H5.41146L4.78177 3.85924L5.01198 4.59727L4.4026 4.14362L3.77292 4.59727L3.99635 3.85924L3.38698 3.4056H4.15885L4.39583 2.66758ZM8.78333 2.66758L9.02708 3.4056H9.79896L9.16927 3.85924L9.41302 4.59727L8.78333 4.14362L8.15365 4.59727L8.3974 3.85924L7.76771 3.4056H8.54635L8.78333 2.66758ZM13.1776 2.66758L13.4146 3.4056H14.1932L13.5635 3.85924L13.8005 4.59727L13.1776 4.14362L12.5479 4.59727L12.7849 3.85924L12.162 3.4056H12.9339L13.1776 2.66758ZM17.5651 2.66758L17.8089 3.4056H18.5807L17.951 3.85924L18.1948 4.59727L17.5651 4.14362L16.9422 4.59727L17.1792 3.85924L16.5495 3.4056H17.3349L17.5651 2.66758ZM21.9594 2.66758L22.1964 3.4056H22.975L22.3453 3.85924L22.5823 4.59727L21.9594 4.14362L21.3297 4.59727L21.5667 3.85924L20.9438 3.4056H21.7156L21.9594 2.66758ZM2.19531 4.52956L2.43906 5.28112H3.21094L2.58802 5.73476L2.825 6.47279L2.19531 6.01237L1.5724 6.47279L1.80938 5.72799L1.17969 5.27435H1.9651L2.19531 4.52956ZM6.58958 4.52956L6.82656 5.27435H7.60521L6.97552 5.72799L7.2125 6.46602L6.58958 6.0056L5.9599 6.46602L6.19688 5.72122L5.57396 5.26758H6.34583L6.58958 4.52956ZM10.9771 4.52956L11.2208 5.27435H11.9859L11.363 5.72799L11.6 6.46602L10.9703 6.0056L10.3474 6.46602L10.5844 5.72122L9.95469 5.26758H10.7333L10.9771 4.52956ZM15.3714 4.52956L15.6083 5.27435H16.387L15.7573 5.72799L16.001 6.46602L15.3714 6.0056L14.7417 6.46602L14.9854 5.72122L14.3557 5.26758H15.1276L15.3714 4.52956ZM19.7589 4.52956L20.0026 5.27435H20.7745L20.1516 5.72799L20.3885 6.46602L19.7589 6.0056L19.1359 6.46602L19.3729 5.72122L18.75 5.26758H19.5219L19.7589 4.52956ZM24.1531 4.52956L24.3901 5.27435H25.1688L24.5391 5.72799L24.7828 6.46602L24.1531 6.0056L23.5234 6.46602L23.7672 5.72122L23.1375 5.26758H23.9161L24.1531 4.52956ZM4.39583 6.39831L4.63281 7.13633H5.41146L4.78177 7.58997L5.01875 8.33476L4.39583 7.87435L3.76615 8.32799L4.00312 7.58997L3.38021 7.13633H4.15208L4.39583 6.39831ZM8.78333 6.39831L9.02708 7.13633H9.79896L9.16927 7.58997L9.41302 8.33476L8.78333 7.87435L8.15365 8.32799L8.3974 7.58997L7.76771 7.13633H8.54635L8.78333 6.39831ZM13.1776 6.39831L13.4146 7.13633H14.1932L13.5635 7.58997L13.8005 8.33476L13.1776 7.87435L12.5479 8.32799L12.7849 7.58997L12.162 7.13633H12.9339L13.1776 6.39831ZM17.5651 6.39831L17.8089 7.13633H18.5807L17.9578 7.58997L18.1948 8.33476L17.5651 7.87435L16.9422 8.32799L17.1792 7.58997L16.5495 7.13633H17.3349L17.5651 6.39831ZM21.9594 6.39831L22.1964 7.13633H22.975L22.3453 7.58997L22.5823 8.33476L21.9594 7.87435L21.3297 8.32799L21.5667 7.58997L20.9438 7.13633H21.7156L21.9594 6.39831ZM2.19531 8.26706L2.43906 9.00508H3.21094L2.58802 9.45872L2.825 10.2035L2.19531 9.7431L1.5724 10.1967L1.80938 9.45872L1.17969 9.00508H1.9651L2.19531 8.26706ZM6.58958 8.26706L6.82656 9.00508H7.60521L6.97552 9.45872L7.2125 10.1967L6.58958 9.7431L5.9599 10.1967L6.19688 9.45872L5.57396 9.00508H6.34583L6.58958 8.26706ZM10.9771 8.26706L11.2208 9.00508H11.9859L11.363 9.45872L11.6 10.2035L10.9703 9.7431L10.3474 10.1967L10.5844 9.45872L9.95469 9.00508H10.7333L10.9771 8.26706ZM15.3714 8.26706L15.6083 9.00508H16.387L15.7573 9.45872L16.001 10.2035L15.3714 9.7431L14.7417 10.1967L14.9854 9.45872L14.3557 9.00508H15.1276L15.3714 8.26706ZM19.7589 8.26706L20.0026 9.00508H20.7745L20.1516 9.45872L20.3885 10.2035L19.7589 9.7431L19.1359 10.1967L19.3729 9.45872L18.75 9.00508H19.5219L19.7589 8.26706ZM24.1531 8.26706L24.3901 9.00508H25.1688L24.5391 9.45872L24.7828 10.2035L24.1531 9.7431L23.5234 10.1967L23.7672 9.45872L23.1375 9.00508H23.9161L24.1531 8.26706ZM4.39583 10.1358L4.63281 10.8738H5.41146L4.78177 11.3275L5.01875 12.0655L4.39583 11.6051L3.76615 12.0655L4.00312 11.3207L3.38021 10.8671H4.15208L4.39583 10.1358ZM8.78333 10.1358L9.02708 10.8738H9.79896L9.16927 11.3275L9.41302 12.0655L8.78333 11.6051L8.15365 12.0655L8.3974 11.3207L7.76771 10.8671H8.54635L8.78333 10.1358ZM13.1776 10.1358L13.4146 10.8738H14.1932L13.5635 11.3275L13.8005 12.0655L13.1776 11.6051L12.5479 12.0655L12.7849 11.3207L12.162 10.8671H12.9339L13.1776 10.1358ZM17.5651 10.1358L17.8089 10.8738H18.5807L17.9578 11.3275L18.1948 12.0655L17.5651 11.6051L16.9422 12.0655L17.1792 11.3207L16.5495 10.8671H17.3349L17.5651 10.1358ZM21.9594 10.1358L22.1964 10.8738H22.975L22.3453 11.3275L22.5823 12.0655L21.9594 11.6051L21.3297 12.0655L21.5667 11.3207L20.9438 10.8671H21.7156L21.9594 10.1358ZM2.19531 11.9978L2.43906 12.7426H3.21094L2.58802 13.1962L2.825 13.9275L2.19531 13.4738L1.5724 13.9275L1.80938 13.1895L1.17969 12.7358H1.9651L2.19531 11.9978ZM6.58958 11.9978L6.82656 12.7426H7.60521L6.97552 13.1962L7.21927 13.9275L6.58958 13.4738L5.9599 13.9275L6.20365 13.1895L5.57396 12.7358H6.34583L6.58958 11.9978ZM10.9771 11.9978L11.2208 12.7426H11.9859L11.363 13.1962L11.6 13.9275L10.9703 13.4738L10.3474 13.9275L10.5844 13.1895L9.95469 12.7358H10.7333L10.9771 11.9978ZM15.3714 11.9978L15.6083 12.7426H16.387L15.7573 13.1962L16.001 13.9275L15.3714 13.4738L14.7417 13.9275L14.9854 13.1895L14.3557 12.7358H15.1276L15.3714 11.9978ZM19.7589 11.9978L20.0026 12.7426H20.7745L20.1516 13.1962L20.3885 13.9275L19.7589 13.4738L19.1359 13.9275L19.3729 13.1895L18.75 12.7358H19.5219L19.7589 11.9978ZM24.1531 11.9978L24.3901 12.7426H25.1688L24.5391 13.1962L24.7828 13.9275L24.1531 13.4738L23.5234 13.9275L23.7672 13.1895L23.1375 12.7358H23.9161L24.1531 11.9978ZM4.39583 13.8665L4.63281 14.6046H5.41146L4.78177 15.0582L5.01875 15.803L4.39583 15.3426L3.76615 15.7962L4.00312 15.0582L3.38021 14.6046H4.15208L4.39583 13.8665ZM8.78333 13.8665L9.02708 14.6046H9.79896L9.16927 15.0582L9.41302 15.803L8.78333 15.3426L8.15365 15.7962L8.3974 15.0582L7.76771 14.6046H8.54635L8.78333 13.8665ZM13.1776 13.8665L13.4146 14.6046H14.1932L13.5635 15.0582L13.8005 15.803L13.1776 15.3426L12.5479 15.7962L12.7849 15.0582L12.162 14.6046H12.9339L13.1776 13.8665ZM17.5651 13.8665L17.8089 14.6046H18.5807L17.9578 15.0582L18.1948 15.803L17.5651 15.3426L16.9422 15.7962L17.1792 15.0582L16.5495 14.6046H17.3349L17.5651 13.8665ZM21.9594 13.8665L22.1964 14.6046H22.975L22.3453 15.0582L22.5823 15.803L21.9594 15.3426L21.3297 15.7962L21.5667 15.0582L20.9438 14.6046H21.7156L21.9594 13.8665ZM2.19531 15.7353L2.43906 16.4733H3.21094L2.58802 16.927L2.825 17.665L2.19531 17.2113L1.5724 17.665L1.80938 16.9202L1.17969 16.4665H1.9651L2.19531 15.7353ZM6.58958 15.7353L6.82656 16.4733H7.60521L6.97552 16.927L7.21927 17.665L6.58958 17.2113L5.9599 17.665L6.20365 16.9202L5.57396 16.4665H6.34583L6.58958 15.7353ZM10.9771 15.7353L11.2208 16.4733H11.9859L11.3766 16.927L11.6135 17.665L10.9839 17.2113L10.3609 17.665L10.5979 16.9202L9.96823 16.4665H10.7469L10.9771 15.7353ZM15.3714 15.7353L15.6083 16.4733H16.387L15.7573 16.927L16.001 17.665L15.3714 17.2113L14.7417 17.665L14.9854 16.9202L14.3557 16.4665H15.1276L15.3714 15.7353ZM19.7589 15.7353L20.0026 16.4733H20.7745L20.1516 16.927L20.3885 17.665L19.7589 17.2113L19.1359 17.665L19.3729 16.9202L18.75 16.4665H19.5219L19.7589 15.7353ZM24.1531 15.7353L24.3901 16.4733H25.1688L24.5391 16.927L24.7828 17.665L24.1531 17.2113L23.5234 17.665L23.7672 16.9202L23.1375 16.4665H23.9161L24.1531 15.7353Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            id="svg-1847215915_356"
          >
            <path
              d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z"
              fill="#EFF6FF"
            />
            <path
              d="M13 6L7.5 11.5L5 9"
              stroke="#2563EB"
              strokeWidth={1.16667}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            id="svg1101367428_791"
          >
            <g clipPath="url(#svg1101367428_791_clip0_1570_2677)">
              <path
                d="M8.39843 15.3999C12.2644 15.3999 15.3984 12.2659 15.3984 8.3999C15.3984 4.53391 12.2644 1.3999 8.39843 1.3999C4.53244 1.3999 1.39844 4.53391 1.39844 8.3999C1.39844 12.2659 4.53244 15.3999 8.39843 15.3999Z"
                stroke="#A1A1AA"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.39844 11.1999V8.3999"
                stroke="#A1A1AA"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.39844 5.6001H8.40544"
                stroke="#A1A1AA"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="svg1101367428_791_clip0_1570_2677">
                <rect width="16.8" height="16.8" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg798110794_9012"
          >
            <mask
              id="svg798110794_9012_mask0_1696_1914"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="47"
              height="35"
            >
              <path d="M0 0H46.2245V34.6667H0V0Z" fill="white" />
            </mask>
            <g mask="url(#svg798110794_9012_mask0_1696_1914)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H65.8667V2.66771H0V0ZM0 5.33542H65.8667V8.00313H0V5.33542ZM0 10.6641H65.8667V13.3385H0V10.6641ZM0 15.9995H65.8667V18.6672H0V15.9995ZM0 21.3349H65.8667V24.0026H0V21.3349ZM0 26.6635H65.8667V29.3313H0V26.6635ZM0 31.999H65.8667V34.6667H0V31.999Z"
                fill="#BD3D44"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.66748H65.8667V5.33519H0V2.66748ZM0 8.0029H65.8667V10.6638H0V8.0029ZM0 13.3315H65.8667V15.9993H0V13.3315ZM0 18.667H65.8667V21.3347H0V18.667ZM0 24.0024H65.8667V26.6701H0V24.0024ZM0 29.331H65.8667V31.9987H0V29.331Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H26.3453V18.6672H0V0Z"
                fill="#192F5D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.19531 0.798828L2.43906 1.53685H3.21094L2.58802 1.99049L2.825 2.73529L2.19531 2.27487L1.5724 2.72852L1.80938 1.99049L1.17969 1.53685H1.9651L2.19531 0.798828ZM6.58958 0.798828L6.82656 1.53685H7.60521L6.97552 1.99049L7.2125 2.73529L6.58958 2.27487L5.9599 2.72852L6.19688 1.99049L5.57396 1.53685H6.34583L6.58958 0.798828ZM10.9771 0.798828L11.2208 1.53685H11.9859L11.363 1.99049L11.6 2.73529L10.9703 2.27487L10.3474 2.72852L10.5844 1.99049L9.95469 1.53685H10.7333L10.9771 0.798828ZM15.3714 0.798828L15.6083 1.53685H16.387L15.7573 1.99049L16.001 2.73529L15.3714 2.27487L14.7417 2.72852L14.9854 1.99049L14.3557 1.53685H15.1276L15.3714 0.798828ZM19.7589 0.798828L20.0026 1.53685H20.7745L20.1516 1.99049L20.3885 2.73529L19.7589 2.27487L19.1359 2.72852L19.3729 1.99049L18.75 1.53685H19.5219L19.7589 0.798828ZM24.1531 0.798828L24.3901 1.53685H25.1688L24.5391 1.99049L24.7828 2.73529L24.1531 2.27487L23.5234 2.72852L23.7672 1.99049L23.1375 1.53685H23.9161L24.1531 0.798828ZM4.39583 2.66758L4.63281 3.4056H5.41146L4.78177 3.85924L5.01198 4.59727L4.4026 4.14362L3.77292 4.59727L3.99635 3.85924L3.38698 3.4056H4.15885L4.39583 2.66758ZM8.78333 2.66758L9.02708 3.4056H9.79896L9.16927 3.85924L9.41302 4.59727L8.78333 4.14362L8.15365 4.59727L8.3974 3.85924L7.76771 3.4056H8.54635L8.78333 2.66758ZM13.1776 2.66758L13.4146 3.4056H14.1932L13.5635 3.85924L13.8005 4.59727L13.1776 4.14362L12.5479 4.59727L12.7849 3.85924L12.162 3.4056H12.9339L13.1776 2.66758ZM17.5651 2.66758L17.8089 3.4056H18.5807L17.951 3.85924L18.1948 4.59727L17.5651 4.14362L16.9422 4.59727L17.1792 3.85924L16.5495 3.4056H17.3349L17.5651 2.66758ZM21.9594 2.66758L22.1964 3.4056H22.975L22.3453 3.85924L22.5823 4.59727L21.9594 4.14362L21.3297 4.59727L21.5667 3.85924L20.9438 3.4056H21.7156L21.9594 2.66758ZM2.19531 4.52956L2.43906 5.28112H3.21094L2.58802 5.73476L2.825 6.47279L2.19531 6.01237L1.5724 6.47279L1.80938 5.72799L1.17969 5.27435H1.9651L2.19531 4.52956ZM6.58958 4.52956L6.82656 5.27435H7.60521L6.97552 5.72799L7.2125 6.46602L6.58958 6.0056L5.9599 6.46602L6.19688 5.72122L5.57396 5.26758H6.34583L6.58958 4.52956ZM10.9771 4.52956L11.2208 5.27435H11.9859L11.363 5.72799L11.6 6.46602L10.9703 6.0056L10.3474 6.46602L10.5844 5.72122L9.95469 5.26758H10.7333L10.9771 4.52956ZM15.3714 4.52956L15.6083 5.27435H16.387L15.7573 5.72799L16.001 6.46602L15.3714 6.0056L14.7417 6.46602L14.9854 5.72122L14.3557 5.26758H15.1276L15.3714 4.52956ZM19.7589 4.52956L20.0026 5.27435H20.7745L20.1516 5.72799L20.3885 6.46602L19.7589 6.0056L19.1359 6.46602L19.3729 5.72122L18.75 5.26758H19.5219L19.7589 4.52956ZM24.1531 4.52956L24.3901 5.27435H25.1688L24.5391 5.72799L24.7828 6.46602L24.1531 6.0056L23.5234 6.46602L23.7672 5.72122L23.1375 5.26758H23.9161L24.1531 4.52956ZM4.39583 6.39831L4.63281 7.13633H5.41146L4.78177 7.58997L5.01875 8.33476L4.39583 7.87435L3.76615 8.32799L4.00312 7.58997L3.38021 7.13633H4.15208L4.39583 6.39831ZM8.78333 6.39831L9.02708 7.13633H9.79896L9.16927 7.58997L9.41302 8.33476L8.78333 7.87435L8.15365 8.32799L8.3974 7.58997L7.76771 7.13633H8.54635L8.78333 6.39831ZM13.1776 6.39831L13.4146 7.13633H14.1932L13.5635 7.58997L13.8005 8.33476L13.1776 7.87435L12.5479 8.32799L12.7849 7.58997L12.162 7.13633H12.9339L13.1776 6.39831ZM17.5651 6.39831L17.8089 7.13633H18.5807L17.9578 7.58997L18.1948 8.33476L17.5651 7.87435L16.9422 8.32799L17.1792 7.58997L16.5495 7.13633H17.3349L17.5651 6.39831ZM21.9594 6.39831L22.1964 7.13633H22.975L22.3453 7.58997L22.5823 8.33476L21.9594 7.87435L21.3297 8.32799L21.5667 7.58997L20.9438 7.13633H21.7156L21.9594 6.39831ZM2.19531 8.26706L2.43906 9.00508H3.21094L2.58802 9.45872L2.825 10.2035L2.19531 9.7431L1.5724 10.1967L1.80938 9.45872L1.17969 9.00508H1.9651L2.19531 8.26706ZM6.58958 8.26706L6.82656 9.00508H7.60521L6.97552 9.45872L7.2125 10.1967L6.58958 9.7431L5.9599 10.1967L6.19688 9.45872L5.57396 9.00508H6.34583L6.58958 8.26706ZM10.9771 8.26706L11.2208 9.00508H11.9859L11.363 9.45872L11.6 10.2035L10.9703 9.7431L10.3474 10.1967L10.5844 9.45872L9.95469 9.00508H10.7333L10.9771 8.26706ZM15.3714 8.26706L15.6083 9.00508H16.387L15.7573 9.45872L16.001 10.2035L15.3714 9.7431L14.7417 10.1967L14.9854 9.45872L14.3557 9.00508H15.1276L15.3714 8.26706ZM19.7589 8.26706L20.0026 9.00508H20.7745L20.1516 9.45872L20.3885 10.2035L19.7589 9.7431L19.1359 10.1967L19.3729 9.45872L18.75 9.00508H19.5219L19.7589 8.26706ZM24.1531 8.26706L24.3901 9.00508H25.1688L24.5391 9.45872L24.7828 10.2035L24.1531 9.7431L23.5234 10.1967L23.7672 9.45872L23.1375 9.00508H23.9161L24.1531 8.26706ZM4.39583 10.1358L4.63281 10.8738H5.41146L4.78177 11.3275L5.01875 12.0655L4.39583 11.6051L3.76615 12.0655L4.00312 11.3207L3.38021 10.8671H4.15208L4.39583 10.1358ZM8.78333 10.1358L9.02708 10.8738H9.79896L9.16927 11.3275L9.41302 12.0655L8.78333 11.6051L8.15365 12.0655L8.3974 11.3207L7.76771 10.8671H8.54635L8.78333 10.1358ZM13.1776 10.1358L13.4146 10.8738H14.1932L13.5635 11.3275L13.8005 12.0655L13.1776 11.6051L12.5479 12.0655L12.7849 11.3207L12.162 10.8671H12.9339L13.1776 10.1358ZM17.5651 10.1358L17.8089 10.8738H18.5807L17.9578 11.3275L18.1948 12.0655L17.5651 11.6051L16.9422 12.0655L17.1792 11.3207L16.5495 10.8671H17.3349L17.5651 10.1358ZM21.9594 10.1358L22.1964 10.8738H22.975L22.3453 11.3275L22.5823 12.0655L21.9594 11.6051L21.3297 12.0655L21.5667 11.3207L20.9438 10.8671H21.7156L21.9594 10.1358ZM2.19531 11.9978L2.43906 12.7426H3.21094L2.58802 13.1962L2.825 13.9275L2.19531 13.4738L1.5724 13.9275L1.80938 13.1895L1.17969 12.7358H1.9651L2.19531 11.9978ZM6.58958 11.9978L6.82656 12.7426H7.60521L6.97552 13.1962L7.21927 13.9275L6.58958 13.4738L5.9599 13.9275L6.20365 13.1895L5.57396 12.7358H6.34583L6.58958 11.9978ZM10.9771 11.9978L11.2208 12.7426H11.9859L11.363 13.1962L11.6 13.9275L10.9703 13.4738L10.3474 13.9275L10.5844 13.1895L9.95469 12.7358H10.7333L10.9771 11.9978ZM15.3714 11.9978L15.6083 12.7426H16.387L15.7573 13.1962L16.001 13.9275L15.3714 13.4738L14.7417 13.9275L14.9854 13.1895L14.3557 12.7358H15.1276L15.3714 11.9978ZM19.7589 11.9978L20.0026 12.7426H20.7745L20.1516 13.1962L20.3885 13.9275L19.7589 13.4738L19.1359 13.9275L19.3729 13.1895L18.75 12.7358H19.5219L19.7589 11.9978ZM24.1531 11.9978L24.3901 12.7426H25.1688L24.5391 13.1962L24.7828 13.9275L24.1531 13.4738L23.5234 13.9275L23.7672 13.1895L23.1375 12.7358H23.9161L24.1531 11.9978ZM4.39583 13.8665L4.63281 14.6046H5.41146L4.78177 15.0582L5.01875 15.803L4.39583 15.3426L3.76615 15.7962L4.00312 15.0582L3.38021 14.6046H4.15208L4.39583 13.8665ZM8.78333 13.8665L9.02708 14.6046H9.79896L9.16927 15.0582L9.41302 15.803L8.78333 15.3426L8.15365 15.7962L8.3974 15.0582L7.76771 14.6046H8.54635L8.78333 13.8665ZM13.1776 13.8665L13.4146 14.6046H14.1932L13.5635 15.0582L13.8005 15.803L13.1776 15.3426L12.5479 15.7962L12.7849 15.0582L12.162 14.6046H12.9339L13.1776 13.8665ZM17.5651 13.8665L17.8089 14.6046H18.5807L17.9578 15.0582L18.1948 15.803L17.5651 15.3426L16.9422 15.7962L17.1792 15.0582L16.5495 14.6046H17.3349L17.5651 13.8665ZM21.9594 13.8665L22.1964 14.6046H22.975L22.3453 15.0582L22.5823 15.803L21.9594 15.3426L21.3297 15.7962L21.5667 15.0582L20.9438 14.6046H21.7156L21.9594 13.8665ZM2.19531 15.7353L2.43906 16.4733H3.21094L2.58802 16.927L2.825 17.665L2.19531 17.2113L1.5724 17.665L1.80938 16.9202L1.17969 16.4665H1.9651L2.19531 15.7353ZM6.58958 15.7353L6.82656 16.4733H7.60521L6.97552 16.927L7.21927 17.665L6.58958 17.2113L5.9599 17.665L6.20365 16.9202L5.57396 16.4665H6.34583L6.58958 15.7353ZM10.9771 15.7353L11.2208 16.4733H11.9859L11.3766 16.927L11.6135 17.665L10.9839 17.2113L10.3609 17.665L10.5979 16.9202L9.96823 16.4665H10.7469L10.9771 15.7353ZM15.3714 15.7353L15.6083 16.4733H16.387L15.7573 16.927L16.001 17.665L15.3714 17.2113L14.7417 17.665L14.9854 16.9202L14.3557 16.4665H15.1276L15.3714 15.7353ZM19.7589 15.7353L20.0026 16.4733H20.7745L20.1516 16.927L20.3885 17.665L19.7589 17.2113L19.1359 17.665L19.3729 16.9202L18.75 16.4665H19.5219L19.7589 15.7353ZM24.1531 15.7353L24.3901 16.4733H25.1688L24.5391 16.927L24.7828 17.665L24.1531 17.2113L23.5234 17.665L23.7672 16.9202L23.1375 16.4665H23.9161L24.1531 15.7353Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg98887204_9010"
          >
            <mask
              id="svg98887204_9010_mask0_1696_935"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="47"
              height="35"
            >
              <path d="M0 0H46.2245V34.6667H0V0Z" fill="white" />
            </mask>
            <g mask="url(#svg98887204_9010_mask0_1696_935)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H65.8667V2.66771H0V0ZM0 5.33542H65.8667V8.00313H0V5.33542ZM0 10.6641H65.8667V13.3385H0V10.6641ZM0 15.9995H65.8667V18.6672H0V15.9995ZM0 21.3349H65.8667V24.0026H0V21.3349ZM0 26.6635H65.8667V29.3313H0V26.6635ZM0 31.999H65.8667V34.6667H0V31.999Z"
                fill="#BD3D44"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.66748H65.8667V5.33519H0V2.66748ZM0 8.0029H65.8667V10.6638H0V8.0029ZM0 13.3315H65.8667V15.9993H0V13.3315ZM0 18.667H65.8667V21.3347H0V18.667ZM0 24.0024H65.8667V26.6701H0V24.0024ZM0 29.331H65.8667V31.9987H0V29.331Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H26.3453V18.6672H0V0Z"
                fill="#192F5D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.19531 0.798828L2.43906 1.53685H3.21094L2.58802 1.99049L2.825 2.73529L2.19531 2.27487L1.5724 2.72852L1.80938 1.99049L1.17969 1.53685H1.9651L2.19531 0.798828ZM6.58958 0.798828L6.82656 1.53685H7.60521L6.97552 1.99049L7.2125 2.73529L6.58958 2.27487L5.9599 2.72852L6.19688 1.99049L5.57396 1.53685H6.34583L6.58958 0.798828ZM10.9771 0.798828L11.2208 1.53685H11.9859L11.363 1.99049L11.6 2.73529L10.9703 2.27487L10.3474 2.72852L10.5844 1.99049L9.95469 1.53685H10.7333L10.9771 0.798828ZM15.3714 0.798828L15.6083 1.53685H16.387L15.7573 1.99049L16.001 2.73529L15.3714 2.27487L14.7417 2.72852L14.9854 1.99049L14.3557 1.53685H15.1276L15.3714 0.798828ZM19.7589 0.798828L20.0026 1.53685H20.7745L20.1516 1.99049L20.3885 2.73529L19.7589 2.27487L19.1359 2.72852L19.3729 1.99049L18.75 1.53685H19.5219L19.7589 0.798828ZM24.1531 0.798828L24.3901 1.53685H25.1688L24.5391 1.99049L24.7828 2.73529L24.1531 2.27487L23.5234 2.72852L23.7672 1.99049L23.1375 1.53685H23.9161L24.1531 0.798828ZM4.39583 2.66758L4.63281 3.4056H5.41146L4.78177 3.85924L5.01198 4.59727L4.4026 4.14362L3.77292 4.59727L3.99635 3.85924L3.38698 3.4056H4.15885L4.39583 2.66758ZM8.78333 2.66758L9.02708 3.4056H9.79896L9.16927 3.85924L9.41302 4.59727L8.78333 4.14362L8.15365 4.59727L8.3974 3.85924L7.76771 3.4056H8.54635L8.78333 2.66758ZM13.1776 2.66758L13.4146 3.4056H14.1932L13.5635 3.85924L13.8005 4.59727L13.1776 4.14362L12.5479 4.59727L12.7849 3.85924L12.162 3.4056H12.9339L13.1776 2.66758ZM17.5651 2.66758L17.8089 3.4056H18.5807L17.951 3.85924L18.1948 4.59727L17.5651 4.14362L16.9422 4.59727L17.1792 3.85924L16.5495 3.4056H17.3349L17.5651 2.66758ZM21.9594 2.66758L22.1964 3.4056H22.975L22.3453 3.85924L22.5823 4.59727L21.9594 4.14362L21.3297 4.59727L21.5667 3.85924L20.9438 3.4056H21.7156L21.9594 2.66758ZM2.19531 4.52956L2.43906 5.28112H3.21094L2.58802 5.73476L2.825 6.47279L2.19531 6.01237L1.5724 6.47279L1.80938 5.72799L1.17969 5.27435H1.9651L2.19531 4.52956ZM6.58958 4.52956L6.82656 5.27435H7.60521L6.97552 5.72799L7.2125 6.46602L6.58958 6.0056L5.9599 6.46602L6.19688 5.72122L5.57396 5.26758H6.34583L6.58958 4.52956ZM10.9771 4.52956L11.2208 5.27435H11.9859L11.363 5.72799L11.6 6.46602L10.9703 6.0056L10.3474 6.46602L10.5844 5.72122L9.95469 5.26758H10.7333L10.9771 4.52956ZM15.3714 4.52956L15.6083 5.27435H16.387L15.7573 5.72799L16.001 6.46602L15.3714 6.0056L14.7417 6.46602L14.9854 5.72122L14.3557 5.26758H15.1276L15.3714 4.52956ZM19.7589 4.52956L20.0026 5.27435H20.7745L20.1516 5.72799L20.3885 6.46602L19.7589 6.0056L19.1359 6.46602L19.3729 5.72122L18.75 5.26758H19.5219L19.7589 4.52956ZM24.1531 4.52956L24.3901 5.27435H25.1688L24.5391 5.72799L24.7828 6.46602L24.1531 6.0056L23.5234 6.46602L23.7672 5.72122L23.1375 5.26758H23.9161L24.1531 4.52956ZM4.39583 6.39831L4.63281 7.13633H5.41146L4.78177 7.58997L5.01875 8.33476L4.39583 7.87435L3.76615 8.32799L4.00312 7.58997L3.38021 7.13633H4.15208L4.39583 6.39831ZM8.78333 6.39831L9.02708 7.13633H9.79896L9.16927 7.58997L9.41302 8.33476L8.78333 7.87435L8.15365 8.32799L8.3974 7.58997L7.76771 7.13633H8.54635L8.78333 6.39831ZM13.1776 6.39831L13.4146 7.13633H14.1932L13.5635 7.58997L13.8005 8.33476L13.1776 7.87435L12.5479 8.32799L12.7849 7.58997L12.162 7.13633H12.9339L13.1776 6.39831ZM17.5651 6.39831L17.8089 7.13633H18.5807L17.9578 7.58997L18.1948 8.33476L17.5651 7.87435L16.9422 8.32799L17.1792 7.58997L16.5495 7.13633H17.3349L17.5651 6.39831ZM21.9594 6.39831L22.1964 7.13633H22.975L22.3453 7.58997L22.5823 8.33476L21.9594 7.87435L21.3297 8.32799L21.5667 7.58997L20.9438 7.13633H21.7156L21.9594 6.39831ZM2.19531 8.26706L2.43906 9.00508H3.21094L2.58802 9.45872L2.825 10.2035L2.19531 9.7431L1.5724 10.1967L1.80938 9.45872L1.17969 9.00508H1.9651L2.19531 8.26706ZM6.58958 8.26706L6.82656 9.00508H7.60521L6.97552 9.45872L7.2125 10.1967L6.58958 9.7431L5.9599 10.1967L6.19688 9.45872L5.57396 9.00508H6.34583L6.58958 8.26706ZM10.9771 8.26706L11.2208 9.00508H11.9859L11.363 9.45872L11.6 10.2035L10.9703 9.7431L10.3474 10.1967L10.5844 9.45872L9.95469 9.00508H10.7333L10.9771 8.26706ZM15.3714 8.26706L15.6083 9.00508H16.387L15.7573 9.45872L16.001 10.2035L15.3714 9.7431L14.7417 10.1967L14.9854 9.45872L14.3557 9.00508H15.1276L15.3714 8.26706ZM19.7589 8.26706L20.0026 9.00508H20.7745L20.1516 9.45872L20.3885 10.2035L19.7589 9.7431L19.1359 10.1967L19.3729 9.45872L18.75 9.00508H19.5219L19.7589 8.26706ZM24.1531 8.26706L24.3901 9.00508H25.1688L24.5391 9.45872L24.7828 10.2035L24.1531 9.7431L23.5234 10.1967L23.7672 9.45872L23.1375 9.00508H23.9161L24.1531 8.26706ZM4.39583 10.1358L4.63281 10.8738H5.41146L4.78177 11.3275L5.01875 12.0655L4.39583 11.6051L3.76615 12.0655L4.00312 11.3207L3.38021 10.8671H4.15208L4.39583 10.1358ZM8.78333 10.1358L9.02708 10.8738H9.79896L9.16927 11.3275L9.41302 12.0655L8.78333 11.6051L8.15365 12.0655L8.3974 11.3207L7.76771 10.8671H8.54635L8.78333 10.1358ZM13.1776 10.1358L13.4146 10.8738H14.1932L13.5635 11.3275L13.8005 12.0655L13.1776 11.6051L12.5479 12.0655L12.7849 11.3207L12.162 10.8671H12.9339L13.1776 10.1358ZM17.5651 10.1358L17.8089 10.8738H18.5807L17.9578 11.3275L18.1948 12.0655L17.5651 11.6051L16.9422 12.0655L17.1792 11.3207L16.5495 10.8671H17.3349L17.5651 10.1358ZM21.9594 10.1358L22.1964 10.8738H22.975L22.3453 11.3275L22.5823 12.0655L21.9594 11.6051L21.3297 12.0655L21.5667 11.3207L20.9438 10.8671H21.7156L21.9594 10.1358ZM2.19531 11.9978L2.43906 12.7426H3.21094L2.58802 13.1962L2.825 13.9275L2.19531 13.4738L1.5724 13.9275L1.80938 13.1895L1.17969 12.7358H1.9651L2.19531 11.9978ZM6.58958 11.9978L6.82656 12.7426H7.60521L6.97552 13.1962L7.21927 13.9275L6.58958 13.4738L5.9599 13.9275L6.20365 13.1895L5.57396 12.7358H6.34583L6.58958 11.9978ZM10.9771 11.9978L11.2208 12.7426H11.9859L11.363 13.1962L11.6 13.9275L10.9703 13.4738L10.3474 13.9275L10.5844 13.1895L9.95469 12.7358H10.7333L10.9771 11.9978ZM15.3714 11.9978L15.6083 12.7426H16.387L15.7573 13.1962L16.001 13.9275L15.3714 13.4738L14.7417 13.9275L14.9854 13.1895L14.3557 12.7358H15.1276L15.3714 11.9978ZM19.7589 11.9978L20.0026 12.7426H20.7745L20.1516 13.1962L20.3885 13.9275L19.7589 13.4738L19.1359 13.9275L19.3729 13.1895L18.75 12.7358H19.5219L19.7589 11.9978ZM24.1531 11.9978L24.3901 12.7426H25.1688L24.5391 13.1962L24.7828 13.9275L24.1531 13.4738L23.5234 13.9275L23.7672 13.1895L23.1375 12.7358H23.9161L24.1531 11.9978ZM4.39583 13.8665L4.63281 14.6046H5.41146L4.78177 15.0582L5.01875 15.803L4.39583 15.3426L3.76615 15.7962L4.00312 15.0582L3.38021 14.6046H4.15208L4.39583 13.8665ZM8.78333 13.8665L9.02708 14.6046H9.79896L9.16927 15.0582L9.41302 15.803L8.78333 15.3426L8.15365 15.7962L8.3974 15.0582L7.76771 14.6046H8.54635L8.78333 13.8665ZM13.1776 13.8665L13.4146 14.6046H14.1932L13.5635 15.0582L13.8005 15.803L13.1776 15.3426L12.5479 15.7962L12.7849 15.0582L12.162 14.6046H12.9339L13.1776 13.8665ZM17.5651 13.8665L17.8089 14.6046H18.5807L17.9578 15.0582L18.1948 15.803L17.5651 15.3426L16.9422 15.7962L17.1792 15.0582L16.5495 14.6046H17.3349L17.5651 13.8665ZM21.9594 13.8665L22.1964 14.6046H22.975L22.3453 15.0582L22.5823 15.803L21.9594 15.3426L21.3297 15.7962L21.5667 15.0582L20.9438 14.6046H21.7156L21.9594 13.8665ZM2.19531 15.7353L2.43906 16.4733H3.21094L2.58802 16.927L2.825 17.665L2.19531 17.2113L1.5724 17.665L1.80938 16.9202L1.17969 16.4665H1.9651L2.19531 15.7353ZM6.58958 15.7353L6.82656 16.4733H7.60521L6.97552 16.927L7.21927 17.665L6.58958 17.2113L5.9599 17.665L6.20365 16.9202L5.57396 16.4665H6.34583L6.58958 15.7353ZM10.9771 15.7353L11.2208 16.4733H11.9859L11.3766 16.927L11.6135 17.665L10.9839 17.2113L10.3609 17.665L10.5979 16.9202L9.96823 16.4665H10.7469L10.9771 15.7353ZM15.3714 15.7353L15.6083 16.4733H16.387L15.7573 16.927L16.001 17.665L15.3714 17.2113L14.7417 17.665L14.9854 16.9202L14.3557 16.4665H15.1276L15.3714 15.7353ZM19.7589 15.7353L20.0026 16.4733H20.7745L20.1516 16.927L20.3885 17.665L19.7589 17.2113L19.1359 17.665L19.3729 16.9202L18.75 16.4665H19.5219L19.7589 15.7353ZM24.1531 15.7353L24.3901 16.4733H25.1688L24.5391 16.927L24.7828 17.665L24.1531 17.2113L23.5234 17.665L23.7672 16.9202L23.1375 16.4665H23.9161L24.1531 15.7353Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            id="svg-1398115612_791"
          >
            <g clipPath="url(#svg-1398115612_791_clip0_1570_2292)">
              <path
                d="M8.39843 15.3999C12.2644 15.3999 15.3984 12.2659 15.3984 8.3999C15.3984 4.53391 12.2644 1.3999 8.39843 1.3999C4.53244 1.3999 1.39844 4.53391 1.39844 8.3999C1.39844 12.2659 4.53244 15.3999 8.39843 15.3999Z"
                stroke="#A1A1AA"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.39844 11.1999V8.3999"
                stroke="#A1A1AA"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.39844 5.6001H8.40544"
                stroke="#A1A1AA"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="svg-1398115612_791_clip0_1570_2292">
                <rect width="16.8" height="16.8" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg2010212194_9010"
          >
            <mask
              id="svg2010212194_9010_mask0_1696_868"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="47"
              height="35"
            >
              <path d="M0 0H46.2245V34.6667H0V0Z" fill="white" />
            </mask>
            <g mask="url(#svg2010212194_9010_mask0_1696_868)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H65.8667V2.66771H0V0ZM0 5.33542H65.8667V8.00313H0V5.33542ZM0 10.6641H65.8667V13.3385H0V10.6641ZM0 15.9995H65.8667V18.6672H0V15.9995ZM0 21.3349H65.8667V24.0026H0V21.3349ZM0 26.6635H65.8667V29.3313H0V26.6635ZM0 31.999H65.8667V34.6667H0V31.999Z"
                fill="#BD3D44"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.66748H65.8667V5.33519H0V2.66748ZM0 8.0029H65.8667V10.6638H0V8.0029ZM0 13.3315H65.8667V15.9993H0V13.3315ZM0 18.667H65.8667V21.3347H0V18.667ZM0 24.0024H65.8667V26.6701H0V24.0024ZM0 29.331H65.8667V31.9987H0V29.331Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H26.3453V18.6672H0V0Z"
                fill="#192F5D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.19531 0.798828L2.43906 1.53685H3.21094L2.58802 1.99049L2.825 2.73529L2.19531 2.27487L1.5724 2.72852L1.80938 1.99049L1.17969 1.53685H1.9651L2.19531 0.798828ZM6.58958 0.798828L6.82656 1.53685H7.60521L6.97552 1.99049L7.2125 2.73529L6.58958 2.27487L5.9599 2.72852L6.19688 1.99049L5.57396 1.53685H6.34583L6.58958 0.798828ZM10.9771 0.798828L11.2208 1.53685H11.9859L11.363 1.99049L11.6 2.73529L10.9703 2.27487L10.3474 2.72852L10.5844 1.99049L9.95469 1.53685H10.7333L10.9771 0.798828ZM15.3714 0.798828L15.6083 1.53685H16.387L15.7573 1.99049L16.001 2.73529L15.3714 2.27487L14.7417 2.72852L14.9854 1.99049L14.3557 1.53685H15.1276L15.3714 0.798828ZM19.7589 0.798828L20.0026 1.53685H20.7745L20.1516 1.99049L20.3885 2.73529L19.7589 2.27487L19.1359 2.72852L19.3729 1.99049L18.75 1.53685H19.5219L19.7589 0.798828ZM24.1531 0.798828L24.3901 1.53685H25.1688L24.5391 1.99049L24.7828 2.73529L24.1531 2.27487L23.5234 2.72852L23.7672 1.99049L23.1375 1.53685H23.9161L24.1531 0.798828ZM4.39583 2.66758L4.63281 3.4056H5.41146L4.78177 3.85924L5.01198 4.59727L4.4026 4.14362L3.77292 4.59727L3.99635 3.85924L3.38698 3.4056H4.15885L4.39583 2.66758ZM8.78333 2.66758L9.02708 3.4056H9.79896L9.16927 3.85924L9.41302 4.59727L8.78333 4.14362L8.15365 4.59727L8.3974 3.85924L7.76771 3.4056H8.54635L8.78333 2.66758ZM13.1776 2.66758L13.4146 3.4056H14.1932L13.5635 3.85924L13.8005 4.59727L13.1776 4.14362L12.5479 4.59727L12.7849 3.85924L12.162 3.4056H12.9339L13.1776 2.66758ZM17.5651 2.66758L17.8089 3.4056H18.5807L17.951 3.85924L18.1948 4.59727L17.5651 4.14362L16.9422 4.59727L17.1792 3.85924L16.5495 3.4056H17.3349L17.5651 2.66758ZM21.9594 2.66758L22.1964 3.4056H22.975L22.3453 3.85924L22.5823 4.59727L21.9594 4.14362L21.3297 4.59727L21.5667 3.85924L20.9438 3.4056H21.7156L21.9594 2.66758ZM2.19531 4.52956L2.43906 5.28112H3.21094L2.58802 5.73476L2.825 6.47279L2.19531 6.01237L1.5724 6.47279L1.80938 5.72799L1.17969 5.27435H1.9651L2.19531 4.52956ZM6.58958 4.52956L6.82656 5.27435H7.60521L6.97552 5.72799L7.2125 6.46602L6.58958 6.0056L5.9599 6.46602L6.19688 5.72122L5.57396 5.26758H6.34583L6.58958 4.52956ZM10.9771 4.52956L11.2208 5.27435H11.9859L11.363 5.72799L11.6 6.46602L10.9703 6.0056L10.3474 6.46602L10.5844 5.72122L9.95469 5.26758H10.7333L10.9771 4.52956ZM15.3714 4.52956L15.6083 5.27435H16.387L15.7573 5.72799L16.001 6.46602L15.3714 6.0056L14.7417 6.46602L14.9854 5.72122L14.3557 5.26758H15.1276L15.3714 4.52956ZM19.7589 4.52956L20.0026 5.27435H20.7745L20.1516 5.72799L20.3885 6.46602L19.7589 6.0056L19.1359 6.46602L19.3729 5.72122L18.75 5.26758H19.5219L19.7589 4.52956ZM24.1531 4.52956L24.3901 5.27435H25.1688L24.5391 5.72799L24.7828 6.46602L24.1531 6.0056L23.5234 6.46602L23.7672 5.72122L23.1375 5.26758H23.9161L24.1531 4.52956ZM4.39583 6.39831L4.63281 7.13633H5.41146L4.78177 7.58997L5.01875 8.33476L4.39583 7.87435L3.76615 8.32799L4.00312 7.58997L3.38021 7.13633H4.15208L4.39583 6.39831ZM8.78333 6.39831L9.02708 7.13633H9.79896L9.16927 7.58997L9.41302 8.33476L8.78333 7.87435L8.15365 8.32799L8.3974 7.58997L7.76771 7.13633H8.54635L8.78333 6.39831ZM13.1776 6.39831L13.4146 7.13633H14.1932L13.5635 7.58997L13.8005 8.33476L13.1776 7.87435L12.5479 8.32799L12.7849 7.58997L12.162 7.13633H12.9339L13.1776 6.39831ZM17.5651 6.39831L17.8089 7.13633H18.5807L17.9578 7.58997L18.1948 8.33476L17.5651 7.87435L16.9422 8.32799L17.1792 7.58997L16.5495 7.13633H17.3349L17.5651 6.39831ZM21.9594 6.39831L22.1964 7.13633H22.975L22.3453 7.58997L22.5823 8.33476L21.9594 7.87435L21.3297 8.32799L21.5667 7.58997L20.9438 7.13633H21.7156L21.9594 6.39831ZM2.19531 8.26706L2.43906 9.00508H3.21094L2.58802 9.45872L2.825 10.2035L2.19531 9.7431L1.5724 10.1967L1.80938 9.45872L1.17969 9.00508H1.9651L2.19531 8.26706ZM6.58958 8.26706L6.82656 9.00508H7.60521L6.97552 9.45872L7.2125 10.1967L6.58958 9.7431L5.9599 10.1967L6.19688 9.45872L5.57396 9.00508H6.34583L6.58958 8.26706ZM10.9771 8.26706L11.2208 9.00508H11.9859L11.363 9.45872L11.6 10.2035L10.9703 9.7431L10.3474 10.1967L10.5844 9.45872L9.95469 9.00508H10.7333L10.9771 8.26706ZM15.3714 8.26706L15.6083 9.00508H16.387L15.7573 9.45872L16.001 10.2035L15.3714 9.7431L14.7417 10.1967L14.9854 9.45872L14.3557 9.00508H15.1276L15.3714 8.26706ZM19.7589 8.26706L20.0026 9.00508H20.7745L20.1516 9.45872L20.3885 10.2035L19.7589 9.7431L19.1359 10.1967L19.3729 9.45872L18.75 9.00508H19.5219L19.7589 8.26706ZM24.1531 8.26706L24.3901 9.00508H25.1688L24.5391 9.45872L24.7828 10.2035L24.1531 9.7431L23.5234 10.1967L23.7672 9.45872L23.1375 9.00508H23.9161L24.1531 8.26706ZM4.39583 10.1358L4.63281 10.8738H5.41146L4.78177 11.3275L5.01875 12.0655L4.39583 11.6051L3.76615 12.0655L4.00312 11.3207L3.38021 10.8671H4.15208L4.39583 10.1358ZM8.78333 10.1358L9.02708 10.8738H9.79896L9.16927 11.3275L9.41302 12.0655L8.78333 11.6051L8.15365 12.0655L8.3974 11.3207L7.76771 10.8671H8.54635L8.78333 10.1358ZM13.1776 10.1358L13.4146 10.8738H14.1932L13.5635 11.3275L13.8005 12.0655L13.1776 11.6051L12.5479 12.0655L12.7849 11.3207L12.162 10.8671H12.9339L13.1776 10.1358ZM17.5651 10.1358L17.8089 10.8738H18.5807L17.9578 11.3275L18.1948 12.0655L17.5651 11.6051L16.9422 12.0655L17.1792 11.3207L16.5495 10.8671H17.3349L17.5651 10.1358ZM21.9594 10.1358L22.1964 10.8738H22.975L22.3453 11.3275L22.5823 12.0655L21.9594 11.6051L21.3297 12.0655L21.5667 11.3207L20.9438 10.8671H21.7156L21.9594 10.1358ZM2.19531 11.9978L2.43906 12.7426H3.21094L2.58802 13.1962L2.825 13.9275L2.19531 13.4738L1.5724 13.9275L1.80938 13.1895L1.17969 12.7358H1.9651L2.19531 11.9978ZM6.58958 11.9978L6.82656 12.7426H7.60521L6.97552 13.1962L7.21927 13.9275L6.58958 13.4738L5.9599 13.9275L6.20365 13.1895L5.57396 12.7358H6.34583L6.58958 11.9978ZM10.9771 11.9978L11.2208 12.7426H11.9859L11.363 13.1962L11.6 13.9275L10.9703 13.4738L10.3474 13.9275L10.5844 13.1895L9.95469 12.7358H10.7333L10.9771 11.9978ZM15.3714 11.9978L15.6083 12.7426H16.387L15.7573 13.1962L16.001 13.9275L15.3714 13.4738L14.7417 13.9275L14.9854 13.1895L14.3557 12.7358H15.1276L15.3714 11.9978ZM19.7589 11.9978L20.0026 12.7426H20.7745L20.1516 13.1962L20.3885 13.9275L19.7589 13.4738L19.1359 13.9275L19.3729 13.1895L18.75 12.7358H19.5219L19.7589 11.9978ZM24.1531 11.9978L24.3901 12.7426H25.1688L24.5391 13.1962L24.7828 13.9275L24.1531 13.4738L23.5234 13.9275L23.7672 13.1895L23.1375 12.7358H23.9161L24.1531 11.9978ZM4.39583 13.8665L4.63281 14.6046H5.41146L4.78177 15.0582L5.01875 15.803L4.39583 15.3426L3.76615 15.7962L4.00312 15.0582L3.38021 14.6046H4.15208L4.39583 13.8665ZM8.78333 13.8665L9.02708 14.6046H9.79896L9.16927 15.0582L9.41302 15.803L8.78333 15.3426L8.15365 15.7962L8.3974 15.0582L7.76771 14.6046H8.54635L8.78333 13.8665ZM13.1776 13.8665L13.4146 14.6046H14.1932L13.5635 15.0582L13.8005 15.803L13.1776 15.3426L12.5479 15.7962L12.7849 15.0582L12.162 14.6046H12.9339L13.1776 13.8665ZM17.5651 13.8665L17.8089 14.6046H18.5807L17.9578 15.0582L18.1948 15.803L17.5651 15.3426L16.9422 15.7962L17.1792 15.0582L16.5495 14.6046H17.3349L17.5651 13.8665ZM21.9594 13.8665L22.1964 14.6046H22.975L22.3453 15.0582L22.5823 15.803L21.9594 15.3426L21.3297 15.7962L21.5667 15.0582L20.9438 14.6046H21.7156L21.9594 13.8665ZM2.19531 15.7353L2.43906 16.4733H3.21094L2.58802 16.927L2.825 17.665L2.19531 17.2113L1.5724 17.665L1.80938 16.9202L1.17969 16.4665H1.9651L2.19531 15.7353ZM6.58958 15.7353L6.82656 16.4733H7.60521L6.97552 16.927L7.21927 17.665L6.58958 17.2113L5.9599 17.665L6.20365 16.9202L5.57396 16.4665H6.34583L6.58958 15.7353ZM10.9771 15.7353L11.2208 16.4733H11.9859L11.3766 16.927L11.6135 17.665L10.9839 17.2113L10.3609 17.665L10.5979 16.9202L9.96823 16.4665H10.7469L10.9771 15.7353ZM15.3714 15.7353L15.6083 16.4733H16.387L15.7573 16.927L16.001 17.665L15.3714 17.2113L14.7417 17.665L14.9854 16.9202L14.3557 16.4665H15.1276L15.3714 15.7353ZM19.7589 15.7353L20.0026 16.4733H20.7745L20.1516 16.927L20.3885 17.665L19.7589 17.2113L19.1359 17.665L19.3729 16.9202L18.75 16.4665H19.5219L19.7589 15.7353ZM24.1531 15.7353L24.3901 16.4733H25.1688L24.5391 16.927L24.7828 17.665L24.1531 17.2113L23.5234 17.665L23.7672 16.9202L23.1375 16.4665H23.9161L24.1531 15.7353Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            width="47"
            height="35"
            viewBox="0 0 47 35"
            fill="none"
            id="svg-1642732060_9010"
          >
            <mask
              id="svg-1642732060_9010_mask0_1696_924"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="47"
              height="35"
            >
              <path d="M0 0H46.2245V34.6667H0V0Z" fill="white" />
            </mask>
            <g mask="url(#svg-1642732060_9010_mask0_1696_924)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H65.8667V2.66771H0V0ZM0 5.33542H65.8667V8.00313H0V5.33542ZM0 10.6641H65.8667V13.3385H0V10.6641ZM0 15.9995H65.8667V18.6672H0V15.9995ZM0 21.3349H65.8667V24.0026H0V21.3349ZM0 26.6635H65.8667V29.3313H0V26.6635ZM0 31.999H65.8667V34.6667H0V31.999Z"
                fill="#BD3D44"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.66748H65.8667V5.33519H0V2.66748ZM0 8.0029H65.8667V10.6638H0V8.0029ZM0 13.3315H65.8667V15.9993H0V13.3315ZM0 18.667H65.8667V21.3347H0V18.667ZM0 24.0024H65.8667V26.6701H0V24.0024ZM0 29.331H65.8667V31.9987H0V29.331Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H26.3453V18.6672H0V0Z"
                fill="#192F5D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.19531 0.798828L2.43906 1.53685H3.21094L2.58802 1.99049L2.825 2.73529L2.19531 2.27487L1.5724 2.72852L1.80938 1.99049L1.17969 1.53685H1.9651L2.19531 0.798828ZM6.58958 0.798828L6.82656 1.53685H7.60521L6.97552 1.99049L7.2125 2.73529L6.58958 2.27487L5.9599 2.72852L6.19688 1.99049L5.57396 1.53685H6.34583L6.58958 0.798828ZM10.9771 0.798828L11.2208 1.53685H11.9859L11.363 1.99049L11.6 2.73529L10.9703 2.27487L10.3474 2.72852L10.5844 1.99049L9.95469 1.53685H10.7333L10.9771 0.798828ZM15.3714 0.798828L15.6083 1.53685H16.387L15.7573 1.99049L16.001 2.73529L15.3714 2.27487L14.7417 2.72852L14.9854 1.99049L14.3557 1.53685H15.1276L15.3714 0.798828ZM19.7589 0.798828L20.0026 1.53685H20.7745L20.1516 1.99049L20.3885 2.73529L19.7589 2.27487L19.1359 2.72852L19.3729 1.99049L18.75 1.53685H19.5219L19.7589 0.798828ZM24.1531 0.798828L24.3901 1.53685H25.1688L24.5391 1.99049L24.7828 2.73529L24.1531 2.27487L23.5234 2.72852L23.7672 1.99049L23.1375 1.53685H23.9161L24.1531 0.798828ZM4.39583 2.66758L4.63281 3.4056H5.41146L4.78177 3.85924L5.01198 4.59727L4.4026 4.14362L3.77292 4.59727L3.99635 3.85924L3.38698 3.4056H4.15885L4.39583 2.66758ZM8.78333 2.66758L9.02708 3.4056H9.79896L9.16927 3.85924L9.41302 4.59727L8.78333 4.14362L8.15365 4.59727L8.3974 3.85924L7.76771 3.4056H8.54635L8.78333 2.66758ZM13.1776 2.66758L13.4146 3.4056H14.1932L13.5635 3.85924L13.8005 4.59727L13.1776 4.14362L12.5479 4.59727L12.7849 3.85924L12.162 3.4056H12.9339L13.1776 2.66758ZM17.5651 2.66758L17.8089 3.4056H18.5807L17.951 3.85924L18.1948 4.59727L17.5651 4.14362L16.9422 4.59727L17.1792 3.85924L16.5495 3.4056H17.3349L17.5651 2.66758ZM21.9594 2.66758L22.1964 3.4056H22.975L22.3453 3.85924L22.5823 4.59727L21.9594 4.14362L21.3297 4.59727L21.5667 3.85924L20.9438 3.4056H21.7156L21.9594 2.66758ZM2.19531 4.52956L2.43906 5.28112H3.21094L2.58802 5.73476L2.825 6.47279L2.19531 6.01237L1.5724 6.47279L1.80938 5.72799L1.17969 5.27435H1.9651L2.19531 4.52956ZM6.58958 4.52956L6.82656 5.27435H7.60521L6.97552 5.72799L7.2125 6.46602L6.58958 6.0056L5.9599 6.46602L6.19688 5.72122L5.57396 5.26758H6.34583L6.58958 4.52956ZM10.9771 4.52956L11.2208 5.27435H11.9859L11.363 5.72799L11.6 6.46602L10.9703 6.0056L10.3474 6.46602L10.5844 5.72122L9.95469 5.26758H10.7333L10.9771 4.52956ZM15.3714 4.52956L15.6083 5.27435H16.387L15.7573 5.72799L16.001 6.46602L15.3714 6.0056L14.7417 6.46602L14.9854 5.72122L14.3557 5.26758H15.1276L15.3714 4.52956ZM19.7589 4.52956L20.0026 5.27435H20.7745L20.1516 5.72799L20.3885 6.46602L19.7589 6.0056L19.1359 6.46602L19.3729 5.72122L18.75 5.26758H19.5219L19.7589 4.52956ZM24.1531 4.52956L24.3901 5.27435H25.1688L24.5391 5.72799L24.7828 6.46602L24.1531 6.0056L23.5234 6.46602L23.7672 5.72122L23.1375 5.26758H23.9161L24.1531 4.52956ZM4.39583 6.39831L4.63281 7.13633H5.41146L4.78177 7.58997L5.01875 8.33476L4.39583 7.87435L3.76615 8.32799L4.00312 7.58997L3.38021 7.13633H4.15208L4.39583 6.39831ZM8.78333 6.39831L9.02708 7.13633H9.79896L9.16927 7.58997L9.41302 8.33476L8.78333 7.87435L8.15365 8.32799L8.3974 7.58997L7.76771 7.13633H8.54635L8.78333 6.39831ZM13.1776 6.39831L13.4146 7.13633H14.1932L13.5635 7.58997L13.8005 8.33476L13.1776 7.87435L12.5479 8.32799L12.7849 7.58997L12.162 7.13633H12.9339L13.1776 6.39831ZM17.5651 6.39831L17.8089 7.13633H18.5807L17.9578 7.58997L18.1948 8.33476L17.5651 7.87435L16.9422 8.32799L17.1792 7.58997L16.5495 7.13633H17.3349L17.5651 6.39831ZM21.9594 6.39831L22.1964 7.13633H22.975L22.3453 7.58997L22.5823 8.33476L21.9594 7.87435L21.3297 8.32799L21.5667 7.58997L20.9438 7.13633H21.7156L21.9594 6.39831ZM2.19531 8.26706L2.43906 9.00508H3.21094L2.58802 9.45872L2.825 10.2035L2.19531 9.7431L1.5724 10.1967L1.80938 9.45872L1.17969 9.00508H1.9651L2.19531 8.26706ZM6.58958 8.26706L6.82656 9.00508H7.60521L6.97552 9.45872L7.2125 10.1967L6.58958 9.7431L5.9599 10.1967L6.19688 9.45872L5.57396 9.00508H6.34583L6.58958 8.26706ZM10.9771 8.26706L11.2208 9.00508H11.9859L11.363 9.45872L11.6 10.2035L10.9703 9.7431L10.3474 10.1967L10.5844 9.45872L9.95469 9.00508H10.7333L10.9771 8.26706ZM15.3714 8.26706L15.6083 9.00508H16.387L15.7573 9.45872L16.001 10.2035L15.3714 9.7431L14.7417 10.1967L14.9854 9.45872L14.3557 9.00508H15.1276L15.3714 8.26706ZM19.7589 8.26706L20.0026 9.00508H20.7745L20.1516 9.45872L20.3885 10.2035L19.7589 9.7431L19.1359 10.1967L19.3729 9.45872L18.75 9.00508H19.5219L19.7589 8.26706ZM24.1531 8.26706L24.3901 9.00508H25.1688L24.5391 9.45872L24.7828 10.2035L24.1531 9.7431L23.5234 10.1967L23.7672 9.45872L23.1375 9.00508H23.9161L24.1531 8.26706ZM4.39583 10.1358L4.63281 10.8738H5.41146L4.78177 11.3275L5.01875 12.0655L4.39583 11.6051L3.76615 12.0655L4.00312 11.3207L3.38021 10.8671H4.15208L4.39583 10.1358ZM8.78333 10.1358L9.02708 10.8738H9.79896L9.16927 11.3275L9.41302 12.0655L8.78333 11.6051L8.15365 12.0655L8.3974 11.3207L7.76771 10.8671H8.54635L8.78333 10.1358ZM13.1776 10.1358L13.4146 10.8738H14.1932L13.5635 11.3275L13.8005 12.0655L13.1776 11.6051L12.5479 12.0655L12.7849 11.3207L12.162 10.8671H12.9339L13.1776 10.1358ZM17.5651 10.1358L17.8089 10.8738H18.5807L17.9578 11.3275L18.1948 12.0655L17.5651 11.6051L16.9422 12.0655L17.1792 11.3207L16.5495 10.8671H17.3349L17.5651 10.1358ZM21.9594 10.1358L22.1964 10.8738H22.975L22.3453 11.3275L22.5823 12.0655L21.9594 11.6051L21.3297 12.0655L21.5667 11.3207L20.9438 10.8671H21.7156L21.9594 10.1358ZM2.19531 11.9978L2.43906 12.7426H3.21094L2.58802 13.1962L2.825 13.9275L2.19531 13.4738L1.5724 13.9275L1.80938 13.1895L1.17969 12.7358H1.9651L2.19531 11.9978ZM6.58958 11.9978L6.82656 12.7426H7.60521L6.97552 13.1962L7.21927 13.9275L6.58958 13.4738L5.9599 13.9275L6.20365 13.1895L5.57396 12.7358H6.34583L6.58958 11.9978ZM10.9771 11.9978L11.2208 12.7426H11.9859L11.363 13.1962L11.6 13.9275L10.9703 13.4738L10.3474 13.9275L10.5844 13.1895L9.95469 12.7358H10.7333L10.9771 11.9978ZM15.3714 11.9978L15.6083 12.7426H16.387L15.7573 13.1962L16.001 13.9275L15.3714 13.4738L14.7417 13.9275L14.9854 13.1895L14.3557 12.7358H15.1276L15.3714 11.9978ZM19.7589 11.9978L20.0026 12.7426H20.7745L20.1516 13.1962L20.3885 13.9275L19.7589 13.4738L19.1359 13.9275L19.3729 13.1895L18.75 12.7358H19.5219L19.7589 11.9978ZM24.1531 11.9978L24.3901 12.7426H25.1688L24.5391 13.1962L24.7828 13.9275L24.1531 13.4738L23.5234 13.9275L23.7672 13.1895L23.1375 12.7358H23.9161L24.1531 11.9978ZM4.39583 13.8665L4.63281 14.6046H5.41146L4.78177 15.0582L5.01875 15.803L4.39583 15.3426L3.76615 15.7962L4.00312 15.0582L3.38021 14.6046H4.15208L4.39583 13.8665ZM8.78333 13.8665L9.02708 14.6046H9.79896L9.16927 15.0582L9.41302 15.803L8.78333 15.3426L8.15365 15.7962L8.3974 15.0582L7.76771 14.6046H8.54635L8.78333 13.8665ZM13.1776 13.8665L13.4146 14.6046H14.1932L13.5635 15.0582L13.8005 15.803L13.1776 15.3426L12.5479 15.7962L12.7849 15.0582L12.162 14.6046H12.9339L13.1776 13.8665ZM17.5651 13.8665L17.8089 14.6046H18.5807L17.9578 15.0582L18.1948 15.803L17.5651 15.3426L16.9422 15.7962L17.1792 15.0582L16.5495 14.6046H17.3349L17.5651 13.8665ZM21.9594 13.8665L22.1964 14.6046H22.975L22.3453 15.0582L22.5823 15.803L21.9594 15.3426L21.3297 15.7962L21.5667 15.0582L20.9438 14.6046H21.7156L21.9594 13.8665ZM2.19531 15.7353L2.43906 16.4733H3.21094L2.58802 16.927L2.825 17.665L2.19531 17.2113L1.5724 17.665L1.80938 16.9202L1.17969 16.4665H1.9651L2.19531 15.7353ZM6.58958 15.7353L6.82656 16.4733H7.60521L6.97552 16.927L7.21927 17.665L6.58958 17.2113L5.9599 17.665L6.20365 16.9202L5.57396 16.4665H6.34583L6.58958 15.7353ZM10.9771 15.7353L11.2208 16.4733H11.9859L11.3766 16.927L11.6135 17.665L10.9839 17.2113L10.3609 17.665L10.5979 16.9202L9.96823 16.4665H10.7469L10.9771 15.7353ZM15.3714 15.7353L15.6083 16.4733H16.387L15.7573 16.927L16.001 17.665L15.3714 17.2113L14.7417 17.665L14.9854 16.9202L14.3557 16.4665H15.1276L15.3714 15.7353ZM19.7589 15.7353L20.0026 16.4733H20.7745L20.1516 16.927L20.3885 17.665L19.7589 17.2113L19.1359 17.665L19.3729 16.9202L18.75 16.4665H19.5219L19.7589 15.7353ZM24.1531 15.7353L24.3901 16.4733H25.1688L24.5391 16.927L24.7828 17.665L24.1531 17.2113L23.5234 17.665L23.7672 16.9202L23.1375 16.4665H23.9161L24.1531 15.7353Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg1549100418_2533"
          >
            <mask
              id="svg1549100418_2533_path-1-inside-1_1567_3936"
              fill="white"
            >
              <path d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z" />
            </mask>
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
              fill="#EFF6FF"
            />
            <path
              d="M12 0V1H36V0V-1H12V0ZM48 12H47V36H48H49V12H48ZM36 48V47H12V48V49H36V48ZM0 36H1V12H0H-1V36H0ZM12 48V47C5.92487 47 1 42.0751 1 36H0H-1C-1 43.1797 4.8203 49 12 49V48ZM48 36H47C47 42.0751 42.0751 47 36 47V48V49C43.1797 49 49 43.1797 49 36H48ZM36 0V1C42.0751 1 47 5.92487 47 12H48H49C49 4.8203 43.1797 -1 36 -1V0ZM12 0V-1C4.8203 -1 -1 4.8203 -1 12H0H1C1 5.92487 5.92487 1 12 1V0Z"
              fill="#F1F5F9"
              mask="url(#svg1549100418_2533_path-1-inside-1_1567_3936)"
            />
            <path
              d="M23.9983 22C23.4678 22 22.9591 22.2107 22.5841 22.5858C22.209 22.9609 21.9983 23.4696 21.9983 24C21.9983 25.02 21.8983 26.51 21.7383 28"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26 25.1201C26 27.5001 26 31.5001 25 34.0001"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M29.2891 33.02C29.4091 32.42 29.7191 30.72 29.7891 30"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 24C14 21.9012 14.6604 19.8556 15.8876 18.1529C17.1148 16.4502 18.8466 15.1769 20.8377 14.5132C22.8288 13.8495 24.9783 13.8291 26.9817 14.4549C28.985 15.0807 30.7407 16.3209 32 18"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 28H14.01"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M33.8008 28C34.0008 26 33.9318 22.646 33.8008 22"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 31.5C17.5 30 18 27 18 24C17.999 23.3189 18.114 22.6425 18.34 22"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.6484 34C20.8584 33.34 21.0984 32.68 21.2184 32"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 18.7999C21.9124 18.2732 22.9474 17.9959 24.001 17.9961C25.0545 17.9963 26.0894 18.2738 27.0017 18.8009C27.9139 19.328 28.6713 20.0859 29.1976 20.9986C29.7239 21.9112 30.0007 22.9464 30 23.9999V25.9999"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg-1084040545_1930"
          >
            <mask
              id="svg-1084040545_1930_path-1-inside-1_1567_3951"
              fill="white"
            >
              <path d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z" />
            </mask>
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
              fill="#EFF6FF"
            />
            <path
              d="M12 0V1H36V0V-1H12V0ZM48 12H47V36H48H49V12H48ZM36 48V47H12V48V49H36V48ZM0 36H1V12H0H-1V36H0ZM12 48V47C5.92487 47 1 42.0751 1 36H0H-1C-1 43.1797 4.8203 49 12 49V48ZM48 36H47C47 42.0751 42.0751 47 36 47V48V49C43.1797 49 49 43.1797 49 36H48ZM36 0V1C42.0751 1 47 5.92487 47 12H48H49C49 4.8203 43.1797 -1 36 -1V0ZM12 0V-1C4.8203 -1 -1 4.8203 -1 12H0H1C1 5.92487 5.92487 1 12 1V0Z"
              fill="#F1F5F9"
              mask="url(#svg-1084040545_1930_path-1-inside-1_1567_3951)"
            />
            <path
              d="M22.2695 33C22.4451 33.304 22.6975 33.5565 23.0016 33.732C23.3056 33.9075 23.6505 33.9999 24.0015 33.9999C24.3526 33.9999 24.6975 33.9075 25.0015 33.732C25.3055 33.5565 25.558 33.304 25.7335 33"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.2613 27.326C15.1306 27.4692 15.0444 27.6472 15.0131 27.8385C14.9818 28.0298 15.0068 28.226 15.085 28.4034C15.1632 28.5807 15.2912 28.7316 15.4535 28.8375C15.6158 28.9434 15.8054 28.9999 15.9993 29H31.9993C32.1931 29.0001 32.3827 28.9438 32.5451 28.8381C32.7076 28.7324 32.8358 28.5817 32.9142 28.4045C32.9926 28.2273 33.0178 28.0311 32.9867 27.8398C32.9557 27.6485 32.8697 27.4703 32.7393 27.327C31.4093 25.956 29.9993 24.499 29.9993 20C29.9993 18.4087 29.3671 16.8826 28.2419 15.7574C27.1167 14.6321 25.5906 14 23.9993 14C22.408 14 20.8818 14.6321 19.7566 15.7574C18.6314 16.8826 17.9993 18.4087 17.9993 20C17.9993 24.499 16.5883 25.956 15.2613 27.326Z"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg111317355_1819"
          >
            <mask id="svg111317355_1819_path-1-inside-1_1567_3959" fill="white">
              <path d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z" />
            </mask>
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
              fill="#EFF6FF"
            />
            <path
              d="M12 0V1H36V0V-1H12V0ZM48 12H47V36H48H49V12H48ZM36 48V47H12V48V49H36V48ZM0 36H1V12H0H-1V36H0ZM12 48V47C5.92487 47 1 42.0751 1 36H0H-1C-1 43.1797 4.8203 49 12 49V48ZM48 36H47C47 42.0751 42.0751 47 36 47V48V49C43.1797 49 49 43.1797 49 36H48ZM36 0V1C42.0751 1 47 5.92487 47 12H48H49C49 4.8203 43.1797 -1 36 -1V0ZM12 0V-1C4.8203 -1 -1 4.8203 -1 12H0H1C1 5.92487 5.92487 1 12 1V0Z"
              fill="#F1F5F9"
              mask="url(#svg111317355_1819_path-1-inside-1_1567_3959)"
            />
            <path
              d="M33 16H26"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 16H15"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M33 24H24"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 24H15"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M33 32H28"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24 32H15"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26 14V18"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 22V26"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28 30V34"
              stroke="#2563EB"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 256 256"
            id="svg-1208994263_271"
          >
            <path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm45.66 85.66-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 11.32Z" />
          </svg>
          <svg
            width="699"
            height="196"
            viewBox="0 0 699 196"
            fill="none"
            id="svg-1137231340_6119"
          >
            <path
              d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z"
              fill="#030319"
            />
            <path
              d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z"
              fill="#030319"
            />
            <path
              d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z"
              fill="#030319"
            />
            <path
              d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z"
              fill="#030319"
            />
            <path
              d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z"
              fill="#030319"
            />
            <path
              d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z"
              fill="#030319"
            />
            <ellipse
              cx="97.8957"
              cy="97.8954"
              rx="97.8957"
              ry="97.8954"
              fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)"
            />
            <path
              d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z"
              fill="white"
            />
            <path
              d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-1137231340_6119_paint0_linear_1843_2573"
                x1="97.8957"
                y1="0"
                x2="46.0375"
                y2="179.202"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            id="svg-1839680863_948"
          >
            <path
              d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z"
              fill="#666D80"
            />
          </svg>
          <svg
            id="2566832247"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 15.75 0 L 0.75 0 C 0.336 0 0 0.336 0 0.75 L 0 11.25 C 0 11.664 0.336 12 0.75 12 L 15.75 12 C 16.164 12 16.5 11.664 16.5 11.25 L 16.5 0.75 C 16.5 0.336 16.164 0 15.75 0 Z M 8.25 6.75 C 7.214 6.75 6.375 5.911 6.375 4.875 C 6.375 3.839 7.214 3 8.25 3 C 9.286 3 10.125 3.839 10.125 4.875 C 10.125 5.911 9.286 6.75 8.25 6.75 Z"
              fillOpacity="var(--1m6trwb, 0)"
              fill="var(--21h8s6, rgb(0, 0, 0))"
              height="12px"
              id="TfH67sxl4"
              transform="translate(3.75 8.25)"
              width="16.5px"
            />
            <path
              d="M 0.75 12 C 0.336 12 0 11.664 0 11.25 L 0 0.75 C 0 0.336 0.336 0 0.75 0 L 15.75 0 C 16.164 0 16.5 0.336 16.5 0.75 L 16.5 11.25 C 16.5 11.664 16.164 12 15.75 12 Z"
              fill="transparent"
              height="12px"
              id="u_qL5Ipuy"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3.75 8.25)"
              width="16.5px"
            />
            <path
              d="M 0 6.75 L 0 3.75 C 0 1.679 1.679 0 3.75 0 C 5.821 0 7.5 1.679 7.5 3.75 L 7.5 6.75"
              fill="transparent"
              height="6.75px"
              id="R9U5kcF0Z"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(8.25 1.5)"
              width="7.5px"
            />
            <path
              d="M 0 1.875 C 0 0.839 0.839 0 1.875 0 C 2.911 0 3.75 0.839 3.75 1.875 C 3.75 2.911 2.911 3.75 1.875 3.75 C 0.839 3.75 0 2.911 0 1.875 Z"
              fill="transparent"
              height="3.75px"
              id="DxIjrjDB6"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(10.125 11.25)"
              width="3.75px"
            />
            <path
              d="M 0 0 L 0 2.25"
              fill="transparent"
              height="2.25px"
              id="PsR8qKhm1"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(12 15)"
              width="1px"
            />
          </svg>
          <svg
            id="175829625"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 12 6.75 L 19.5 10.5 L 19.5 13.5 L 12 12 L 12 15 L 13.5 16.5 L 13.5 19.5 L 9.75 18 L 6 19.5 L 6 16.5 L 7.5 15 L 7.5 12 L 0 13.5 L 0 10.5 L 7.5 6.75 L 7.5 2.25 C 7.5 1.007 8.507 0 9.75 0 C 10.993 0 12 1.007 12 2.25 Z"
              fillOpacity="var(--1m6trwb, 0)"
              fill="var(--21h8s6, rgb(0, 0, 0))"
              height="19.5px"
              id="OSiNnMF1N"
              transform="translate(2.25 2.25)"
              width="19.5px"
            />
            <path
              d="M 12 6.75 L 19.5 10.5 L 19.5 13.5 L 12 12 L 12 15 L 13.5 16.5 L 13.5 19.5 L 9.75 18 L 6 19.5 L 6 16.5 L 7.5 15 L 7.5 12 L 0 13.5 L 0 10.5 L 7.5 6.75 L 7.5 2.25 C 7.5 1.007 8.507 0 9.75 0 C 10.993 0 12 1.007 12 2.25 Z"
              fill="transparent"
              height="19.5px"
              id="QF7jvRl_w"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(2.25 2.25)"
              width="19.5px"
            />
          </svg>
          <svg
            id="941805552"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 6.75 5.673 L 3.998 3 C 3.808 2.829 3.718 2.573 3.76 2.32 C 3.802 2.068 3.969 1.854 4.205 1.753 L 4.875 1.5 L 10.268 3.485 L 15.41 0.415 C 16.685 -0.336 18.317 -0.044 19.253 1.101 L 21 3.342 L 7.18 11.592 C 6.034 12.259 4.585 12.094 3.618 11.187 L 0.237 7.875 C 0.052 7.702 -0.033 7.447 0.011 7.198 C 0.055 6.949 0.222 6.738 0.455 6.639 L 0.75 6.494 L 3.73 7.5 Z"
              fillOpacity="var(--1m6trwb, 0)"
              fill="var(--21h8s6, rgb(0, 0, 0))"
              height="11.999016919302917px"
              id="UrpsVK2qr"
              transform="translate(1.5 5.25)"
              width="20.99991123745394px"
            />
            <path
              d="M 0 0 L 13.5 0"
              fill="transparent"
              height="1px"
              id="SPJY1s_ru"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(2.25 20.25)"
              width="13.5px"
            />
            <path
              d="M 6.75 5.673 L 3.998 3 C 3.808 2.829 3.718 2.573 3.76 2.32 C 3.802 2.068 3.969 1.854 4.205 1.753 L 4.875 1.5 L 10.268 3.485 L 15.41 0.415 C 16.685 -0.336 18.317 -0.044 19.253 1.101 L 21 3.342 L 7.18 11.592 C 6.034 12.259 4.585 12.094 3.618 11.187 L 0.237 7.875 C 0.052 7.702 -0.033 7.447 0.011 7.198 C 0.055 6.949 0.222 6.738 0.455 6.639 L 0.75 6.494 L 3.73 7.5 Z"
              fill="transparent"
              height="11.999016919302917px"
              id="tsspz4TXi"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(1.5 5.25)"
              width="20.99991123745394px"
            />
          </svg>
          <svg
            id="4090123071"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 0 0 L 16.5 0"
              fill="transparent"
              height="1px"
              id="OwsiYUS5O"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3.75 6)"
              width="16.5px"
            />
            <path
              d="M 0 0 L 5.25 0"
              fill="transparent"
              height="1px"
              id="N74NQKmbf"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3.75 12)"
              width="5.25px"
            />
            <path
              d="M 0 0 L 6.75 0"
              fill="transparent"
              height="1px"
              id="s8ediYkAd"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3.75 18)"
              width="6.75px"
            />
            <path
              d="M 4.5 6.613 L 7.282 8.25 L 6.525 5.195 L 9 3.151 L 5.752 2.901 L 4.5 0 L 3.248 2.901 L 0 3.151 L 2.475 5.195 L 1.718 8.25 Z"
              fill="transparent"
              height="8.25px"
              id="okMMMBzBw"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(12.75 9.75)"
              width="9px"
            />
          </svg>
          <svg
            id="2883338743"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 0 9 C 0 4.029 4.029 0 9 0 C 13.971 0 18 4.029 18 9 C 18 13.971 13.971 18 9 18 C 4.029 18 0 13.971 0 9 Z"
              fillOpacity="var(--1m6trwb, 0)"
              fill="var(--21h8s6, rgb(0, 0, 0))"
              height="18px"
              id="M2umBpORv"
              transform="translate(3 3)"
              width="18px"
            />
            <path
              d="M 0 3 L 2.25 5.25 L 7.5 0"
              fill="transparent"
              height="5.25px"
              id="SKKzYtdWd"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(8.25 9.75)"
              width="7.5px"
            />
            <path
              d="M 0 9 C 0 4.029 4.029 0 9 0 C 13.971 0 18 4.029 18 9 C 18 13.971 13.971 18 9 18 C 4.029 18 0 13.971 0 9 Z"
              fill="transparent"
              height="18px"
              id="Ub0giwiXO"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3 3)"
              width="18px"
            />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div
          data-framer-root=""
          className="framer-sA4Yy framer-rcOGl framer-tx7Wz framer-6lXp4 framer-ix61hb accounts-s1"
        >
          <div className="ssr-variant hidden-ms262u">
            <div
              className="framer-1bps7bv-container accounts-s2"
              data-framer-appear-id="1bps7bv"
              id="1bps7bv"
            >
              <div className="ssr-variant hidden-1fi46e6">
                <div
                  className="framer-8MFL4 framer-15zawlh framer-v-15zawlh accounts-s3"
                  data-framer-name="Desktop [Default Boxed]"
                >
                  <header
                    className="framer-ooxjtq accounts-s4"
                    data-border="true"
                    data-framer-name="Main Area"
                  >
                    <div
                      className="framer-p578i7 accounts-s5"
                      data-framer-name="Background [Default]"
                    />
                    <div
                      className="framer-pc27k4 accounts-s6"
                      data-framer-name="Background [Boxed Mini]"
                    />
                    <div className="framer-cjwofg" data-framer-name="Content">
                      {/*$*/}
                      <a className="framer-1jy87r1 framer-145ct8v" href="/">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1hjthz accounts-s7"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                      <nav className="framer-xe9vp0" data-framer-name="Nav">
                        <div
                          className="framer-1hg3ikx-container"
                          data-framer-name="Menu [Desktop]"
                          name="Menu [Desktop]"
                        >
                          <div
                            name="Menu [Desktop]"
                            className="framer-n0D3w framer-1itjusz framer-v-1itjusz accounts-s8"
                            data-framer-name="Menu"
                          >
                            {/*$*/}
                            <div className="framer-mquu2a-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/accounts"
                                data-framer-page-link-current="true"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Accounts{' '}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1yixouk-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-pay"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Scallop Pay
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-wi7xty-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/cards"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Cards
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1tpzm7c-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-plus"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Scallop+
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-u2qi4r-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/helpcenter"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    FAQs
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                      </nav>
                      <div
                        className="framer-14uxsxw"
                        data-framer-name="Menu Icon"
                      >
                        <div
                          className="framer-16051d2"
                          data-framer-name="QR Overlay Trigger"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-168591e-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 accounts-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm accounts-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s14"
                                >
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze accounts-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
              </div>
              <div className="ssr-variant hidden-ix61hb">
                <div
                  className="framer-8MFL4 framer-15zawlh framer-v-15viyb0 accounts-s3"
                  data-framer-name="Desktop [Boxed Mini]"
                >
                  <header
                    className="framer-ooxjtq accounts-s17"
                    data-border="true"
                    data-framer-name="Main Area"
                  >
                    <div
                      className="framer-p578i7 accounts-s6"
                      data-framer-name="Background [Default]"
                    />
                    <div
                      className="framer-pc27k4 accounts-s5"
                      data-framer-name="Background [Boxed Mini]"
                    />
                    <div className="framer-cjwofg" data-framer-name="Content">
                      {/*$*/}
                      <a className="framer-1jy87r1 framer-145ct8v" href="/">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1hjthz accounts-s7"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                      <nav className="framer-xe9vp0" data-framer-name="Nav">
                        <div
                          className="framer-1hg3ikx-container"
                          data-framer-name="Menu [Desktop]"
                          name="Menu [Desktop]"
                        >
                          <div
                            name="Menu [Desktop]"
                            className="framer-n0D3w framer-1itjusz framer-v-1itjusz accounts-s8"
                            data-framer-name="Menu"
                          >
                            {/*$*/}
                            <div className="framer-mquu2a-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/accounts"
                                data-framer-page-link-current="true"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Accounts{' '}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1yixouk-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-pay"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Scallop Pay
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-wi7xty-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/cards"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Cards
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1tpzm7c-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-plus"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    Scallop+
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-u2qi4r-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq accounts-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/helpcenter"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi accounts-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s11"
                                  >
                                    FAQs
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                      </nav>
                      <div
                        className="framer-14uxsxw"
                        data-framer-name="Menu Icon"
                      >
                        <div
                          className="framer-16051d2"
                          data-framer-name="QR Overlay Trigger"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-168591e-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 accounts-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm accounts-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s14"
                                >
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze accounts-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
            <div
              className="framer-1bps7bv-container"
              data-framer-appear-id="1bps7bv"
              id="1bps7bv"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l accounts-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq accounts-s18"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 accounts-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 accounts-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz accounts-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi accounts-s19"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-1cux5of accounts-s20" />
                          <div className="framer-1w1bul6 accounts-s20" />
                          <div className="framer-1ku2ucf accounts-s21" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-g2zy0l" data-framer-name="Background">
            <div
              className="framer-xzw2w"
              data-framer-appear-id="xzw2w"
              data-framer-name="Left Abstract"
            >
              <div className="framer-1yhrd15" data-framer-name="Sub Container">
                <div className="framer-4cfgfx" data-framer-name="Ellipse 3" />
                <div className="framer-9stl4r" data-framer-name="Ellipse 4" />
                <div className="framer-9wuxsy" data-framer-name="Ellipse 2" />
                <div className="framer-l7p0dj" data-framer-name="Ellipse 1" />
              </div>
              <div className="framer-1w4bs1d" data-framer-name="Sub Container">
                <div className="framer-k9a904" data-framer-name="Ellipse 3" />
                <div className="framer-11dcebx" data-framer-name="Ellipse 4" />
                <div className="framer-rr22xc" data-framer-name="Ellipse 2" />
                <div className="framer-1170x0q" data-framer-name="Ellipse 1" />
              </div>
            </div>
            <div
              className="framer-1s4f5i9"
              data-framer-appear-id="1s4f5i9"
              data-framer-name="Right Abstract"
            >
              <div className="framer-1chqp99" data-framer-name="Sub Container">
                <div className="framer-ndqk04" data-framer-name="Ellipse 3" />
                <div className="framer-14zypww" data-framer-name="Ellipse 4" />
                <div className="framer-1gfzo9r" data-framer-name="Ellipse 2" />
                <div className="framer-b8h6s3" data-framer-name="Ellipse 1" />
              </div>
              <div
                className="framer-18p62m4 accounts-s22"
                data-framer-name="Sub Container"
              >
                <div className="framer-9psy64" data-framer-name="Ellipse 3" />
                <div className="framer-gq1r0w" data-framer-name="Ellipse 4" />
                <div className="framer-1dh3aak" data-framer-name="Ellipse 2" />
                <div className="framer-1wbiagt" data-framer-name="Ellipse 1" />
              </div>
            </div>
            <div className="framer-1jjc24c" data-framer-name="BG" />
            <div className="framer-1b3xm3e" data-framer-name="Sub Container">
              <div
                className="framer-1rzfzq7"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-11txgrn"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1asvwtd"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-bw1imy"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-14o43yb"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1ibwbev"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-2rkzge"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-8xwzg3"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-dslh9g"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1oevzil"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-16tbj78"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1ic3f55"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1lmsb7f"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-yfeuz7"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-r1khpo"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1xqb6bq"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1dsv8nf"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1h4fclv"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-xlfvnj"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1c7ogk4"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-s7bhrq"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-1kppo5j"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-wbt7od"
                data-border="true"
                data-framer-name="Vertical Block"
              />
              <div
                className="framer-4xr6sa"
                data-border="true"
                data-framer-name="Vertical Block"
              />
            </div>
            <div className="framer-1pmem3a" data-framer-name="BG" />
          </div>
          <div className="framer-lhwc9p" data-framer-name="Main Container">
            <section
              className="framer-be9ule"
              data-framer-name="Hero"
              id="use-cases"
            >
              <div className="framer-10eecef" data-framer-name="Container">
                <div className="ssr-variant hidden-ms262u">
                  {/*$*/}
                  <a
                    className="framer-l8bcb2 framer-1twpk0x"
                    data-framer-appear-id="l8bcb2"
                    data-framer-name="Link - Variant 2"
                    id="l8bcb2"
                    href="https://onelink.to/wch597"
                    target="_blank"
                    rel="noopener"
                    tabIndex={0}
                  >
                    <div
                      className="framer-q2z2fq"
                      data-framer-name="Badge \u2192 _Badge base"
                    >
                      <div
                        className="framer-1paensj accounts-s23 reveal"
                        data-framer-name="Text \u2192 New"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s24">
                          Start Now
                        </p>
                      </div>
                    </div>
                    <div className="framer-zyytil" data-framer-name="Content">
                      <div
                        className="framer-1hbhy26 accounts-s23 reveal"
                        data-framer-name="Message \u2192 We just launched our beta app"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s25">
                          Create your account in minutes
                        </p>
                      </div>
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="arrow-right"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1kbaslt accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 20 21" className="accounts-s28">
                            <use href="#svg542025065_547" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1g7dk6x hidden-1fi46e6 hidden-ms262u"
                      data-border="true"
                      data-framer-name="Border"
                      id="1g7dk6x"
                      tabIndex={0}
                    />
                  </a>
                  {/*/$*/}
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  {/*$*/}
                  <a
                    className="framer-l8bcb2 framer-1twpk0x"
                    data-framer-appear-id="l8bcb2"
                    data-framer-name="Link - Variant 2"
                    id="l8bcb2"
                    href="https://onelink.to/wch597"
                    target="_blank"
                    rel="noopener"
                    tabIndex={0}
                  >
                    <div
                      className="framer-q2z2fq"
                      data-framer-name="Badge \u2192 _Badge base"
                    >
                      <div
                        className="framer-1paensj accounts-s23 reveal"
                        data-framer-name="Text \u2192 New"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s24">
                          Start Now
                        </p>
                      </div>
                    </div>
                    <div className="framer-zyytil" data-framer-name="Content">
                      <div
                        className="framer-1hbhy26 accounts-s23 reveal"
                        data-framer-name="Message \u2192 We just launched our beta app"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s25">
                          Create account in minutes
                        </p>
                      </div>
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="arrow-right"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1kbaslt accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 20 21" className="accounts-s28">
                            <use href="#svg542025065_547" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1g7dk6x hidden-1fi46e6 hidden-ms262u"
                      data-border="true"
                      data-framer-name="Border"
                      id="1g7dk6x"
                      tabIndex={0}
                    />
                  </a>
                  {/*/$*/}
                </div>
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-rf1yx0 accounts-s29 reveal"
                    data-framer-appear-id="rf1yx0"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s30">
                      One account. One balance.{' '}
                      <span className="framer-text accounts-s31">
                        Built for global money.
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ix61hb">
                  <div
                    className="framer-rf1yx0 accounts-s29 reveal"
                    data-framer-appear-id="rf1yx0"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf accounts-s32"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      One account. One balance.{' '}
                      <span className="framer-text accounts-s33">
                        Built for global money.
                      </span>
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-rf4glh accounts-s29 reveal"
                    data-framer-appear-id="rf4glh"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s34">
                      Send, spend, and convert across 52+ currencies and digital
                      assets without switching apps or wallets
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ix61hb">
                  <div
                    className="framer-rf4glh accounts-s29 reveal"
                    data-framer-appear-id="rf4glh"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s34">
                      Send, spend, and convert across 52+ currencies and digital
                      assets without switching apps or wallets
                    </p>
                  </div>
                </div>
                <div className="framer-1v503yg" data-framer-appear-id="1v503yg">
                  {/*$*/}
                  <a
                    className="framer-18l32v1 framer-1twpk0x"
                    data-framer-name="Appstore"
                    href="https://apps.apple.com/app/scallop/id6746711366"
                    target="_blank"
                    rel="noopener"
                  >
                    <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-124dco5 accounts-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg className="accounts-s36">
                            <use href="#svg1322499166_10645" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-124dco5 accounts-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg className="accounts-s36">
                            <use href="#svg2038526003_10374" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-124dco5 accounts-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg className="accounts-s36">
                            <use href="#svg-365320820_10584" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </a>
                  {/*/$*/}
                  {/*$*/}
                  <a
                    className="framer-6v6rwr framer-1twpk0x"
                    data-framer-name="Playstore"
                    href="https://play.google.com/store/apps/details?id=com.app.scallop"
                    target="_blank"
                    rel="noopener"
                  >
                    <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qwmb2l accounts-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg className="accounts-s36">
                            <use href="#svg-412316951_7924" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qwmb2l accounts-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg className="accounts-s36">
                            <use href="#svg-77694124_7650" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qwmb2l accounts-s35"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg className="accounts-s36">
                            <use href="#svg922906930_7792" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </a>
                  {/*/$*/}
                </div>
              </div>
              <div
                className="framer-bsxes0"
                data-framer-appear-id="bsxes0"
                data-framer-name="img"
              >
                <div className="framer-ja5639" data-framer-name="BG">
                  <div className="ssr-variant">
                    <div className="framer-1wveo2" data-framer-name="Ellipse 5">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          width="2480"
                          height="1988"
                          sizes="(min-width: 1440px) 619.9667px, (max-width: 809.98px) 620px, (min-width: 810px) and (max-width: 1439.98px) 619.9667px"
                          srcSet="/framerusercontent.com/images/OEI0W59ipnhGQuQ1zULWxwNuA.png 512w,/framerusercontent.com/images/OEI0W59ipnhGQuQ1zULWxwNuA.png 1024w,/framerusercontent.com/images/OEI0W59ipnhGQuQ1zULWxwNuA.png 2048w,/framerusercontent.com/images/OEI0W59ipnhGQuQ1zULWxwNuA.png 2480w"
                          src="/framerusercontent.com/images/OEI0W59ipnhGQuQ1zULWxwNuA.png"
                          alt=""
                          className="accounts-s38"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-1w6ydkx"
                      data-framer-name="Ellipse 4"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          width="2480"
                          height="1988"
                          sizes="(min-width: 1440px) 619.9667px, (max-width: 809.98px) 620px, (min-width: 810px) and (max-width: 1439.98px) 619.9667px"
                          srcSet="/framerusercontent.com/images/ilNRq4zVa1VI5SYyb3gjutGPcvE.png 512w,/framerusercontent.com/images/ilNRq4zVa1VI5SYyb3gjutGPcvE.png 1024w,/framerusercontent.com/images/ilNRq4zVa1VI5SYyb3gjutGPcvE.png 2048w,/framerusercontent.com/images/ilNRq4zVa1VI5SYyb3gjutGPcvE.png 2480w"
                          src="/framerusercontent.com/images/ilNRq4zVa1VI5SYyb3gjutGPcvE.png"
                          alt=""
                          className="accounts-s38"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-8copdn"
                    data-framer-name="product demo"
                  >
                    <div
                      data-framer-background-image-wrapper="true"
                      className="accounts-s37"
                    >
                      <img
                        decoding="async"
                        width="802"
                        height="795"
                        sizes="(min-width: 1440px) 802px, (max-width: 809.98px) 295px, (min-width: 810px) and (max-width: 1439.98px) 537px"
                        srcSet="/framerusercontent.com/images/3SswWYZ1FsJJS7srwz1LgsNhI.png 512w,/framerusercontent.com/images/3SswWYZ1FsJJS7srwz1LgsNhI.png 802w"
                        src="/framerusercontent.com/images/3SswWYZ1FsJJS7srwz1LgsNhI.png"
                        alt=""
                        className="accounts-s39"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="framer-1oa76o" data-framer-name="Features">
              <div className="framer-ip31k4">
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-1kg5ip1 accounts-s40 reveal"
                    data-framer-appear-id="1kg5ip1"
                    data-framer-name="Everything runs in one place. No fragmentation. No"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s41">
                      No fragmentation. No switching between apps.
                      <br className="framer-text" />
                      Built for regions where most neobanks don&rsquo;t operate.
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ix61hb">
                  <div
                    className="framer-1kg5ip1 accounts-s29 reveal"
                    data-framer-appear-id="1kg5ip1"
                    data-framer-name="Everything runs in one place. No fragmentation. No"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s34">
                      No fragmentation. No switching between apps. Built for
                      regions where most neobanks don&rsquo;t operate.
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-1b0b03z accounts-s29 reveal"
                    data-framer-appear-id="1b0b03z"
                    data-framer-name="Stop managing your money across multiple apps"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s30">
                      Stop managing your money across multiple apps
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div
                    className="framer-1b0b03z accounts-s29 reveal"
                    data-framer-appear-id="1b0b03z"
                    data-framer-name="Stop managing your money across multiple apps"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      Stop managing your money across multiple apps
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                  <div
                    className="framer-1b0b03z accounts-s29 reveal"
                    data-framer-appear-id="1b0b03z"
                    data-framer-name="Stop managing your money across multiple apps"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Stop managing your money across multiple apps
                    </h2>
                  </div>
                </div>
                <div
                  className="framer-ieojvj hidden-1fi46e6 hidden-ms262u"
                  data-framer-name="Heading 2"
                />
              </div>
              <div className="framer-ccwtr6">
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-hg4xob"
                    data-framer-appear-id="hg4xob"
                    data-framer-name="Container"
                  >
                    <div
                      className="framer-ethwgd"
                      data-framer-name="Container"
                    />
                    <div className="framer-3jrw8" data-framer-name="Container">
                      <div
                        className="framer-apqrpb accounts-s23 reveal"
                        data-framer-name="Hold and manage 52+ fiat currencies globally from "
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s42">
                          Hold and manage 52+ fiat currencies globally from one
                          account
                        </p>
                      </div>
                      <div
                        className="framer-1geyh98 accounts-s23 reveal"
                        data-framer-name="Multi-Currency Accounts"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s43">
                          Multi-Currency Accounts
                        </p>
                      </div>
                      <div
                        className="framer-stkg47"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-mywbqa"
                          data-framer-name="Paragraph"
                        >
                          <div
                            className="framer-qmlvm1 accounts-s40 reveal"
                            data-framer-name="Supported currencies :"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s44">
                              Supported currencies
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-sby5q3"
                          data-framer-name="Frame 1707479828"
                        >
                          <div
                            className="framer-12mm08n"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-129i6ru"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-9d8ccl"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Clip path group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-15vbqln accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1209903461_9010" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1etqof8"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-glnnru"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-1prbh8c"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-p41mz5 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-77748519_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-3fgmhx accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg2125279330_305" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-9x3jnb accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg994370299_368" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1us0noz accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1148296261_203" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-ds0p3r accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-29915228_203" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-srfsy8"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-1tq1vm0"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-1f5c3kk"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-8ebkdv accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg49011196_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-o70fzu accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 25 24"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-873981876_11120" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1nsprfh"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-a7rkfi"
                              data-framer-name="Group circle"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Oval"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-l042d5 accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 35 35"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1761932441_338" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-1fd94uh accounts-s23 reveal"
                                data-framer-name="FL"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s45"
                                >
                                  49+
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*$*/}
                      <a
                        className="framer-1st6vv1 framer-1twpk0x"
                        data-framer-name="Frame 1707479994"
                        href="https://docs.scallopx.com/details/supported-rails-and-currencies-fiat"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          className="framer-32h9y3 accounts-s23 reveal"
                          data-framer-name="Hold and manage 52+ fiat currencies globally from "
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s46">
                            Explore
                          </p>
                        </div>
                        <div
                          className="framer-1ynk8su"
                          data-framer-name="ArrowUpRight"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Vector"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-ufjfwl accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 9 9" className="accounts-s28">
                                <use href="#svg879503595_837" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    <div
                      className="framer-1l6553x accounts-s47"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-hk4baj"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-1opf0ou"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-iw8jdi"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-94t2uo"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-gsygjj"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/97a2yuykIERsWjHpnzUzFSxlM.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-16bkako"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-1yd9ug7"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-2yurcq accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  US Dollar (USD)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-w54sfz accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 59 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg1335810439_5361" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-j5pyej"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-1tnml6"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-13gg7r3"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-slvs2m"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Mask Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1ttwlyh accounts-s49"
                              aria-hidden="true"
                            >
                              <div className="svgContainer accounts-s27">
                                <svg
                                  viewBox="0 0 37 37"
                                  className="accounts-s28"
                                >
                                  <use href="#svg1905732075_3621" />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1qrtdca"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-hsk44t"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-1h3ycjg accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  British Pound (GBP)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-1jvmiu2 accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 62 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg701843853_4460" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-n7rdfx"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-h6br76"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-5dxnmz"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-kla4uy"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-1m7kij3"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/HJ9vxIF9Nzw93O4ICl7wmsMFiOE.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1c7qi13"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-604e8u"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-ddmpo6 accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  UAE Dirham (AED)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-an3r7v accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 59 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-508483599_4911" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-1jnsozw"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-140lvft"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-1iwelhw"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-11ak278"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-1cehceo"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/4UBaX6DAnk8TmOHJ0GEekFvmCA.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-2gt67v"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-154d8hl"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-1ej03tl accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  Naira (NGN)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-17ikcrh accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 81 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1992885442_5845" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-10i4n7m"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div
                    className="framer-hg4xob"
                    data-framer-appear-id="hg4xob"
                    data-framer-name="Container"
                  >
                    <div
                      className="framer-ethwgd"
                      data-framer-name="Container"
                    />
                    <div className="framer-3jrw8" data-framer-name="Container">
                      <div
                        className="framer-apqrpb accounts-s23 reveal"
                        data-framer-name="Hold and manage 52+ fiat currencies globally from "
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s42">
                          Hold and manage 52+ fiat currencies globally from one
                          account
                        </p>
                      </div>
                      <div
                        className="framer-1geyh98 accounts-s23 reveal"
                        data-framer-name="Multi-Currency Accounts"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s50">
                          Multi-Currency Accounts
                        </p>
                      </div>
                      <div
                        className="framer-stkg47"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-mywbqa"
                          data-framer-name="Paragraph"
                        >
                          <div
                            className="framer-qmlvm1 accounts-s40 reveal"
                            data-framer-name="Supported currencies :"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s44">
                              Supported currencies
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-sby5q3"
                          data-framer-name="Frame 1707479828"
                        >
                          <div
                            className="framer-12mm08n"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-129i6ru"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-9d8ccl"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Clip path group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-15vbqln accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1209903461_9010" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1etqof8"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-glnnru"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-1prbh8c"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-p41mz5 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-77748519_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-3fgmhx accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg2125279330_305" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-9x3jnb accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg994370299_368" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1us0noz accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1148296261_203" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-ds0p3r accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-29915228_203" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-srfsy8"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-1tq1vm0"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-1f5c3kk"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-8ebkdv accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg49011196_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-o70fzu accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 25 24"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-873981876_11120" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1nsprfh"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-a7rkfi"
                              data-framer-name="Group circle"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Oval"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-l042d5 accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 35 35"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1761932441_338" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-1fd94uh accounts-s23 reveal"
                                data-framer-name="FL"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s45"
                                >
                                  49+
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*$*/}
                      <a
                        className="framer-1st6vv1 framer-1twpk0x"
                        data-framer-name="Frame 1707479994"
                        href="https://docs.scallopx.com/details/supported-rails-and-currencies-fiat"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          className="framer-32h9y3 accounts-s23 reveal"
                          data-framer-name="Hold and manage 52+ fiat currencies globally from "
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s46">
                            Explore
                          </p>
                        </div>
                        <div
                          className="framer-1ynk8su"
                          data-framer-name="ArrowUpRight"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Vector"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-ufjfwl accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 9 9" className="accounts-s28">
                                <use href="#svg879503595_837" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    <div
                      className="framer-1l6553x accounts-s47"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-hk4baj"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-1opf0ou"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-iw8jdi"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-94t2uo"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-gsygjj"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/97a2yuykIERsWjHpnzUzFSxlM.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-16bkako"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-1yd9ug7"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-2yurcq accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  US Dollar (USD)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-w54sfz accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 59 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg1335810439_5361" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-j5pyej"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-1tnml6"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-13gg7r3"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-slvs2m"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Mask Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1ttwlyh accounts-s49"
                              aria-hidden="true"
                            >
                              <div className="svgContainer accounts-s27">
                                <svg
                                  viewBox="0 0 37 37"
                                  className="accounts-s28"
                                >
                                  <use href="#svg1905732075_3621" />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1qrtdca"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-hsk44t"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-1h3ycjg accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  British Pound (GBP)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-1jvmiu2 accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 62 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg701843853_4460" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-n7rdfx"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-h6br76"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-5dxnmz"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-kla4uy"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-1m7kij3"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/HJ9vxIF9Nzw93O4ICl7wmsMFiOE.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1c7qi13"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-604e8u"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-ddmpo6 accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  UAE Dirham (AED)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-an3r7v accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 59 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-508483599_4911" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-1jnsozw"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-140lvft"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-1iwelhw"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-11ak278"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-1cehceo"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/4UBaX6DAnk8TmOHJ0GEekFvmCA.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-2gt67v"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-154d8hl"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-1ej03tl accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  Naira (NGN)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-17ikcrh accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 81 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1992885442_5845" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-10i4n7m"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                  <div
                    className="framer-hg4xob"
                    data-framer-appear-id="hg4xob"
                    data-framer-name="Container"
                  >
                    <div
                      className="framer-ethwgd"
                      data-framer-name="Container"
                    />
                    <div className="framer-3jrw8" data-framer-name="Container">
                      <div
                        className="framer-apqrpb accounts-s23 reveal"
                        data-framer-name="Hold and manage 52+ fiat currencies globally from "
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s42">
                          Hold and manage 52+ fiat currencies globally from one
                          account
                        </p>
                      </div>
                      <div
                        className="framer-1geyh98 accounts-s23 reveal"
                        data-framer-name="Multi-Currency Accounts"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s50">
                          Multi-Currency Accounts
                        </p>
                      </div>
                      <div
                        className="framer-stkg47"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-mywbqa"
                          data-framer-name="Paragraph"
                        >
                          <div
                            className="framer-qmlvm1 accounts-s40 reveal"
                            data-framer-name="Supported currencies :"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s44">
                              Supported currencies
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-sby5q3"
                          data-framer-name="Frame 1707479828"
                        >
                          <div
                            className="framer-12mm08n"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-129i6ru"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-9d8ccl"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Clip path group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-15vbqln accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1209903461_9010" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1etqof8"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-glnnru"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-1prbh8c"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-p41mz5 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-77748519_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-3fgmhx accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg2125279330_305" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-9x3jnb accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg994370299_368" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1us0noz accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1148296261_203" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-ds0p3r accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-29915228_203" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-srfsy8"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-1tq1vm0"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-1f5c3kk"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-8ebkdv accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg49011196_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-o70fzu accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 25 24"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-873981876_11120" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1nsprfh"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-a7rkfi"
                              data-framer-name="Group circle"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Oval"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-l042d5 accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 35 35"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1761932441_338" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-1fd94uh accounts-s51 reveal"
                                data-framer-name="FL"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s45"
                                >
                                  49+
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*$*/}
                      <a
                        className="framer-1st6vv1 framer-1twpk0x"
                        data-framer-name="Frame 1707479994"
                        href="https://docs.scallopx.com/details/supported-rails-and-currencies-fiat"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          className="framer-32h9y3 accounts-s23 reveal"
                          data-framer-name="Hold and manage 52+ fiat currencies globally from "
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s46">
                            Explore
                          </p>
                        </div>
                        <div
                          className="framer-1ynk8su"
                          data-framer-name="ArrowUpRight"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Vector"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-ufjfwl accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 9 9" className="accounts-s28">
                                <use href="#svg879503595_837" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    <div
                      className="framer-1l6553x accounts-s47"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-hk4baj"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-1opf0ou"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-iw8jdi"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-94t2uo"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-gsygjj"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/97a2yuykIERsWjHpnzUzFSxlM.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-16bkako"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-1yd9ug7"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-2yurcq accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  US Dollar (USD)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-w54sfz accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 59 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg1335810439_5361" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-j5pyej"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-1tnml6"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-13gg7r3"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-slvs2m"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Mask Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1ttwlyh accounts-s49"
                              aria-hidden="true"
                            >
                              <div className="svgContainer accounts-s27">
                                <svg
                                  viewBox="0 0 37 37"
                                  className="accounts-s28"
                                >
                                  <use href="#svg1905732075_3621" />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1qrtdca"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-hsk44t"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-1h3ycjg accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  British Pound (GBP)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-1jvmiu2 accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 62 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg701843853_4460" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-n7rdfx"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-h6br76"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-5dxnmz"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-kla4uy"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-1m7kij3"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/HJ9vxIF9Nzw93O4ICl7wmsMFiOE.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1c7qi13"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-604e8u"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-ddmpo6 accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  UAE Dirham (AED)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-an3r7v accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 59 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-508483599_4911" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-1jnsozw"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-140lvft"
                          data-framer-name="Token list item"
                        >
                          <div
                            className="framer-1iwelhw"
                            data-framer-name="Icon"
                          >
                            <div
                              className="framer-11ak278"
                              data-framer-name="Ellipse 133"
                            />
                            <div
                              className="framer-1cehceo"
                              data-framer-name="Mask Group"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="147"
                                  height="147"
                                  src="/framerusercontent.com/images/4UBaX6DAnk8TmOHJ0GEekFvmCA.png"
                                  alt=""
                                  className="accounts-s39"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-2gt67v"
                            data-framer-name="Frame 1437257082"
                          >
                            <div
                              className="framer-154d8hl"
                              data-framer-name="Frame 1437257088"
                            >
                              <div
                                className="framer-1ej03tl accounts-s40 reveal"
                                data-framer-name="Token"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s48"
                                >
                                  Naira (NGN)
                                </p>
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Frame 1437257084"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-17ikcrh accounts-s49"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 81 25"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1992885442_5845" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-10i4n7m"
                              data-framer-name="Arrow Icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-1s96bc7"
                    data-framer-appear-id="1s96bc7"
                    data-framer-name="Container"
                  >
                    <div
                      className="framer-1bheqan"
                      data-framer-name="Container"
                    />
                    <div
                      className="framer-bwh73e accounts-s52"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1h1kr7d"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-1bmzlih"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-aq77qy accounts-s53"
                            data-framer-name="image 1520"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="87"
                                height="87"
                                src="/framerusercontent.com/images/1oceTIR1r5cpCVKHctKmPUjribQ.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-mfuq2w"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-1b81mvg accounts-s40 reveal"
                              data-framer-name="USD Balance"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s55"
                              >
                                USD Balance
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-sc8or0 accounts-s40 reveal"
                          data-framer-name="$1,200.00"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s56">
                            $1,200.00
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1yfaz15"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-mwudt1"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-4einca"
                            data-framer-name="Container"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="50"
                                height="50"
                                src="/framerusercontent.com/images/pSjk1JQj9DHzoowqHAKIuFBVf8.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-1jo1f3w"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-1rirtsa accounts-s40 reveal"
                              data-framer-name="Tether"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s55"
                              >
                                Tether
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-g1cn3h accounts-s40 reveal"
                          data-framer-name="500.00 USDT"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s56">
                            500.00 USDT
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1aebk95"
                      data-framer-name="Container"
                    >
                      <div className="framer-ybubjo">
                        <div
                          className="framer-199khtm accounts-s23 reveal"
                          data-framer-name="Digital Assets and Stablecoins"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s43">
                            Digital Assets and Stablecoins
                          </p>
                        </div>
                        <div
                          className="framer-d505ek accounts-s23 reveal"
                          data-framer-name="Hold and manage 52+ fiat currencies globally from "
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s42">
                            Your digital assets aren&apos;t stored separately
                            <br className="framer-text" />
                            They sit in the same balance as your fiat currencies
                          </p>
                        </div>
                        <div
                          className="framer-ntpyzr"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-1etb2qj"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-2cg4h1 accounts-s40 reveal"
                              data-framer-name="What you can do:"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s44"
                              >
                                What you can do:
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-9nd1l3"
                            data-framer-name="Frame 17"
                          >
                            <div
                              className="framer-1u9176n"
                              data-framer-name="Frame 11"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-lytmez accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-1ihrr8b accounts-s23 reveal"
                                data-framer-name="EUR / GBP IBAN accounts \u2192 Scallop Airport Companion"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  View everything in one balance
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-vab3cp"
                              data-framer-name="Frame 12"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-m79zut accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-fu57xw accounts-s23"
                                data-framer-name="Swap crypto <-> fiat seamlessly \u2192 24 X 7  365 Days Personal Assistant"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  Spend from any asset
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-jog00h"
                              data-framer-name="Frame 14"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-4wgymk accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-16zdgjf accounts-s23 reveal"
                                data-framer-name="EAL6+ security & 24/7 support \u2192 Travel & Purchase Protect"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  Convert instantly
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-149h67o"
                              data-framer-name="Frame 15"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-azvfgk accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-80rena accounts-s23 reveal"
                                data-framer-name="Instant KYC onboarding \u2192 Luxury Hotel Collection"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  No bridging. No switching
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1gvvd5z hidden-1fi46e6 hidden-ms262u"
                          data-framer-name="Frame 1707479994"
                        />
                        {/*$*/}
                        <a
                          className="framer-1x4kez6 framer-1twpk0x"
                          data-framer-name="Frame 1707479995"
                          href="https://docs.scallopx.com/details/supported-rails-and-currencies-fiat"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            className="framer-1ekj5xk accounts-s23 reveal"
                            data-framer-name="Hold and manage 52+ fiat currencies globally from "
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s46">
                              Explore supported currencies
                            </p>
                          </div>
                          <div
                            className="framer-1yf1po2"
                            data-framer-name="ArrowUpRight"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Vector"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1mv6x7h accounts-s26"
                              aria-hidden="true"
                            >
                              <div className="svgContainer accounts-s27">
                                <svg viewBox="0 0 9 9" className="accounts-s28">
                                  <use href="#svg879503595_837" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div
                    className="framer-1s96bc7"
                    data-framer-appear-id="1s96bc7"
                    data-framer-name="Container"
                  >
                    <div
                      className="framer-1bheqan"
                      data-framer-name="Container"
                    />
                    <div
                      className="framer-bwh73e accounts-s52"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1h1kr7d"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-1bmzlih"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-aq77qy accounts-s53"
                            data-framer-name="image 1520"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="87"
                                height="87"
                                src="/framerusercontent.com/images/1oceTIR1r5cpCVKHctKmPUjribQ.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-mfuq2w"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-1b81mvg accounts-s40 reveal"
                              data-framer-name="USD Balance"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s55"
                              >
                                USD Balance
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-sc8or0 accounts-s40 reveal"
                          data-framer-name="$1,200.00"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s56">
                            $1,200.00
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1yfaz15"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-mwudt1"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-4einca"
                            data-framer-name="Container"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="50"
                                height="50"
                                src="/framerusercontent.com/images/pSjk1JQj9DHzoowqHAKIuFBVf8.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-1jo1f3w"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-1rirtsa accounts-s40 reveal"
                              data-framer-name="Tether"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s55"
                              >
                                Tether
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-g1cn3h accounts-s40 reveal"
                          data-framer-name="500.00 USDT"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s56">
                            500.00 USDT
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1aebk95"
                      data-framer-name="Container"
                    >
                      <div className="framer-ybubjo">
                        <div
                          className="framer-199khtm accounts-s23 reveal"
                          data-framer-name="Digital Assets and Stablecoins"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s50">
                            Digital Assets and Stablecoins
                          </p>
                        </div>
                        <div
                          className="framer-d505ek accounts-s23 reveal"
                          data-framer-name="Hold and manage 52+ fiat currencies globally from "
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s42">
                            Your digital assets aren&apos;t stored separately.
                            They sit in the same balance as your fiat
                            currencies.
                          </p>
                        </div>
                        <div
                          className="framer-ntpyzr"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-1etb2qj"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-2cg4h1 accounts-s40 reveal"
                              data-framer-name="What you can do:"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s44"
                              >
                                What you can do:
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-9nd1l3"
                            data-framer-name="Frame 17"
                          >
                            <div
                              className="framer-1u9176n"
                              data-framer-name="Frame 11"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-lytmez accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-1ihrr8b accounts-s23 reveal"
                                data-framer-name="EUR / GBP IBAN accounts \u2192 Scallop Airport Companion"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  View everything in one balance
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-vab3cp"
                              data-framer-name="Frame 12"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-m79zut accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-fu57xw accounts-s23"
                                data-framer-name="Swap crypto <-> fiat seamlessly \u2192 24 X 7  365 Days Personal Assistant"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  Spend from any asset
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-jog00h"
                              data-framer-name="Frame 14"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-4wgymk accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-16zdgjf accounts-s23 reveal"
                                data-framer-name="EAL6+ security & 24/7 support \u2192 Travel & Purchase Protect"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  Convert instantly
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-149h67o"
                              data-framer-name="Frame 15"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-azvfgk accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-80rena accounts-s23 reveal"
                                data-framer-name="Instant KYC onboarding \u2192 Luxury Hotel Collection"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  No bridging. No switching
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1gvvd5z hidden-1fi46e6 hidden-ms262u"
                          data-framer-name="Frame 1707479994"
                        />
                        {/*$*/}
                        <a
                          className="framer-1x4kez6 framer-1twpk0x"
                          data-framer-name="Frame 1707479995"
                          href="https://docs.scallopx.com/details/supported-rails-and-currencies-fiat"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            className="framer-1ekj5xk accounts-s23 reveal"
                            data-framer-name="Hold and manage 52+ fiat currencies globally from "
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s58">
                              Explore supported{' '}
                            </p>
                            <p dir="auto" className="framer-text accounts-s58">
                              currencies
                            </p>
                          </div>
                          <div
                            className="framer-1yf1po2"
                            data-framer-name="ArrowUpRight"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Vector"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1mv6x7h accounts-s26"
                              aria-hidden="true"
                            >
                              <div className="svgContainer accounts-s27">
                                <svg viewBox="0 0 9 9" className="accounts-s28">
                                  <use href="#svg879503595_837" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                  <div
                    className="framer-1s96bc7"
                    data-framer-appear-id="1s96bc7"
                    data-framer-name="Container"
                  >
                    <div
                      className="framer-1bheqan"
                      data-framer-name="Container"
                    />
                    <div
                      className="framer-bwh73e accounts-s52"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1h1kr7d"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-1bmzlih"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-aq77qy accounts-s53"
                            data-framer-name="image 1520"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="87"
                                height="87"
                                src="/framerusercontent.com/images/1oceTIR1r5cpCVKHctKmPUjribQ.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-mfuq2w"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-1b81mvg accounts-s40 reveal"
                              data-framer-name="USD Balance"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s55"
                              >
                                USD Balance
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-sc8or0 accounts-s40 reveal"
                          data-framer-name="$1,200.00"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s56">
                            $1,200.00
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1yfaz15"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-mwudt1"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-4einca"
                            data-framer-name="Container"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="50"
                                height="50"
                                src="/framerusercontent.com/images/pSjk1JQj9DHzoowqHAKIuFBVf8.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-1jo1f3w"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-1rirtsa accounts-s40 reveal"
                              data-framer-name="Tether"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s55"
                              >
                                Tether
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-g1cn3h accounts-s40 reveal"
                          data-framer-name="500.00 USDT"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s56">
                            500.00 USDT
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1aebk95"
                      data-framer-name="Container"
                    >
                      <div className="framer-ybubjo">
                        <div
                          className="framer-199khtm accounts-s23 reveal"
                          data-framer-name="Digital Assets and Stablecoins"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s50">
                            Digital Assets and Stablecoins
                          </p>
                        </div>
                        <div
                          className="framer-d505ek accounts-s23 reveal"
                          data-framer-name="Hold and manage 52+ fiat currencies globally from "
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s42">
                            Your digital assets aren&apos;t stored separately.
                            They sit in the same balance as your fiat
                            currencies.
                          </p>
                        </div>
                        <div
                          className="framer-ntpyzr"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-1etb2qj"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-2cg4h1 accounts-s40 reveal"
                              data-framer-name="What you can do:"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s44"
                              >
                                What you can do:
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-9nd1l3"
                            data-framer-name="Frame 17"
                          >
                            <div
                              className="framer-1u9176n"
                              data-framer-name="Frame 11"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-lytmez accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-1ihrr8b accounts-s23 reveal"
                                data-framer-name="EUR / GBP IBAN accounts \u2192 Scallop Airport Companion"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  View everything in one balance
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-vab3cp"
                              data-framer-name="Frame 12"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-m79zut accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-fu57xw accounts-s23"
                                data-framer-name="Swap crypto <-> fiat seamlessly \u2192 24 X 7  365 Days Personal Assistant"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  Spend from any asset
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-jog00h"
                              data-framer-name="Frame 14"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-4wgymk accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-16zdgjf accounts-s23 reveal"
                                data-framer-name="EAL6+ security & 24/7 support \u2192 Travel & Purchase Protect"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  Convert instantly
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-149h67o"
                              data-framer-name="Frame 15"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="SVG \u2192 SVG"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-azvfgk accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 18 18"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-458407791_470" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-80rena accounts-s23 reveal"
                                data-framer-name="Instant KYC onboarding \u2192 Luxury Hotel Collection"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s57"
                                >
                                  No bridging. No switching
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1gvvd5z hidden-1fi46e6 hidden-ms262u"
                          data-framer-name="Frame 1707479994"
                        />
                        {/*$*/}
                        <a
                          className="framer-1x4kez6 framer-1twpk0x"
                          data-framer-name="Frame 1707479995"
                          href="https://docs.scallopx.com/details/supported-rails-and-currencies-fiat"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            className="framer-1ekj5xk accounts-s23 reveal"
                            data-framer-name="Hold and manage 52+ fiat currencies globally from "
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s59">
                              Explore supported currencies
                            </p>
                          </div>
                          <div
                            className="framer-1yf1po2"
                            data-framer-name="ArrowUpRight"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Vector"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1mv6x7h accounts-s26"
                              aria-hidden="true"
                            >
                              <div className="svgContainer accounts-s27">
                                <svg viewBox="0 0 9 9" className="accounts-s28">
                                  <use href="#svg879503595_837" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-1cix7v8" data-framer-appear-id="1cix7v8">
                <div className="framer-ei1jg0">
                  <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                    <div
                      className="framer-7zobet"
                      data-border="true"
                      data-framer-appear-id="7zobet"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-50z3ae accounts-s40 reveal"
                        data-framer-name="Instant conversion"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Instant conversion
                        </p>
                      </div>
                      <div
                        className="framer-5qccgw accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s61">
                          Swap between fiat, stablecoins and digital assets in
                          seconds
                        </p>
                      </div>
                      <div
                        className="framer-1bltouc"
                        data-framer-name="image 1558"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="160"
                            height="160"
                            src="/framerusercontent.com/images/mV3Ahq0ai4M0RwT9JvTJO1C1yQY.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    <div
                      className="framer-7zobet"
                      data-border="true"
                      data-framer-appear-id="7zobet"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-50z3ae accounts-s40 reveal"
                        data-framer-name="Instant conversion"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Instant conversion
                        </p>
                      </div>
                      <div
                        className="framer-5qccgw accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s61">
                          Swap between fiat, stablecoins and digital assets in
                          seconds
                        </p>
                      </div>
                      <div
                        className="framer-1bltouc"
                        data-framer-name="image 1558"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="160"
                            height="160"
                            src="/framerusercontent.com/images/mV3Ahq0ai4M0RwT9JvTJO1C1yQY.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                    <div
                      className="framer-7zobet"
                      data-border="true"
                      data-framer-appear-id="7zobet"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-50z3ae accounts-s62 reveal"
                        data-framer-name="Instant conversion"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Instant conversion
                        </p>
                      </div>
                      <div
                        className="framer-5qccgw accounts-s63 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s61">
                          Swap between fiat, stablecoins and digital assets in
                          seconds
                        </p>
                      </div>
                      <div
                        className="framer-1bltouc"
                        data-framer-name="image 1558"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="160"
                            height="160"
                            src="/framerusercontent.com/images/mV3Ahq0ai4M0RwT9JvTJO1C1yQY.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                    <div
                      className="framer-1e6n3wt"
                      data-border="true"
                      data-framer-appear-id="1e6n3wt"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1lf4lrj accounts-s40 reveal"
                        data-framer-name="Global payments"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Global payments
                        </p>
                      </div>
                      <div
                        className="framer-4ooodx accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s64">
                          Send and receive money worldwide with clear rates and
                          no hidden fees
                        </p>
                      </div>
                      <div
                        className="framer-12nspt9"
                        data-framer-name="image 1 \u2192 f9kcasPp09X0W75IxfCvQWBQgyc.png"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="152"
                            height="164"
                            src="/framerusercontent.com/images/AqpfftH4Tch7W7G14reXN2hB4.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    <div
                      className="framer-1e6n3wt"
                      data-border="true"
                      data-framer-appear-id="1e6n3wt"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1lf4lrj accounts-s40 reveal"
                        data-framer-name="Global payments"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Global payments
                        </p>
                      </div>
                      <div
                        className="framer-4ooodx accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s64">
                          Send and receive money worldwide with clear rates and
                          no hidden fees
                        </p>
                      </div>
                      <div
                        className="framer-12nspt9"
                        data-framer-name="image 1 \u2192 f9kcasPp09X0W75IxfCvQWBQgyc.png"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="152"
                            height="164"
                            src="/framerusercontent.com/images/AqpfftH4Tch7W7G14reXN2hB4.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                    <div
                      className="framer-1e6n3wt"
                      data-border="true"
                      data-framer-appear-id="1e6n3wt"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1lf4lrj accounts-s62 reveal"
                        data-framer-name="Global payments"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Global payments
                        </p>
                      </div>
                      <div
                        className="framer-4ooodx accounts-s63 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s64">
                          Send and receive money worldwide with clear rates and
                          no hidden fees
                        </p>
                      </div>
                      <div
                        className="framer-12nspt9"
                        data-framer-name="image 1 \u2192 f9kcasPp09X0W75IxfCvQWBQgyc.png"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="152"
                            height="164"
                            src="/framerusercontent.com/images/AqpfftH4Tch7W7G14reXN2hB4.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-e2d68q">
                  <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                    <div
                      className="framer-1kxs00r"
                      data-border="true"
                      data-framer-appear-id="1kxs00r"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1lino1q accounts-s40 reveal"
                        data-framer-name="Virtual cards"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Virtual cards
                        </p>
                      </div>
                      <div
                        className="framer-qu9v3f accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s64">
                          Create cards instantly and use them globally
                        </p>
                      </div>
                      <div
                        className="framer-11qzxw2"
                        data-framer-name="image 1562"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="228"
                            height="200"
                            src="/framerusercontent.com/images/BaHIJl5YXQjmEQV1Hd6yt0j8.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-7w4uxy hidden-1fi46e6 hidden-ms262u"
                        data-framer-name="ArrowUpRight"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-16e3bdq accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 14 14" className="accounts-s28">
                              <use href="#svg-2032160236_829" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    <div
                      className="framer-1kxs00r"
                      data-border="true"
                      data-framer-appear-id="1kxs00r"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1lino1q accounts-s40 reveal"
                        data-framer-name="Virtual cards"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Virtual cards
                        </p>
                      </div>
                      <div
                        className="framer-qu9v3f accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s64">
                          Create cards instantly and use them globally
                        </p>
                      </div>
                      <div
                        className="framer-11qzxw2"
                        data-framer-name="image 1562"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="228"
                            height="200"
                            src="/framerusercontent.com/images/BaHIJl5YXQjmEQV1Hd6yt0j8.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-7w4uxy hidden-1fi46e6 hidden-ms262u"
                        data-framer-name="ArrowUpRight"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-16e3bdq accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 14 14" className="accounts-s28">
                              <use href="#svg-2032160236_829" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                    <div
                      className="framer-1kxs00r"
                      data-border="true"
                      data-framer-appear-id="1kxs00r"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-1lino1q accounts-s62 reveal"
                        data-framer-name="Virtual cards"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Virtual cards
                        </p>
                      </div>
                      <div
                        className="framer-qu9v3f accounts-s63 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s64">
                          Create cards instantly and use them globally
                        </p>
                      </div>
                      <div
                        className="framer-11qzxw2"
                        data-framer-name="image 1562"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="228"
                            height="200"
                            src="/framerusercontent.com/images/BaHIJl5YXQjmEQV1Hd6yt0j8.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-7w4uxy hidden-1fi46e6 hidden-ms262u"
                        data-framer-name="ArrowUpRight"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-16e3bdq accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 14 14" className="accounts-s28">
                              <use href="#svg-2032160236_829" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                    <div
                      className="framer-1cvtv7y"
                      data-border="true"
                      data-framer-appear-id="1cvtv7y"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-146qnmb accounts-s40 reveal"
                        data-framer-name="Scallop Pay"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Scallop Pay
                        </p>
                      </div>
                      <div
                        className="framer-1wh1c22 accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s65">
                          Pay like a local in 10+ currencies via QR (PIX, GCash,
                          Maya, VietQR)
                        </p>
                      </div>
                      <div
                        className="framer-3h6wpm"
                        data-framer-name="image 1560"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="208"
                            height="208"
                            src="/framerusercontent.com/images/qsJD9eEIm6MQ2FE1T56bABOESc.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-1y8k6kc hidden-1fi46e6 hidden-ms262u"
                        data-framer-name="ArrowUpRight"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1y64wr0 accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 14 14" className="accounts-s28">
                              <use href="#svg-2032160236_829" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    <div
                      className="framer-1cvtv7y"
                      data-border="true"
                      data-framer-appear-id="1cvtv7y"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-146qnmb accounts-s40 reveal"
                        data-framer-name="Scallop Pay"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Scallop Pay
                        </p>
                      </div>
                      <div
                        className="framer-1wh1c22 accounts-s23 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s65">
                          Pay like a local in 10+ currencies via QR (PIX, GCash,
                          Maya, VietQR)
                        </p>
                      </div>
                      <div
                        className="framer-3h6wpm"
                        data-framer-name="image 1560"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="208"
                            height="208"
                            src="/framerusercontent.com/images/qsJD9eEIm6MQ2FE1T56bABOESc.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-1y8k6kc hidden-1fi46e6 hidden-ms262u"
                        data-framer-name="ArrowUpRight"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1y64wr0 accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 14 14" className="accounts-s28">
                              <use href="#svg-2032160236_829" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                    <div
                      className="framer-1cvtv7y"
                      data-border="true"
                      data-framer-appear-id="1cvtv7y"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-146qnmb accounts-s62 reveal"
                        data-framer-name="Scallop Pay"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s60">
                          Scallop Pay
                        </p>
                      </div>
                      <div
                        className="framer-1wh1c22 accounts-s63 reveal"
                        data-framer-name="Swap between currencies and digital assets in seco"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s65">
                          Pay like a local in 10+ currencies via QR (PIX, GCash,
                          Maya, VietQR)
                        </p>
                      </div>
                      <div
                        className="framer-3h6wpm"
                        data-framer-name="image 1560"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="208"
                            height="208"
                            src="/framerusercontent.com/images/qsJD9eEIm6MQ2FE1T56bABOESc.png"
                            alt=""
                            className="accounts-s38"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-1y8k6kc hidden-1fi46e6 hidden-ms262u"
                        data-framer-name="ArrowUpRight"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1y64wr0 accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 14 14" className="accounts-s28">
                              <use href="#svg-2032160236_829" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1y1363o">
              <div className="framer-1lp8m3o" data-framer-name="Features 2">
                <div
                  className="framer-1bfff06 hidden-ms262u"
                  data-framer-name="Container"
                />
                <div
                  className="framer-1e7y4yv hidden-ms262u"
                  data-framer-name="Container"
                />
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-14ecnd1 accounts-s23 reveal"
                    data-framer-name="Built for how money actually moves"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s66">
                      Built for how money actually moves
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div
                    className="framer-14ecnd1 accounts-s23 reveal"
                    data-framer-name="Built for how money actually moves"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1 dir="auto" className="framer-text accounts-s67">
                      Built for how money actually moves
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                  <div
                    className="framer-14ecnd1 accounts-s23 reveal"
                    data-framer-name="Built for how money actually moves"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw accounts-s68"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Built for how money actually moves
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u">
                  <div className="framer-1gy6mrr">
                    <div className="framer-oro6l4">
                      <div
                        className="framer-dtzfrp"
                        data-framer-name="Frame 1707479928"
                      >
                        <div
                          className="framer-175dqg0"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-blyloj accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg-959763977_725" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-1erfpkv"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-cjvgx1 accounts-s40 reveal"
                              data-framer-name="Hold multiple currencies"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Hold multiple currencies
                              </p>
                            </div>
                            <div
                              className="framer-1634sdj accounts-s23 reveal"
                              data-framer-name="Without opening multiple accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                Without opening multiple accounts
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-rmyr7p"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-l53j31 accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg-874199162_1508" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-e6tvoe"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-m6l6e8 accounts-s40 reveal"
                              data-framer-name="Operate globally"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Operate globally
                              </p>
                            </div>
                            <div
                              className="framer-mouo8o accounts-s23 reveal"
                              data-framer-name="From one account."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                From one account
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-fx94zm"
                        data-framer-name="Container"
                      >
                        <div className="ssr-variant">
                          <div
                            className="framer-gx2wlp accounts-s70"
                            data-framer-name="image 1623"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="284"
                                height="177"
                                src="/framerusercontent.com/images/bncd2CsUlCwXmsdaMt3ZwtIYb0.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="framer-1moj3bn" data-framer-name="swap">
                          <div className="ssr-variant hidden-1fi46e6">
                            <div
                              className="framer-zixace accounts-s71"
                              data-framer-name="image 1510"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="998"
                                  height="2048"
                                  sizes="(min-width: 1440px) 258px, (min-width: 810px) and (max-width: 1439.98px) 258px, (max-width: 809.98px) 258px"
                                  srcSet="/framerusercontent.com/images/kMOaqTxloSH2nP3KaFNepWawIFk.png 998w"
                                  src="/framerusercontent.com/images/kMOaqTxloSH2nP3KaFNepWawIFk.png"
                                  alt=""
                                  className="accounts-s54"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ix61hb">
                            <div
                              className="framer-zixace"
                              data-framer-name="image 1510"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="998"
                                  height="2048"
                                  sizes="(min-width: 1440px) 258px, (min-width: 810px) and (max-width: 1439.98px) 258px, (max-width: 809.98px) 258px"
                                  srcSet="/framerusercontent.com/images/kMOaqTxloSH2nP3KaFNepWawIFk.png 998w"
                                  src="/framerusercontent.com/images/kMOaqTxloSH2nP3KaFNepWawIFk.png"
                                  alt=""
                                  className="accounts-s54"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-1fi46e6">
                            <div
                              className="framer-1ishiq9 accounts-s71"
                              data-framer-name="iPhone 17 Pro orange front label"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="1838"
                                  height="3969"
                                  sizes="(min-width: 1440px) 237.7179px, (min-width: 810px) and (max-width: 1439.98px) 237.7179px, (max-width: 809.98px) 237.7179px"
                                  srcSet="/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png 948w,/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png 1838w"
                                  src="/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png"
                                  alt=""
                                  className="accounts-s54"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ix61hb">
                            <div
                              className="framer-1ishiq9 accounts-s72"
                              data-framer-name="iPhone 17 Pro orange front label"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="accounts-s37"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="1838"
                                  height="3969"
                                  sizes="(min-width: 1440px) 237.7179px, (min-width: 810px) and (max-width: 1439.98px) 237.7179px, (max-width: 809.98px) 237.7179px"
                                  srcSet="/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png 948w,/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png 1838w"
                                  src="/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png"
                                  alt=""
                                  className="accounts-s54"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-qsoowb"
                        data-framer-name="Frame 1707479927"
                      >
                        <div
                          className="framer-my8f5u"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-nkuvgl accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg883086955_1070" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-jkhdhh"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-17lf1ad accounts-s40 reveal"
                              data-framer-name="Earn in one currency"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Earn in one currency
                              </p>
                            </div>
                            <div
                              className="framer-ub7a50 accounts-s23 reveal"
                              data-framer-name="Spend to another direct from the same."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                Spend in another currency directly from the same
                                balance
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-ybmo3p"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-d3uj2h accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg-899467930_1823" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-1yuqklr"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-1g0p0pm accounts-s40 reveal"
                              data-framer-name="Send money internationally"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Send money internationally
                              </p>
                            </div>
                            <div
                              className="framer-1qepqk2 accounts-s23 reveal"
                              data-framer-name="Without transfers between systems."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                Without transfers between systems
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div className="framer-1gy6mrr accounts-s73">
                    <div className="framer-oro6l4">
                      <div
                        className="framer-dtzfrp"
                        data-framer-name="Frame 1707479928"
                      >
                        <div
                          className="framer-175dqg0"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-blyloj accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg-959763977_725" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-1erfpkv"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-cjvgx1 accounts-s40 reveal"
                              data-framer-name="Hold multiple currencies"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Hold multiple currencies
                              </p>
                            </div>
                            <div
                              className="framer-1634sdj accounts-s23 reveal"
                              data-framer-name="Without opening multiple accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                Without opening multiple accounts
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-rmyr7p"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-l53j31 accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg-874199162_1508" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-e6tvoe"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-m6l6e8 accounts-s40 reveal"
                              data-framer-name="Operate globally"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Operate globally
                              </p>
                            </div>
                            <div
                              className="framer-mouo8o accounts-s23 reveal"
                              data-framer-name="From one account."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                From one account
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-fx94zm"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-gx2wlp accounts-s70"
                          data-framer-name="image 1623"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="accounts-s37"
                          >
                            <img
                              decoding="async"
                              loading="lazy"
                              width="284"
                              height="177"
                              src="/framerusercontent.com/images/bncd2CsUlCwXmsdaMt3ZwtIYb0.png"
                              alt=""
                              className="accounts-s54"
                            />
                          </div>
                        </div>
                        <div className="framer-1moj3bn" data-framer-name="swap">
                          <div
                            className="framer-zixace accounts-s71"
                            data-framer-name="image 1510"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) 258px, (min-width: 810px) and (max-width: 1439.98px) 258px, (max-width: 809.98px) 258px"
                                srcSet="/framerusercontent.com/images/kMOaqTxloSH2nP3KaFNepWawIFk.png 998w"
                                src="/framerusercontent.com/images/kMOaqTxloSH2nP3KaFNepWawIFk.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-1ishiq9 accounts-s72"
                            data-framer-name="iPhone 17 Pro orange front label"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="accounts-s37"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="1838"
                                height="3969"
                                sizes="(min-width: 1440px) 237.7179px, (min-width: 810px) and (max-width: 1439.98px) 237.7179px, (max-width: 809.98px) 237.7179px"
                                srcSet="/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png 948w,/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png 1838w"
                                src="/framerusercontent.com/images/DfSkRABYxKVivxSvySVzgLmQlqw.png"
                                alt=""
                                className="accounts-s54"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-qsoowb"
                        data-framer-name="Frame 1707479927"
                      >
                        <div
                          className="framer-my8f5u"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-nkuvgl accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg883086955_1070" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-jkhdhh"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-17lf1ad accounts-s40 reveal"
                              data-framer-name="Earn in one currency"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Earn in one currency
                              </p>
                            </div>
                            <div
                              className="framer-ub7a50 accounts-s23 reveal"
                              data-framer-name="Spend to another direct from the same."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                Spend in another currency directly from the same
                                balance
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-ybmo3p"
                          data-border="true"
                          data-framer-name="Container"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame 1707479998"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-d3uj2h accounts-s26"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 40 40" className="accounts-s28">
                                <use href="#svg-899467930_1823" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-1yuqklr"
                            data-framer-name="Frame 1707479999"
                          >
                            <div
                              className="framer-1g0p0pm accounts-s40 reveal"
                              data-framer-name="Send money internationally"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s69"
                              >
                                Send money internationally
                              </p>
                            </div>
                            <div
                              className="framer-1qepqk2 accounts-s23 reveal"
                              data-framer-name="Without transfers between systems."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s64"
                              >
                                Without transfers between systems
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1hnxgu5" data-framer-name="Pricing">
              <div className="framer-1u2lccs" data-framer-name="Container">
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-bh6l7w accounts-s23 reveal"
                    data-framer-name="Choose how you use your account"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s30">
                      Choose how you use your account
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div
                    className="framer-bh6l7w accounts-s23 reveal"
                    data-framer-name="Choose how you use your account"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s74">
                      Choose how you use your account
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                  <div
                    className="framer-bh6l7w accounts-s23 reveal"
                    data-framer-name="Choose how you use your account"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s75">
                      Choose how you use your account
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-qtu2ab accounts-s40 reveal"
                    data-framer-name="More features, higher limits, and priority access "
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s41">
                      More features, higher limits, and priority access as you
                      scale
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ix61hb">
                  <div
                    className="framer-qtu2ab accounts-s23 reveal"
                    data-framer-name="More features, higher limits, and priority access "
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s34">
                      More features, higher limits, and priority access as you
                      scale
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-1u4t2oh">
                <div
                  className="framer-vih0va"
                  data-border="true"
                  data-framer-name="Frame 1707479949"
                >
                  <div
                    className="framer-19q5htq"
                    data-framer-name="Frame 1707479991"
                  >
                    <div className="framer-vsd1wz" data-framer-name="Container">
                      <div
                        className="framer-1yg9802 accounts-s23 reveal"
                        data-framer-name="Voyager"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s76">
                          Voyager
                        </p>
                      </div>
                      <div
                        className="framer-jjds5i accounts-s40 reveal"
                        data-framer-name="For personal use. \u2028Manage and move your own funds."
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s77">
                          For personal use. <br className="framer-text" />
                          Manage and move your own funds
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1fv3dl6"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-m7buff"
                        data-framer-name="Frame 1707479947"
                      >
                        <div
                          className="framer-7jhcgb accounts-s23 reveal"
                          data-framer-name="A free entry-level tier designed for users who wan"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s42">
                            Basic access to hold, convert, and move your own
                            funds{' '}
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-chptkh"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-n067k2"
                          data-framer-name="Text"
                        />
                        <div
                          className="framer-wbolq3 accounts-s40 reveal"
                          data-framer-name="Best for:"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s78">
                            Best for:
                          </p>
                        </div>
                        <div
                          className="framer-4naa7a accounts-s23 reveal"
                          data-framer-name="Individuals managing their own money across curren"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s79">
                            Users managing their own funds across currencies
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-f5xx1h" data-framer-name="Container">
                    <div
                      className="framer-1altkqk accounts-s23 reveal"
                      data-framer-name="(No subscription fee)"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s57">
                        (No subscription fee)
                      </p>
                    </div>
                    <div
                      className="framer-1xd3cm9 accounts-s62 reveal"
                      data-framer-name="Free"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s80">
                        Free
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u">
                    {/*$*/}
                    <a
                      className="framer-1xsiv66 framer-1twpk0x"
                      data-border="true"
                      data-framer-name="Button"
                      id="1xsiv66"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-1fvjvop accounts-s51 reveal"
                        data-framer-name="Get Started with Voyager"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s81">
                          Get Started with Voyager
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    {/*$*/}
                    <a
                      className="framer-1xsiv66 framer-1twpk0x"
                      data-border="true"
                      data-framer-name="Button"
                      id="1xsiv66"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-1fvjvop accounts-s51 reveal"
                        data-framer-name="Get Started with Voyager"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s81">
                          Get Started with Voyager
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div className="framer-aicj58" data-framer-name="Container">
                    <div
                      className="framer-1sf2cre"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-lm6l7g accounts-s40 reveal"
                        data-framer-name="Pricing & Limits"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s82">
                          Pricing &amp; Limits
                        </p>
                      </div>
                      <div className="framer-78hub3" data-framer-name="List">
                        <div
                          className="framer-1saxrm2"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-107srfn accounts-s23 reveal"
                            data-framer-name="Swap fee"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Swap fee
                            </p>
                          </div>
                          <div
                            className="framer-15mg546 accounts-s23 reveal"
                            data-framer-name="1.5%"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s83">
                              1.5%
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-m84pql"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-1ftfixl accounts-s23 reveal"
                            data-framer-name="Virtual cards"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Virtual cards
                            </p>
                          </div>
                          <div
                            className="framer-tlygfp accounts-s23 reveal"
                            data-framer-name="$2 per card"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s83">
                              $2 per card
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-10g00rq"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-70qskg accounts-s23 reveal"
                            data-framer-name="Yield"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Yield
                            </p>
                          </div>
                          <div
                            className="framer-15iln5t accounts-s23 reveal"
                            data-framer-name="Not Available"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s83">
                              Not Available
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-h3p0nd" data-framer-name="Container">
                      <div
                        className="framer-1wq6uwq"
                        data-framer-name="Heading 4"
                      >
                        <div
                          className="framer-1gyzlo9 accounts-s40 reveal"
                          data-framer-name="Coverage"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s82">
                            Coverage
                          </p>
                        </div>
                      </div>
                      <div className="framer-q8hd1h" data-framer-name="List">
                        <div
                          className="framer-r9byu5"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-1sbr9cb"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-1n7ewwe accounts-s40 reveal"
                              data-framer-name="Supported currencies :"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s44"
                              >
                                Supported currencies
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-yl1xyx"
                            data-framer-name="Frame 1707479828"
                          >
                            <div
                              className="framer-vbj6c6"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-92m2n6"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-1i2k27g"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Clip path group"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-83roro accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg2080463978_9012" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-13l3i7p"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-1azy8q3"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-j8ux2u"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-le22wk accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-77748519_156" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1dc3nb8 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg2125279330_305" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1xmlpbn accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg994370299_368" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1wwaqw4 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1148296261_203" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1mo45ag accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-29915228_203" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-68cfk5"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-k5wjav"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-j9ag6h"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-hng6p7 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg49011196_156" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Group"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7yn9pf accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 25 24"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-983728359_11122" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-1na7z8i"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-vqffaz"
                                data-framer-name="Group circle"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Oval"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-ga5iij accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 35 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1761932441_338" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  className="framer-1h387ha accounts-s23 reveal"
                                  data-framer-name="FL"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s45"
                                  >
                                    7+
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1gfkw7c"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-r2gqjb"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-sk61hw accounts-s40 reveal"
                              data-framer-name="Payout (fiat currencies) corridors:"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s44"
                              >
                                Fiat payout corridors
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1m7r760"
                            data-framer-name="Frame 1707479828"
                          >
                            <div
                              className="framer-5ic4od"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-188qpq3"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-13dzo8t"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Clip path group"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1m1y2fv accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1372703318_9012" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-fjcmzr"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-wnd4er"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-u93qx1"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-d4rgl9 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-77748519_156" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1n98xa1 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg2125279330_305" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-xlqi27 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg994370299_368" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-wwkkyl accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1148296261_203" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-ygzuv0 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-29915228_203" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-cugx69"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-1qs5218"
                                data-framer-name="Group circle"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Oval"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1i98dxh accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 35 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1761932441_338" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  className="framer-1tqygoi accounts-s23 reveal"
                                  data-framer-name="FL"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s45"
                                  >
                                    8+
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1a987g1"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-lkucrd"
                        data-framer-name="Heading 4"
                      >
                        <div
                          className="framer-cq3yq7 accounts-s40 reveal"
                          data-framer-name="What you can do"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s82">
                            What you can do
                          </p>
                        </div>
                      </div>
                      <div className="framer-1qlhzpj" data-framer-name="List">
                        <div
                          className="framer-gfonau"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-4id7mf accounts-s23 reveal reveal-fast"
                            data-framer-name="Hold and manage up to 10 currencies"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Hold and manage up to 10 currencies
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1rbwi6t accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-ntpkj"
                          data-framer-name="List Item"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1luht1l accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-xtbj1k accounts-s23 reveal reveal-fast"
                            data-framer-name="Send funds globally"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s84">
                              Send funds globally
                            </p>
                          </div>
                        </div>
                        <div className="framer-15c2o1c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-13vvze8 accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-bage11 accounts-s23 reveal reveal-fast"
                            data-framer-name="First virtual card free, additional cards $1 each\u2028"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Convert currencies instantly within the app
                            </p>
                          </div>
                          <div
                            className="framer-30gn1g"
                            data-framer-name="List Item"
                          />
                        </div>
                        <div
                          className="framer-m5e138"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-1ns17il accounts-s23 reveal reveal-fast"
                            data-framer-name="Withdraw to supported fiat corridors"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Withdraw to supported fiat corridors
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m1yadk accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-10ghp6d"
                          data-framer-name="List Item"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-rp77c9 accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-fkpuut accounts-s23 reveal reveal-fast"
                            data-framer-name="No third-party incoming transfers"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s84">
                              No third-party incoming transfers
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-3turlm" data-framer-name="Container">
                  <div
                    className="framer-ful240 accounts-s72 reveal"
                    data-framer-name="Most Popular"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s85">
                      Most Popular
                    </p>
                  </div>
                </div>
                <div
                  className="framer-1mwupau"
                  data-border="true"
                  data-framer-name="Frame 1707479949"
                >
                  <div
                    className="framer-1e30en3"
                    data-framer-name="Frame 1707479993"
                  >
                    <div className="framer-wnv12h" data-framer-name="Container">
                      <div
                        className="framer-1pknxtx accounts-s23 reveal"
                        data-framer-name="Mariner"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s86">
                          Mariner
                        </p>
                      </div>
                      <div
                        className="framer-1g6ezg accounts-s40 reveal"
                        data-framer-name="For global payments, spending, \u2028and real-world use"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s77">
                          For global payments, spending,{' '}
                          <br className="framer-text" />
                          and real-world use
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1hrlvp9"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-q5634s"
                        data-framer-name="Frame 1707479947"
                      >
                        <div
                          className="framer-1mx5dab accounts-s23 reveal"
                          data-framer-name="A free entry-level tier designed for users who wan"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s42">
                            Use one balance to send, receive, and spend globally
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1v51dfv"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-gvquan"
                          data-framer-name="Text"
                        />
                        <div
                          className="framer-1tr8qgt accounts-s40 reveal"
                          data-framer-name="Best for:"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s78">
                            Best for:
                          </p>
                        </div>
                        <div
                          className="framer-1bsg3fn accounts-s23 reveal"
                          data-framer-name="Individuals managing their own money across curren"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s79">
                            Users who earn, spend, and send money globally
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-15dozea" data-framer-name="Container">
                    <div
                      className="framer-1t8bq2j accounts-s23 reveal"
                      data-framer-name="(No subscription fee)"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s57">
                        (Per month)
                      </p>
                    </div>
                    <div
                      className="framer-1ug3gr3 accounts-s62 reveal"
                      data-framer-name="Free"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s80">
                        $14.99
                      </p>
                    </div>
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Icon"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-13uoq2o accounts-s26 reveal reveal-fast"
                      aria-hidden="true"
                    >
                      <div className="svgContainer accounts-s27">
                        <svg viewBox="0 0 17 17" className="accounts-s28">
                          <use href="#svg1101367428_791" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u">
                    {/*$*/}
                    <a
                      className="framer-77l2ya framer-1twpk0x"
                      data-framer-name="Button"
                      id="77l2ya"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-1b8y8hf accounts-s51 reveal"
                        data-framer-name="Get Started with Mariner"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s87">
                          Get Started with Mariner
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    {/*$*/}
                    <a
                      className="framer-77l2ya framer-1twpk0x"
                      data-framer-name="Button"
                      id="77l2ya"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-1b8y8hf accounts-s51 reveal"
                        data-framer-name="Get Started with Mariner"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s87">
                          Get Started with Mariner
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div className="framer-17q4hff" data-framer-name="Container">
                    <div className="framer-59a50j" data-framer-name="Container">
                      <div
                        className="framer-14cweq7 accounts-s40 reveal"
                        data-framer-name="Pricing & Limits"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s82">
                          Pricing &amp; Limits
                        </p>
                      </div>
                      <div className="framer-1e88vns" data-framer-name="List">
                        <div
                          className="framer-a6zpqn"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-8h8a6y accounts-s23 reveal"
                            data-framer-name="Swap fee"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Swap fee
                            </p>
                          </div>
                          <div
                            className="framer-21dqfs accounts-s23 reveal"
                            data-framer-name="0.75%"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s83">
                              0.75%
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1tpap1i"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-vrqxam accounts-s23 reveal"
                            data-framer-name="Virtual cards"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Virtual cards
                            </p>
                          </div>
                          <div className="ssr-variant hidden-1fi46e6">
                            <div
                              className="framer-1fp2nhl accounts-s23 reveal"
                              data-framer-name="First free, additional $1.00 each"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s83"
                              >
                                First free, additional{' '}
                              </p>
                              <p
                                dir="auto"
                                className="framer-text accounts-s83"
                              >
                                $1.00 each
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                            <div
                              className="framer-1fp2nhl accounts-s23 reveal"
                              data-framer-name="First free, additional $1.00 each"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s83"
                              >
                                First free, additional $1.00 each
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1wwicfa"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-1xd6qz6 accounts-s23 reveal"
                            data-framer-name="Yield"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Yield
                            </p>
                          </div>
                          <div
                            className="framer-1ryivlo accounts-s23 reveal"
                            data-framer-name="Coming Soon"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s88">
                              Coming Soon
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-9www0z" data-framer-name="Container">
                      <div
                        className="framer-1ue42t7"
                        data-framer-name="Heading 4"
                      >
                        <div
                          className="framer-j85ybx accounts-s40 reveal"
                          data-framer-name="Coverage"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s82">
                            Coverage
                          </p>
                        </div>
                      </div>
                      <div className="framer-zjcvo4" data-framer-name="List">
                        <div
                          className="framer-4w17f1"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-1eks18h"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-c9po7v accounts-s40 reveal"
                              data-framer-name="Supported currencies :"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s44"
                              >
                                Supported currencies
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-11hktg5"
                            data-framer-name="Frame 1707479828"
                          >
                            <div
                              className="framer-gpjozc"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-1mfqa9b"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-1awiwnc"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Clip path group"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-3nnbhk accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg798110794_9012" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-yauanz"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-1sr5egz"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-1wvm5l1"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-17vbm7s accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-77748519_156" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-17p0nnd accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg2125279330_305" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1vc8ftc accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg994370299_368" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-xp4ltq accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1148296261_203" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7ovku8 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-29915228_203" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-19r1tt7"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-lvik5h"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-3gdk6w"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1h3bkv8 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg49011196_156" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Group"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1wa5ivh accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 25 24"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-983728359_11122" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-mjcrwl"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-9hdxkh"
                                data-framer-name="Group circle"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Oval"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-kt1vfj accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 35 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1761932441_338" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  className="framer-vkykdw accounts-s23 reveal"
                                  data-framer-name="FL"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s45"
                                  >
                                    49+
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-e06xj2"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-cslwue"
                            data-framer-name="Paragraph"
                          >
                            <div
                              className="framer-fnjftc accounts-s40 reveal"
                              data-framer-name="Payout (fiat currencies) corridors:"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s44"
                              >
                                Fiat payout corridors
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-194qcjc"
                            data-framer-name="Frame 1707479828"
                          >
                            <div
                              className="framer-1rfw16h"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-1gn8pm"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-1j9itaw"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Clip path group"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1acibd6 accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg98887204_9010" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-1440vrc"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-1c8tkuz"
                                data-framer-name="Mask"
                              >
                                <div
                                  className="framer-15yo1y3"
                                  data-framer-name="Countries"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1wy2f7p accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-77748519_156" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-ix9lvi accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg2125279330_305" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1eu8n7y accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg994370299_368" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-157jiih accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1148296261_203" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Vector"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-1ukywxg accounts-s26"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 47 35"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-29915228_203" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-1icvkhz"
                              data-framer-name="Avatar"
                            >
                              <div
                                className="framer-1fjwjpe"
                                data-framer-name="Group circle"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Oval"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-11u6km9 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 35 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1761932441_338" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  className="framer-knl405 accounts-s23 reveal"
                                  data-framer-name="FL"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s45"
                                  >
                                    50+
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-51n2so" data-framer-name="Container">
                      <div
                        className="framer-hdlhvw"
                        data-framer-name="Heading 4"
                      >
                        <div
                          className="framer-1kwi06 accounts-s40 reveal"
                          data-framer-name="What you can do"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s82">
                            What you can do
                          </p>
                        </div>
                      </div>
                      <div className="framer-166d9zb" data-framer-name="List">
                        <div className="framer-15wo4mp hidden-ms262u">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-enxb5p accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-1fi46e6">
                            <div
                              className="framer-3ghrld accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s84"
                              >
                                Send funds globally to third parties
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                            <div
                              className="framer-3ghrld accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Send funds globally to third parties
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="framer-1hqwb7t hidden-ms262u">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ud7k6e accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-1fi46e6">
                            <div
                              className="framer-zb35pr accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s84"
                              >
                                Access virtual accounts, including USD,EUR, GBP
                                and AED
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                            <div
                              className="framer-zb35pr accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Access virtual accounts, including USD,EUR, GBP
                                and AED
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="framer-1j9thf6">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-mam1r7 accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                            <div
                              className="framer-19cawa3 accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s84"
                              >
                                Receive third-party transfers{' '}
                                <br className="framer-text" />
                                (USD and AED supported)
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                            <div
                              className="framer-19cawa3 accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                First virtual card free, additional cards $1
                                each
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                            <div
                              className="framer-19cawa3 accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Receive third-party transfers (USD and AED
                                supported)
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="framer-gl9m9y">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19nq8p1 accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u">
                            <div
                              className="framer-yg2osk accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Convert currencies instantly within the app
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                            <div
                              className="framer-yg2osk accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Send funds globally to third parties
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1u64558 hidden-ix61hb"
                          data-framer-name="List Item"
                        >
                          <div className="ssr-variant hidden-1fi46e6">
                            <div
                              className="framer-1sc6d9a accounts-s23 reveal reveal-fast"
                              data-framer-name="Receive third-party transfers \u2028(USD and AED supported)"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s84"
                              >
                                Access virtual accounts, including USD,EUR, GBP
                                and AED
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                            <div
                              className="framer-1sc6d9a accounts-s89 reveal reveal-fast"
                              data-framer-name="Receive third-party transfers \u2028(USD and AED supported)"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s84"
                              >
                                First virtual card free, additional cards $1
                                each
                              </p>
                            </div>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-10qi5iq accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-mbdmn9 hidden-ix61hb hidden-1fi46e6"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-1tntart accounts-s23 reveal reveal-fast"
                            data-framer-name="Receive third-party transfers \u2028(USD and AED supported)"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s84">
                              Receive third-party transfers{' '}
                              <br className="framer-text" />
                              (USD and AED supported)
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1wi3xzq accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="framer-hgnpum hidden-1fi46e6">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-ykum2v accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u">
                            <div
                              className="framer-f5r2d4 accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s84"
                              >
                                First virtual card free, additional cards $1
                                <br className="framer-text" />
                                each
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                            <div
                              className="framer-f5r2d4 accounts-s23 reveal reveal-fast"
                              data-framer-name="First virtual card free, additional cards $1 each\u2028"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Convert currencies instantly within the app
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1oe53bz"
                            data-framer-name="List Item"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-7zel67"
                  data-border="true"
                  data-framer-name="Frame 1707479949"
                >
                  <div
                    className="framer-gdsvf0"
                    data-framer-name="Frame 1707479992"
                  >
                    <div
                      className="framer-17g532w"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-4qflmf accounts-s23 reveal"
                        data-framer-name="Admiral"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s76">
                          Admiral
                        </p>
                      </div>
                      <div
                        className="framer-qrt6gc accounts-s40 reveal"
                        data-framer-name="High volume / business / serious usage"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s77">
                          High volume / business / serious usage
                        </p>
                      </div>
                    </div>
                    <div className="framer-tswnc6" data-framer-name="Container">
                      <div
                        className="framer-wn158q"
                        data-framer-name="Frame 1707479947"
                      >
                        <div
                          className="framer-175jwkx accounts-s23 reveal"
                          data-framer-name="A free entry-level tier designed for users who wan"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s42">
                            Built for high-volume usage, businesses, and
                            advanced operations
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-bb5fzo"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-fkhcg6"
                          data-framer-name="Text"
                        />
                        <div
                          className="framer-b1a89l accounts-s40 reveal"
                          data-framer-name="Best for:"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s78">
                            Best for:
                          </p>
                        </div>
                        <div
                          className="framer-1akle9k accounts-s23 reveal"
                          data-framer-name="Individuals managing their own money across curren"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s79">
                            Businesses, institutions, and high-volume users
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-d2yu2k" data-framer-name="Container">
                    <div
                      className="framer-csp9dk accounts-s23 reveal"
                      data-framer-name="(Per month)"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s57">
                        (Per month)
                      </p>
                    </div>
                    <div
                      className="framer-1ta50aj accounts-s62 reveal"
                      data-framer-name="$49.99"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s80">
                        $49.99
                      </p>
                    </div>
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Icon"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-hgofkd accounts-s26 reveal reveal-fast"
                      aria-hidden="true"
                    >
                      <div className="svgContainer accounts-s27">
                        <svg viewBox="0 0 17 17" className="accounts-s28">
                          <use href="#svg-1398115612_791" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u">
                    {/*$*/}
                    <a
                      className="framer-kqlcyx framer-1twpk0x"
                      data-border="true"
                      data-framer-name="Button"
                      id="kqlcyx"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-4azs1r accounts-s51 reveal"
                        data-framer-name="Get Started with Admiral"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s81">
                          Get Started with Admiral
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    {/*$*/}
                    <a
                      className="framer-kqlcyx framer-1twpk0x"
                      data-border="true"
                      data-framer-name="Button"
                      id="kqlcyx"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-4azs1r accounts-s51 reveal"
                        data-framer-name="Get Started with Admiral"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s81">
                          Get Started with Admiral
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div className="framer-stzxus" data-framer-name="Container">
                    <div
                      className="framer-1bt79va"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-jpawwn accounts-s40 reveal"
                        data-framer-name="Pricing & Limits"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s82">
                          Pricing &amp; Limits
                        </p>
                      </div>
                      <div className="framer-1ub03d4" data-framer-name="List">
                        <div
                          className="framer-1ahehnc"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-1np9lpo accounts-s23 reveal"
                            data-framer-name="Swap fee"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Swap fee
                            </p>
                          </div>
                          <div
                            className="framer-1e35eo accounts-s23 reveal"
                            data-framer-name="0.40%"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s88">
                              0.40%
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-wnrbp5"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-30kdex accounts-s23 reveal"
                            data-framer-name="Virtual cards"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Virtual cards
                            </p>
                          </div>
                          <div
                            className="framer-i7lsre accounts-s23 reveal"
                            data-framer-name="Multiple free"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s83">
                              Multiple free
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-18cet51"
                          data-border="true"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-1cd1izr accounts-s23 reveal"
                            data-framer-name="Yield"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Yield
                            </p>
                          </div>
                          <div
                            className="framer-1n8advq accounts-s23 reveal"
                            data-framer-name="Coming Soon"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s88">
                              Coming Soon
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1a22x0f" data-framer-name="List">
                      <div
                        className="framer-1573r7u"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-at3jrq"
                          data-framer-name="Paragraph"
                        >
                          <div
                            className="framer-1j5kclc accounts-s40 reveal"
                            data-framer-name="Supported currencies :"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s44">
                              Supported currencies
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1lps4p9"
                          data-framer-name="Frame 1707479829"
                        >
                          <div
                            className="framer-1meqsaf"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-1y23vxo"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-63eloa"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Clip path group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-n4d897 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg2010212194_9010" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-ecw0ru"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-1r3su84"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-jnps2b"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1shk60h accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-77748519_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1if6exy accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg2125279330_305" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-2li8g5 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg994370299_368" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1dq377e accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1148296261_203" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-8o8tr0 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-29915228_203" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1v9oia5"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-17y4fpm"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-1boudmz"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-uoqij2 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg49011196_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-parf3d accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 25 24"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-983728359_11122" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1n225xs"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-dunu83"
                              data-framer-name="Group circle"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Oval"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-1wbjn54 accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 35 35"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1761932441_338" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-1lrrp0j accounts-s23 reveal"
                                data-framer-name="FL"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s45"
                                >
                                  49+
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1vwhf2z"
                        data-framer-name="Container"
                      >
                        <div
                          className="framer-df1pri"
                          data-framer-name="Paragraph"
                        >
                          <div
                            className="framer-1nb5gf4 accounts-s40 reveal"
                            data-framer-name="Payout (fiat currencies) corridors:"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s44">
                              Fiat payout corridors
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-wo27n2"
                          data-framer-name="Frame 1707479828"
                        >
                          <div
                            className="framer-1pvjgpj"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-1j3j0rp"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-jtq8cr"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Clip path group"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-98t5qd accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1642732060_9010" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-aoos07"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-13f6okj"
                              data-framer-name="Mask"
                            >
                              <div
                                className="framer-59nfe7"
                                data-framer-name="Countries"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1ynye7q accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-77748519_156" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-8aajir accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg2125279330_305" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-wbfoky accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg994370299_368" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1rkhxvi accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-1148296261_203" />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-nt0xj4 accounts-s26"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer accounts-s27">
                                    <svg
                                      viewBox="0 0 47 35"
                                      className="accounts-s28"
                                    >
                                      <use href="#svg-29915228_203" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1amp9h8"
                            data-framer-name="Avatar"
                          >
                            <div
                              className="framer-l1mwch"
                              data-framer-name="Group circle"
                            >
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Oval"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-29sj80 accounts-s26"
                                aria-hidden="true"
                              >
                                <div className="svgContainer accounts-s27">
                                  <svg
                                    viewBox="0 0 35 35"
                                    className="accounts-s28"
                                  >
                                    <use href="#svg-1761932441_338" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className="framer-fi720e accounts-s23 reveal"
                                data-framer-name="FL"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text accounts-s45"
                                >
                                  50+
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-i2vx2f" data-framer-name="Container">
                      <div
                        className="framer-46ws4"
                        data-framer-name="Heading 4"
                      >
                        <div
                          className="framer-v7x4qk accounts-s40 reveal"
                          data-framer-name="What you can do"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s82">
                            What you can do
                          </p>
                        </div>
                      </div>
                      <div className="framer-knqym8" data-framer-name="List">
                        <div
                          className="framer-bcdx20"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-2hjdxm accounts-s23 reveal reveal-fast"
                            data-framer-name="Full access to all supported currencies and corridors"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Full access to all supported currencies and
                              corridors
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1f1zy3a accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1kvy8ni"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-1ke9r2p accounts-s23 reveal reveal-fast"
                            data-framer-name="Priority payout routes and advanced banking features"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s84">
                              Priority payout routes and advanced banking
                              features
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-13occor accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-cji9d6"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-2aqion accounts-s23 reveal reveal-fast"
                            data-framer-name="Issue and manage multiple virtual cards at no cost"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Issue and manage multiple virtual cards at no cost
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-9y6ovn accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="framer-a322mf">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-5zvir4 accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-ewvcc1 accounts-s23 reveal reveal-fast"
                            data-framer-name="First virtual card free, additional cards $1 each\u2028"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Access the lowest fees across the platform
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1gxhtvj hidden-ms262u"
                          data-framer-name="List Item"
                        >
                          <div className="ssr-variant hidden-1fi46e6">
                            <div
                              className="framer-2ypx9o accounts-s23 reveal reveal-fast"
                              data-framer-name="Optimized for high balances and transaction volumes"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Optimized for high balances and transaction
                                volumes
                              </p>
                            </div>
                          </div>
                          <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                            <div
                              className="framer-2ypx9o accounts-s23 reveal reveal-fast"
                              data-framer-name="Optimized for high balances and transaction volumes"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s57"
                              >
                                Access the lowest fees across the platform
                              </p>
                            </div>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1kpszns accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-6g1w77 hidden-ix61hb"
                          data-framer-name="List Item"
                        >
                          <div
                            className="framer-8q91c6 accounts-s23 reveal reveal-fast"
                            data-framer-name="Optimized for high balances and transaction volumes"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s57">
                              Optimized for high balances and transaction
                              volumes
                            </p>
                          </div>
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="check"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-zzllvh accounts-s26 reveal reveal-fast"
                            aria-hidden="true"
                          >
                            <div className="svgContainer accounts-s27">
                              <svg viewBox="0 0 18 18" className="accounts-s28">
                                <use href="#svg-1847215915_356" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-rk4r6" data-framer-name="Security">
              <div className="framer-nqa22w">
                <div className="framer-oif93r" data-framer-name="Container">
                  <div className="ssr-variant">
                    <div
                      className="framer-6xm6yb"
                      data-framer-name="image 1512"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="2436"
                          height="2016"
                          sizes="(min-width: 1440px) 699px, (min-width: 810px) and (max-width: 1439.98px) 699px, (max-width: 809.98px) calc(100vw + 73px)"
                          srcSet="/framerusercontent.com/images/H8Lhg3UiHA9XbZ9ixZY5UsTuIQY.png 512w,/framerusercontent.com/images/H8Lhg3UiHA9XbZ9ixZY5UsTuIQY.png 1024w,/framerusercontent.com/images/H8Lhg3UiHA9XbZ9ixZY5UsTuIQY.png 2048w,/framerusercontent.com/images/H8Lhg3UiHA9XbZ9ixZY5UsTuIQY.png 2436w"
                          src="/framerusercontent.com/images/H8Lhg3UiHA9XbZ9ixZY5UsTuIQY.png"
                          alt=""
                          className="accounts-s38"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-107qwxa">
                  <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                    <div
                      className="framer-11s54zp accounts-s23 reveal"
                      data-framer-name="You Control your money always"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s90">
                        You Control your money always
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                    <div
                      className="framer-11s54zp accounts-s23 reveal"
                      data-framer-name="You Control your money always"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s91">
                        You Control your money always
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                    <div
                      className="framer-11s54zp accounts-s23 reveal"
                      data-framer-name="You Control your money always"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s92">
                        You Control your money always
                      </p>
                    </div>
                  </div>
                  <div className="framer-2ad0v0" data-framer-name="Container">
                    <div className="framer-hdfbrr" data-framer-name="Container">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Container"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1113zyg accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 48 48" className="accounts-s28">
                            <use href="#svg1549100418_2533" />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="framer-1f4wmzs"
                        data-framer-name="Frame 1707479929"
                      >
                        <div
                          className="framer-oam4n6 accounts-s40 reveal"
                          data-framer-name="Biometric login"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s78">
                            Biometric login
                          </p>
                        </div>
                        <div
                          className="framer-16llp07 accounts-s23 reveal"
                          data-framer-name="No one accesses your account without you."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s64">
                            Your account stays protected with biometric login
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1mtbjlj"
                      data-framer-name="Container"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Container"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-z0lids accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 48 48" className="accounts-s28">
                            <use href="#svg-1084040545_1930" />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="framer-1xhdcrw"
                        data-framer-name="Frame 1707479929"
                      >
                        <div
                          className="framer-86ndc accounts-s40 reveal"
                          data-framer-name="Real-time alerts"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s78">
                            Real-time alerts
                          </p>
                        </div>
                        <div className="ssr-variant hidden-ms262u">
                          <div
                            className="framer-149b0k2 accounts-s23 reveal"
                            data-framer-name="Every transaction, instantly visible."
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s64">
                              Every transaction, instantly visible
                            </p>
                          </div>
                        </div>
                        <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                          <div
                            className="framer-149b0k2 accounts-s23 reveal"
                            data-framer-name="Every transaction, instantly visible."
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text accounts-s64">
                              Every transaction, instantly
                              <br className="framer-text" />
                              visible.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-12pcwvb"
                      data-framer-name="Container"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Container"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1rm4qpo accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 48 48" className="accounts-s28">
                            <use href="#svg111317355_1819" />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="framer-jursd1"
                        data-framer-name="Frame 1707479929"
                      >
                        <div
                          className="framer-dv2e39 accounts-s40 reveal"
                          data-framer-name="Instant card control"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s78">
                            Instant card control
                          </p>
                        </div>
                        <div
                          className="framer-10gsisb accounts-s23 reveal"
                          data-framer-name="Freeze or manage your card in seconds."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s64">
                            Freeze or manage your card in seconds
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1fi46e6">
              <section
                className="framer-13o220f hidden-ms262u"
                data-framer-name="Content \xB7 3"
              >
                <div className="framer-keluu0" data-framer-name="Container">
                  <div className="framer-1yusg6a" data-framer-name="Content">
                    <div className="framer-1kiun6a">
                      <div className="framer-fn3n1d" data-framer-name="Text">
                        <div
                          className="framer-12r4hex accounts-s40 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s77">
                            FOR COMPANIES
                          </p>
                        </div>
                        <div
                          className="framer-1g8ofli"
                          data-framer-name="Content"
                        >
                          <div className="framer-40i6ux">
                            <div
                              className="framer-qq4dkn accounts-s23 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h3
                                dir="auto"
                                className="framer-text accounts-s90"
                              >
                                YOUR BUSINESS.
                              </h3>
                              <h3
                                dir="auto"
                                className="framer-text accounts-s90"
                              >
                                SAME ACCOUNT.
                              </h3>
                            </div>
                            <div
                              className="framer-j1icaj accounts-s23 reveal"
                              data-framer-name="A free entry-level tier designed for users who wan"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s42"
                              >
                                Open a multi-currency account in your
                                company&apos;s name, same platform, same
                                currencies, same rates. Verified via KYB, not
                                KYC.
                              </p>
                            </div>
                          </div>
                          <div className="framer-1thicib">
                            <div className="framer-ha22rr-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Account in your company&apos;s legal name
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-ltex6f-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Hold, send, receive &amp; convert in 52+
                                    currencies
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-bcexnt-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Same infrastructure. Same pricing as
                                    Admiral.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*$*/}
                      <a
                        className="framer-k5pv3p framer-1twpk0x"
                        data-framer-name="Button"
                        href="https://docs.scallopx.com/details/requirements-for-businesses"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          className="framer-tmdvtn accounts-s23 reveal"
                          data-framer-name="Get Started with Mariner"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s87">
                            Explore Scallop Business
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    <div className="framer-sjjgz8" data-framer-name="Image">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          width="1455"
                          height="1455"
                          sizes="(min-width: 1440px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), 100vw), (max-width: 809.98px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), min(100vw - 32px, 1280px)), (min-width: 810px) and (max-width: 1439.98px) max(max((min(100vw - 64px, 1280px) - 32px) / 2, 1px), 100vw)"
                          srcSet="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 512w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1024w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1455w"
                          src="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="ssr-variant hidden-ms262u hidden-ix61hb">
              <section
                className="framer-13o220f hidden-ms262u"
                data-framer-name="Tablet"
              >
                <div className="framer-keluu0" data-framer-name="Container">
                  <div className="framer-1yusg6a" data-framer-name="Content">
                    <div className="framer-1kiun6a">
                      <div className="framer-fn3n1d" data-framer-name="Text">
                        <div
                          className="framer-12r4hex accounts-s40 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-4v41ce accounts-s31"
                            data-styles-preset="uKHXEJe7O"
                            dir="auto"
                          >
                            FOR COMPANIES
                          </p>
                        </div>
                        <div
                          className="framer-1g8ofli"
                          data-framer-name="Content"
                        >
                          <div className="framer-40i6ux">
                            <div
                              className="framer-qq4dkn accounts-s23 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h3
                                dir="auto"
                                className="framer-text accounts-s96"
                              >
                                YOUR BUSINESS.
                              </h3>
                              <h3
                                dir="auto"
                                className="framer-text accounts-s96"
                              >
                                SAME ACCOUNT.
                              </h3>
                            </div>
                            <div
                              className="framer-j1icaj accounts-s23 reveal"
                              data-framer-name="A free entry-level tier designed for users who wan"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s42"
                              >
                                Open a multi-currency account in your
                                company&apos;s name, same platform, same
                                currencies, same rates. Verified via KYB, not
                                KYC.
                              </p>
                            </div>
                          </div>
                          <div className="framer-1thicib">
                            <div className="framer-ha22rr-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Account in your company&apos;s legal name
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-ltex6f-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Hold, send, receive &amp; convert in 52+
                                    currencies
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-bcexnt-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Same infrastructure. Same pricing as
                                    Admiral.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*$*/}
                      <a
                        className="framer-k5pv3p framer-1twpk0x"
                        data-framer-name="Button"
                        href="https://docs.scallopx.com/details/requirements-for-businesses"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          className="framer-tmdvtn accounts-s23 reveal"
                          data-framer-name="Get Started with Mariner"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s87">
                            Explore Scallop Business
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    <div className="framer-sjjgz8" data-framer-name="Image">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          width="1455"
                          height="1455"
                          sizes="(min-width: 1440px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), 100vw), (max-width: 809.98px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), min(100vw - 32px, 1280px)), (min-width: 810px) and (max-width: 1439.98px) max(max((min(100vw - 64px, 1280px) - 32px) / 2, 1px), 100vw)"
                          srcSet="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 512w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1024w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1455w"
                          src="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="ssr-variant hidden-ms262u">
              <section
                className="framer-9r9p1i hidden-ix61hb hidden-1fi46e6"
                data-framer-name="Content \xB7 3"
              >
                <div className="framer-1e8woad" data-framer-name="Container">
                  <div className="framer-1eyyp10" data-framer-name="Content">
                    {/*$*/}
                    <a
                      className="framer-1h61cjd framer-1twpk0x"
                      data-framer-name="Button"
                      href="https://docs.scallopx.com/details/requirements-for-businesses"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-xghfh5 accounts-s23 reveal"
                        data-framer-name="Get Started with Mariner"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s87">
                          Explore Scallop Business
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                    <div className="framer-u937x0">
                      <div className="framer-1icb12r" data-framer-name="Text">
                        <div
                          className="framer-14th27x accounts-s40 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s77">
                            FOR COMPANIES
                          </p>
                        </div>
                        <div
                          className="framer-ijzs6i"
                          data-framer-name="Content"
                        >
                          <div className="framer-1a8no8k">
                            <div
                              className="framer-p7eika accounts-s23 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h3
                                dir="auto"
                                className="framer-text accounts-s90"
                              >
                                YOUR BUSINESS.
                              </h3>
                              <h3
                                dir="auto"
                                className="framer-text accounts-s90"
                              >
                                SAME ACCOUNT.
                              </h3>
                            </div>
                            <div
                              className="framer-131y34z accounts-s23 reveal"
                              data-framer-name="A free entry-level tier designed for users who wan"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s42"
                              >
                                Open a multi-currency account in your
                                company&apos;s name - same platform, same
                                currencies, same rates. Verified via KYB, not
                                KYC.
                              </p>
                            </div>
                          </div>
                          <div className="framer-1ko6f3q">
                            <div className="framer-163iv7-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Account in your company&apos;s legal name
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-cph44u-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Hold, send, receive &amp; convert in 52+
                                    currencies
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-1g27qcy-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Same infrastructure. Same pricing as
                                    Admiral.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="framer-129aawn" data-framer-name="Image">
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            width="1455"
                            height="1455"
                            srcSet="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 512w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1024w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1455w"
                            src="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png"
                            alt=""
                            sizes="(min-width: 1440px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), 100vw), (max-width: 809.98px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), min(100vw - 32px, 1280px)), (min-width: 810px) and (max-width: 1439.98px) max(max((min(100vw - 64px, 1280px) - 32px) / 2, 1px), 100vw)"
                            className="accounts-s97"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
              <section
                className="framer-9r9p1i hidden-ix61hb hidden-1fi46e6"
                data-framer-name="Phone"
              >
                <div className="framer-1e8woad" data-framer-name="Container">
                  <div className="framer-1eyyp10" data-framer-name="Content">
                    {/*$*/}
                    <a
                      className="framer-1h61cjd framer-1twpk0x"
                      data-framer-name="Button"
                      href="https://docs.scallopx.com/details/requirements-for-businesses"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-xghfh5 accounts-s23 reveal"
                        data-framer-name="Get Started with Mariner"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text accounts-s87">
                          Explore Scallop Business
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                    <div className="framer-u937x0">
                      <div className="framer-1icb12r" data-framer-name="Text">
                        <div
                          className="framer-14th27x accounts-s40 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-4v41ce accounts-s31"
                            data-styles-preset="uKHXEJe7O"
                            dir="auto"
                          >
                            FOR COMPANIES
                          </p>
                        </div>
                        <div
                          className="framer-ijzs6i"
                          data-framer-name="Content"
                        >
                          <div className="framer-1a8no8k">
                            <div
                              className="framer-p7eika accounts-s23 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h3
                                dir="auto"
                                className="framer-text accounts-s98"
                              >
                                YOUR BUSINESS.
                              </h3>
                              <h3
                                dir="auto"
                                className="framer-text accounts-s98"
                              >
                                SAME ACCOUNT.
                              </h3>
                            </div>
                            <div
                              className="framer-131y34z accounts-s23 reveal"
                              data-framer-name="A free entry-level tier designed for users who wan"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text accounts-s42"
                              >
                                Open a multi-currency account in your
                                company&apos;s name - same platform, same
                                currencies, same rates. Verified via KYB, not
                                KYC.
                              </p>
                            </div>
                          </div>
                          <div className="framer-1ko6f3q">
                            <div className="framer-163iv7-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Account in your company&apos;s legal name
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-cph44u-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Hold, send, receive &amp; convert in 52+
                                    currencies
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-1g27qcy-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx accounts-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc accounts-s93 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer accounts-s27">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="accounts-s28"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz accounts-s94 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text accounts-s95"
                                  >
                                    Same infrastructure. Same pricing as
                                    Admiral.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="framer-129aawn" data-framer-name="Image">
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            width="1455"
                            height="1455"
                            sizes="(min-width: 1440px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), 100vw), (max-width: 809.98px) max(max((min(100vw - 96px, 1280px) - 32px) / 2, 1px), min(100vw - 32px, 1280px)), (min-width: 810px) and (max-width: 1439.98px) max(max((min(100vw - 64px, 1280px) - 32px) / 2, 1px), 100vw)"
                            srcSet="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 512w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1024w,/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png 1455w"
                            src="/framerusercontent.com/images/iGCFyF0eC2VvrooEyZ4nVuoAsA.png"
                            alt=""
                            className="accounts-s54"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="framer-1r95nv4" data-framer-name="c2a">
              <div className="framer-ap5wrk">
                <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
                  <div
                    className="framer-ucdxvq accounts-s29 reveal"
                    data-framer-name="Your global account is ready"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s66">
                      Your global{' '}
                    </p>
                    <p dir="auto" className="framer-text accounts-s66">
                      account is ready
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div
                    className="framer-ucdxvq accounts-s29 reveal"
                    data-framer-name="Your global account is ready"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s67">
                      Your global{' '}
                    </p>
                    <p dir="auto" className="framer-text accounts-s67">
                      account is ready
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                  <div
                    className="framer-ucdxvq accounts-s29 reveal"
                    data-framer-name="Your global account is ready"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s99">
                      Your global{' '}
                    </p>
                    <p dir="auto" className="framer-text accounts-s99">
                      account is ready
                    </p>
                  </div>
                </div>
                <div
                  className="framer-ifd4jo accounts-s40 reveal"
                  data-framer-name="One balance. 52+ currencies. Fiat and digital asse"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text accounts-s100">
                    One balance. 52+ currencies. Fiat and digital assets. Start
                    now.
                  </p>
                </div>
                <div className="framer-1xwbkro" data-framer-name="Paragraph">
                  <div className="ssr-variant hidden-1fi46e6">
                    <div
                      className="framer-bdb7ol accounts-s40 reveal"
                      data-framer-name="Start using your account in minutes"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s101">
                        Start using your account in minutes
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-ms262u hidden-ix61hb">
                    <div
                      className="framer-bdb7ol accounts-s71 reveal"
                      data-framer-name="Start using your account in minutes"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s101">
                        Start using your account in minutes
                      </p>
                    </div>
                  </div>
                </div>
                <div className="framer-pjg7cm" data-framer-appear-id="pjg7cm">
                  {/*$*/}
                  <a
                    className="framer-uikbmu framer-1twpk0x"
                    data-framer-name="Appstore"
                    href="https://apps.apple.com/app/scallop/id6746711366"
                    target="_blank"
                    rel="noopener"
                  >
                    <div
                      data-framer-component-type="SVG"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1nqm5l5 accounts-s35"
                      aria-hidden="true"
                    >
                      <div className="svgContainer accounts-s27">
                        <svg className="accounts-s36">
                          <use href="#svg1322499166_10645" />
                        </svg>
                      </div>
                    </div>
                  </a>
                  {/*/$*/}
                  {/*$*/}
                  <a
                    className="framer-6nau3f framer-1twpk0x"
                    data-framer-name="Playstore"
                    href="https://play.google.com/store/apps/details?id=com.app.scallop"
                    target="_blank"
                    rel="noopener"
                  >
                    <div
                      data-framer-component-type="SVG"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1adorqn accounts-s35"
                      aria-hidden="true"
                    >
                      <div className="svgContainer accounts-s27">
                        <svg className="accounts-s36">
                          <use href="#svg-412316951_7924" />
                        </svg>
                      </div>
                    </div>
                  </a>
                  {/*/$*/}
                </div>
              </div>
            </div>
            <div className="framer-7mkk9k" data-framer-name="Send Money">
              <div className="framer-fya9nx" data-framer-name="Country content">
                <div className="ssr-variant hidden-ms262u">
                  <div
                    className="framer-156u1kx accounts-s23 reveal"
                    data-framer-name="Section title"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s102">
                      Send Money Abroad with Scallop
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
                  <div
                    className="framer-156u1kx accounts-s23 reveal"
                    data-framer-name="Section title"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text accounts-s98">
                      Send Money Abroad with Scallop
                    </p>
                  </div>
                </div>
                <div className="framer-napj37" data-framer-name="Country grid">
                  <div
                    className="framer-1knl73i"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-lmq0gt">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="54"
                          height="54"
                          src="/framerusercontent.com/images/H9OEQ1mKEc0OMKgpdFTVurZm8.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-vvynt7 accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-nigeria-with-scallop-%f0%9f%87%b3%f0%9f%87%ac/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Nigeria
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-a1neem"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-xgmgi1">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/fF2xoDbCYrcjk6T6nRs9kdA9jw.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-714viu accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-vietnam-with-scallop-%f0%9f%87%bb%f0%9f%87%b3/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Vietnam
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-c99yqz"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1h789bv">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/9V49O3RY5argijn9BrUn98Ao.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1pp7wps accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-the-united-kingdom-with-scallop%f0%9f%87%ac%f0%9f%87%a7/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to the United Kingdom
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-9n41dt"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-16b58gh">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/z4K3BkkqKntJGPcLeiWqWSks.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-axqubc accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-spain-with-scallop-%f0%9f%87%aa%f0%9f%87%b8/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Spain
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-1aqm4wo"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1csltjr">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/R4reWXSjSIlwhnueBcVu7bKqDlw.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-15z98zm accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-poland-with-scallop%f0%9f%87%b5%f0%9f%87%b1/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Poland
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-1l8et3l"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-qqa2cx">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/f0pEAIz8CyXt7B2qIZ1EJ6hP2I.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1i4jl95 accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-north-macedonia-with-scallop-%f0%9f%87%b2%f0%9f%87%b0/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to North Macedonia
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-6s1fjs"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-n67muj">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/87Yq1nvY2hYSCihY8yIrDJb1zbU.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-ua8bgh accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-ghana-with-scallop-%f0%9f%87%ac%f0%9f%87%ad/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Ghana
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-ru3key"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-byysig">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/XlUjavCuwjXPAARSAHg0TgMPeYQ.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-13v0rn2 accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-the-philippines-with-scallop%f0%9f%87%b5%f0%9f%87%ad/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to the Philippines
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-1wrvvd6"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-enhr1n">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/1cA1R9kEvXCP0rPDvqvjk5JQzvw.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1kpaill accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-saudi-arabia-with-scallop%f0%9f%87%b8%f0%9f%87%a6/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Saudi Arabia
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-uz8td9"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-9btjwh">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/BPGJnoUUzFxDdAhwvRoklt4FE.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-ydpavc accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-kazakhstan-with-scallop-%f0%9f%87%b0%f0%9f%87%bf/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Kazakhstan
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-1oklzyn"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-kotlt">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/FS2aYidfUvtOMyH4gzaPy8iovKM.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1m9h2ck accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-india-with-scallop%f0%9f%87%ae%f0%9f%87%b3/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to India
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-3conpk"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-wvrng5">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/u1jCE0YdocarRBjOPssyIqdg90.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-18bx2yc accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-the-united-states-with-scallop-%f0%9f%87%ba%f0%9f%87%b8/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to the United States
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-1xngw5y"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-186cprk">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/2rhXPobnsZO8SenmplDKQkY1W0.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-3nl5rw accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-mexico-with-scallop%f0%9f%87%b2%f0%9f%87%bd/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Mexico
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-11980mj"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1b9gog5">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/0OV7TNkJYuFVmrJHzI16KMUq50.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-s54z59 accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-dubai-the-uae-with-scallop-%f0%9f%87%a6%f0%9f%87%aa/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Dubai &amp; the UAE
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-3bdbiu"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-u38jzx">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/hEDwlKPYtskg0EOrDqcZzQzEmE.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-g982pw accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-brazil-with-scallop-%f0%9f%87%a7%f0%9f%87%b7/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Brazil
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-136pqed"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-126pdqd">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/AYce7yXLuipEEZX4VBEWf8es.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-6q1c73 accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-peru-with-scallop-%f0%9f%87%b5%f0%9f%87%aa/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Peru
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-rb3occ"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-yvapq4">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/pvImMXWFzozZo8V0AlhN7y0iQ.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-ze1ba accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-turkey-with-scallop%f0%9f%87%b9%f0%9f%87%b7/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Turkey
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-sgv4n4"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1cx17df">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/nnaZvFCFOs6OtEAXiJBA75QZhg.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1i312u7 accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-indonesia-with-scallop%f0%9f%87%ae%f0%9f%87%a9/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Indonesia
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-6vk4wm"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1ffiajh">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/EoyE8BiVLiNhFGcwDTENvpM54.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-sryrd7 accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-thailand-with-scallop-%f0%9f%87%b9%f0%9f%87%ad/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Thailand
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-be2eyl"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1uum56n">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/y1MptPLQoLkDmGFQNN1AoCMS8.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-726y0p accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-sri-lanka-with-scallop%f0%9f%87%b1%f0%9f%87%b0/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Sri Lanka
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-18982xk"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1a8ryn1">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/oocxMNYprfNdjR4WORojATqxM4.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-14np0fi accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-egypt-with-scallop-%f0%9f%87%aa%f0%9f%87%ac/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Egypt
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-9e3o08"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-12fibxu">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/Jw8oXBLDPWhicTB5Et9G3cB6qI.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-7vqfhf accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-kenya-with-scallop%f0%9f%87%b0%f0%9f%87%aa/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Kenya
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-i5z48d"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1yn654">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/LHV96CkCr3rDmSIAEHsD5j73o.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-10qz01n accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-morocco-with-scallop-%f0%9f%87%b2%f0%9f%87%a6/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Morocco
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-vqz58"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-iw2mot">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/05LeRiyQplp5I5UkCZNouhWrySg.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1ngve1f accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-colombia-with-scallop-%f0%9f%87%a8%f0%9f%87%b4/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to Colombia
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-13iosvt"
                    data-framer-name="Country item / Andorra"
                  >
                    <div className="framer-1ga5f3s">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="accounts-s37"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="120"
                          height="120"
                          src="/framerusercontent.com/images/wmgDsa5lRuPMkpObBBIJbjV7svE.png"
                          alt=""
                          className="accounts-s54"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1sts8gb accounts-s40 reveal"
                      data-framer-name="Send money to Andorra"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text accounts-s55">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://blog.scallopx.com/send-money-to-south-africa-with-scallop-%f0%9f%87%bf%f0%9f%87%a6/"
                          target="_blank"
                          rel="noopener"
                        >
                          Send Money to South Africa
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-ms262u hidden-1fi46e6">
              <div className="framer-fcvf4v-container">
                <div
                  className="framer-60Kb5 framer-1rilglu framer-v-1rilglu accounts-s103"
                  data-framer-name="Desktop"
                >
                  <div
                    className="framer-14npji9"
                    data-framer-name="Frame 33595"
                  >
                    <div className="framer-1nbyyte">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1ick3k6 accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 699 196" className="accounts-s28">
                            <use href="#svg-1137231340_6119" />
                          </svg>
                        </div>
                      </div>
                      <div className="framer-6st60f">
                        <div
                          className="framer-9nwe5k accounts-s104 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s105">
                            <strong className="framer-text">
                              One account for all your currencies{' '}
                              <br className="framer-text" />
                            </strong>
                            Manage, send, and receive money globally
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1d0k7xa"
                        data-framer-name="ICO Logo_Blue"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            width="1440"
                            height="1440"
                            sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                            srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                            src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                            alt=""
                            className="accounts-s54"
                          />
                        </div>
                      </div>
                      <div className="scallop-compliance-note">
                        <p>
                          This website is managed by Scallop Pvt Limited, Sri Lanka.
                          <br />
                          Scallop does not provide services in the countries listed on
                          its{' '}
                          <a
                            href="https://docs.scallopx.com/details/onboarding-regions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Prohibited Countries list
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-c50yne"
                      data-framer-name="Frame 33594"
                    >
                      <div className="framer-5dec6k" data-framer-name="Menu">
                        <div
                          className="framer-nmphiu accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Programs
                          </p>
                        </div>
                        <div className="framer-1odpfed" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1tz9h0j-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/ambassador"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/ambassador"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Ambassador
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                      <div className="framer-a8htgk" data-framer-name="Menu">
                        <div
                          className="framer-1rugbzn accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Products
                          </p>
                        </div>
                        <div className="framer-1oe4fxe" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-153yqwe-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/accounts"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/accounts"
                                    data-framer-page-link-current="true"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Accounts
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1di1zw4-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/cards"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/cards"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Cards
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-165n05h-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-pay"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-pay"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Pay
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1ddhrxh-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-plus"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-plus"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Plus
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-nsl31k-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://blog.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://blog.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Blogs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                      <div className="framer-bcfdyi" data-framer-name="Menu">
                        <div
                          className="framer-cv5tks accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Support
                          </p>
                        </div>
                        <div className="framer-16j5a70" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1apiy1v-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/support"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/support"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Contact Us
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-650678-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/helpcenter"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/helpcenter"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    FAQs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-1935128-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://docs.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://docs.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Docs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1l4w042"
                    data-framer-name="Frame 33831"
                  >
                    <div className="framer-jk8g5w" data-framer-name="Link">
                      <div className="framer-80yh0c">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="ic:baseline-copyright"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-m3skko accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 20 20" className="accounts-s28">
                              <use href="#svg-1839680863_948" />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="framer-hv1cvb accounts-s109 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s110">
                            2026 Scallop Group. All rights reserved.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c28m8b">
                      {/*$*/}
                      <a
                        data-framer-component-type="SVG"
                        as="a"
                        data-framer-name="X"
                        href="https://x.com/Scallopcom"
                        target="_blank"
                        rel="noopener"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-dziac9 framer-1d3y7cu accounts-s111"
                        aria-hidden="true"
                      />
                      {/*/$*/}
                      {/*$*/}
                      <a
                        className="framer-n9nhin framer-1d3y7cu"
                        data-framer-name="LinkdIn"
                        href="https://www.linkedin.com/company/scallopcom"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="linkd"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ggemab accounts-s112"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1fi46e6 hidden-ix61hb">
              <div className="framer-fcvf4v-container">
                <div
                  className="framer-60Kb5 framer-1rilglu framer-v-ltf6f8 accounts-s103"
                  data-framer-name="Mobile"
                >
                  <div
                    className="framer-14npji9"
                    data-framer-name="Frame 33595"
                  >
                    <div className="framer-1nbyyte">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1ick3k6 accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 699 196" className="accounts-s28">
                            <use href="#svg-1137231340_6119" />
                          </svg>
                        </div>
                      </div>
                      <div className="framer-6st60f">
                        <div
                          className="framer-9nwe5k accounts-s104 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s105">
                            <strong className="framer-text">
                              One account for all your currencies{' '}
                              <br className="framer-text" />
                            </strong>
                            Manage, send, and receive money globally
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1d0k7xa"
                        data-framer-name="ICO Logo_Blue"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            width="1440"
                            height="1440"
                            sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                            srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                            src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                            alt=""
                            className="accounts-s54"
                          />
                        </div>
                      </div>
                      <div className="scallop-compliance-note">
                        <p>
                          This website is managed by Scallop Pvt Limited, Sri Lanka.
                          <br />
                          Scallop does not provide services in the countries listed on
                          its{' '}
                          <a
                            href="https://docs.scallopx.com/details/onboarding-regions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Prohibited Countries list
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-c50yne"
                      data-framer-name="Frame 33594"
                    >
                      <div className="framer-5dec6k" data-framer-name="Menu">
                        <div
                          className="framer-nmphiu accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Programs
                          </p>
                        </div>
                        <div className="framer-1odpfed" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1tz9h0j-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/ambassador"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/ambassador"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Ambassador
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                      <div className="framer-a8htgk" data-framer-name="Menu">
                        <div
                          className="framer-1rugbzn accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Products
                          </p>
                        </div>
                        <div className="framer-1oe4fxe" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-153yqwe-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/accounts"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/accounts"
                                    data-framer-page-link-current="true"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Accounts
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1di1zw4-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/cards"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/cards"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Cards
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-165n05h-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-pay"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-pay"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Pay
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1ddhrxh-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-plus"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-plus"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Plus
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-nsl31k-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://blog.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://blog.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Blogs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                      <div className="framer-bcfdyi" data-framer-name="Menu">
                        <div
                          className="framer-cv5tks accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Support
                          </p>
                        </div>
                        <div className="framer-16j5a70" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1apiy1v-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/support"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/support"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Contact Us
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-650678-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/helpcenter"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/helpcenter"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    FAQs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-1935128-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://docs.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://docs.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Docs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1l4w042"
                    data-framer-name="Frame 33831"
                  >
                    <div className="framer-jk8g5w" data-framer-name="Link">
                      <div className="framer-80yh0c">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="ic:baseline-copyright"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-m3skko accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 20 20" className="accounts-s28">
                              <use href="#svg-1839680863_948" />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="framer-hv1cvb accounts-s109 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s110">
                            2026 Scallop Group. All rights reserved.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c28m8b">
                      {/*$*/}
                      <a
                        data-framer-component-type="SVG"
                        as="a"
                        data-framer-name="X"
                        href="https://x.com/Scallopcom"
                        target="_blank"
                        rel="noopener"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-dziac9 framer-1d3y7cu accounts-s111"
                        aria-hidden="true"
                      />
                      {/*/$*/}
                      {/*$*/}
                      <a
                        className="framer-n9nhin framer-1d3y7cu"
                        data-framer-name="LinkdIn"
                        href="https://www.linkedin.com/company/scallopcom"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="linkd"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ggemab accounts-s112"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-ms262u hidden-ix61hb">
              <div className="framer-fcvf4v-container">
                <div
                  className="framer-60Kb5 framer-1rilglu framer-v-183e6ee accounts-s103"
                  data-framer-name="Tablet"
                >
                  <div
                    className="framer-14npji9"
                    data-framer-name="Frame 33595"
                  >
                    <div className="framer-1nbyyte">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1ick3k6 accounts-s26"
                        aria-hidden="true"
                      >
                        <div className="svgContainer accounts-s27">
                          <svg viewBox="0 0 699 196" className="accounts-s28">
                            <use href="#svg-1137231340_6119" />
                          </svg>
                        </div>
                      </div>
                      <div className="framer-6st60f">
                        <div
                          className="framer-9nwe5k accounts-s104 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s105">
                            <strong className="framer-text">
                              One account for all your currencies{' '}
                              <br className="framer-text" />
                            </strong>
                            Manage, send, and receive money globally
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1d0k7xa"
                        data-framer-name="ICO Logo_Blue"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="accounts-s37"
                        >
                          <img
                            decoding="async"
                            width="1440"
                            height="1440"
                            sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                            srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                            src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                            alt=""
                            className="accounts-s54"
                          />
                        </div>
                      </div>
                      <div className="scallop-compliance-note">
                        <p>
                          This website is managed by Scallop Pvt Limited, Sri Lanka.
                          <br />
                          Scallop does not provide services in the countries listed on
                          its{' '}
                          <a
                            href="https://docs.scallopx.com/details/onboarding-regions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Prohibited Countries list
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-c50yne"
                      data-framer-name="Frame 33594"
                    >
                      <div className="framer-5dec6k" data-framer-name="Menu">
                        <div
                          className="framer-nmphiu accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Programs
                          </p>
                        </div>
                        <div className="framer-1odpfed" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1tz9h0j-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/ambassador"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/ambassador"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Ambassador
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                      <div className="framer-a8htgk" data-framer-name="Menu">
                        <div
                          className="framer-1rugbzn accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Products
                          </p>
                        </div>
                        <div className="framer-1oe4fxe" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-153yqwe-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/accounts"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/accounts"
                                    data-framer-page-link-current="true"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Accounts
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1di1zw4-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/cards"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/cards"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Cards
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-165n05h-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-pay"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-pay"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Pay
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1ddhrxh-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-plus"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-plus"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Plus
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-nsl31k-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://blog.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://blog.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Blogs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                      <div className="framer-bcfdyi" data-framer-name="Menu">
                        <div
                          className="framer-cv5tks accounts-s106 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s107">
                            Support
                          </p>
                        </div>
                        <div className="framer-16j5a70" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1apiy1v-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/support"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/support"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Contact Us
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-650678-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/helpcenter"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/helpcenter"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    FAQs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-1935128-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://docs.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb accounts-s106 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text accounts-s108">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://docs.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Docs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1l4w042"
                    data-framer-name="Frame 33831"
                  >
                    <div className="framer-jk8g5w" data-framer-name="Link">
                      <div className="framer-80yh0c">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="ic:baseline-copyright"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-m3skko accounts-s26"
                          aria-hidden="true"
                        >
                          <div className="svgContainer accounts-s27">
                            <svg viewBox="0 0 20 20" className="accounts-s28">
                              <use href="#svg-1839680863_948" />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="framer-hv1cvb accounts-s109 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text accounts-s110">
                            2026 Scallop Group. All rights reserved.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c28m8b">
                      {/*$*/}
                      <a
                        data-framer-component-type="SVG"
                        as="a"
                        data-framer-name="X"
                        href="https://x.com/Scallopcom"
                        target="_blank"
                        rel="noopener"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-dziac9 framer-1d3y7cu accounts-s111"
                        aria-hidden="true"
                      />
                      {/*/$*/}
                      {/*$*/}
                      <a
                        className="framer-n9nhin framer-1d3y7cu"
                        data-framer-name="LinkdIn"
                        href="https://www.linkedin.com/company/scallopcom"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="linkd"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ggemab accounts-s112"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-1jxkmth-container">
            {/*$*/}
            {/*/$*/}
          </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>
  );
}

export default Accounts;
